import { defineComponent as i, computed as l, openBlock as a, createElementBlock as c, normalizeClass as d, normalizeStyle as p, unref as h, createElementVNode as n, createStaticVNode as u, h as f } from "vue";
const y = ["stroke-width"], w = /* @__PURE__ */ n("path", {
  d: "M576 336c0 26.496 21.504 48 48 48h272v528a48 48 0 0 1-48 48H176a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48h400z",
  fill: "#e7e7e7"
}, null, -1), g = /* @__PURE__ */ n("path", {
  d: "m640 64 256 256H688a48 48 0 0 1-48-48z",
  fill: "#ababab"
}, null, -1), v = /* @__PURE__ */ n("path", {
  d: "M676.736 511.68a48 48 0 0 1 72.576 62.528l-4.672 5.376-256 256a48 48 0 0 1-62.528 4.672l-5.376-4.672L287.872 702.72a48 48 0 0 1 62.528-72.576l5.376 4.672 98.88 98.944z",
  fill: "#979797"
}, null, -1), z = [
  w,
  g,
  v
], lu = /* @__PURE__ */ i({
  __name: "IconColourActiveNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, z, 14, y));
  }
}), $ = ["stroke-width"], m = /* @__PURE__ */ n("path", {
  d: "m256 134.336 218.624 145.728-53.248 79.872L304 281.728V896h-96V281.728L90.624 359.936l-53.248-79.872L256 134.336z",
  fill: "#1763FB"
}, null, -1), k = /* @__PURE__ */ n("path", {
  d: "m768 953.664 218.624-145.728-53.248-79.872L816 806.272V192h-96v614.272l-117.376-78.208-53.248 79.872L768 953.664z",
  fill: "#AEAFB2"
}, null, -1), S = [
  m,
  k
], au = /* @__PURE__ */ i({
  __name: "IconColourAscendActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, S, 14, $));
  }
}), x = ["stroke-width"], C = /* @__PURE__ */ n("path", {
  d: "M96 160h832a32 32 0 0 1 32 32v160H64V192a32 32 0 0 1 32-32zM64 416h896v416a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V416z",
  fill: "#ADCBFF"
}, null, -1), B = /* @__PURE__ */ n("path", {
  d: "M160 528h384a32 32 0 0 1 32 32v32a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32zm0 144h256a32 32 0 0 1 32 32v32a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32z",
  fill: "#005CFF"
}, null, -1), M = [
  C,
  B
], cu = /* @__PURE__ */ i({
  __name: "IconColourCardActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, M, 14, x));
  }
}), Z = ["stroke-width"], I = /* @__PURE__ */ n("path", {
  d: "M96 160h832a32 32 0 0 1 32 32v160H64V192a32 32 0 0 1 32-32zM64 416h896v416a32 32 0 0 1-32 32H96a32 32 0 0 1-32-32V416z",
  fill: "#E7E7E7"
}, null, -1), b = /* @__PURE__ */ n("path", {
  d: "M160 528h384a32 32 0 0 1 32 32v32a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32zm0 144h256a32 32 0 0 1 32 32v32a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32v-32a32 32 0 0 1 32-32z",
  fill: "#ABABAB"
}, null, -1), W = [
  I,
  b
], du = /* @__PURE__ */ i({
  __name: "IconColourCardNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, W, 14, Z));
  }
}), H = ["stroke-width"], V = /* @__PURE__ */ n("path", {
  d: "m536 77.888 339.968 196.224a48 48 0 0 1 24 41.6v392.576a48 48 0 0 1-24 41.6L536 946.112a48 48 0 0 1-48 0L148.032 749.888a48 48 0 0 1-24-41.6V315.712a48 48 0 0 1 24-41.6L488 77.888a48 48 0 0 1 48 0zM512 288a224 224 0 1 0 0 448 224 224 0 0 0 0-448z",
  fill: "#ADCBFF"
}, null, -1), A = /* @__PURE__ */ n("path", {
  d: "M384 512a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z",
  fill: "#005CFF"
}, null, -1), L = [
  V,
  A
], pu = /* @__PURE__ */ i({
  __name: "IconColourConfigActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, L, 14, H));
  }
}), N = ["stroke-width"], F = /* @__PURE__ */ n("path", {
  d: "m536 77.888 339.968 196.224a48 48 0 0 1 24 41.6v392.576a48 48 0 0 1-24 41.6L536 946.112a48 48 0 0 1-48 0L148.032 749.888a48 48 0 0 1-24-41.6V315.712a48 48 0 0 1 24-41.6L488 77.888a48 48 0 0 1 48 0zM512 288a224 224 0 1 0 0 448 224 224 0 0 0 0-448z",
  fill: "#D8D8D8"
}, null, -1), G = /* @__PURE__ */ n("path", {
  d: "M384 512a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z",
  fill: "#ABABAB"
}, null, -1), D = [
  F,
  G
], hu = /* @__PURE__ */ i({
  __name: "IconColourConfigNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, D, 14, N));
  }
}), E = ["stroke-width"], U = /* @__PURE__ */ u('<g fill="none" fill-rule="evenodd"><path d="M0 0h16v16H0z"></path><path d="M2 2h12v12H2z"></path><path stroke="#AEAFB2" stroke-width="1.5" d="M3 3h6v7H3z"></path><path d="M11 6h1.5a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V12" stroke="#AEAFB2" stroke-width="1.5"></path></g>', 1), O = [
  U
], uu = /* @__PURE__ */ i({
  __name: "IconColourCopy",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, O, 14, E));
  }
}), R = ["stroke-width"], j = /* @__PURE__ */ n("path", {
  d: "M768 889.664 549.376 743.936l53.248-79.872L720 742.272V128h96v614.272l117.376-78.208 53.248 79.872L768 889.664z",
  fill: "#1763FB"
}, null, -1), P = /* @__PURE__ */ n("path", {
  d: "M256 70.336 37.376 216.064l53.248 79.872L208 217.728V832h96V217.728l117.376 78.208 53.248-79.872L256 70.336z",
  fill: "#AEAFB2"
}, null, -1), T = [
  j,
  P
], fu = /* @__PURE__ */ i({
  __name: "IconColourDescendActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, T, 14, R));
  }
}), q = ["stroke-width"], K = /* @__PURE__ */ n("g", {
  fill: "none",
  "fill-rule": "evenodd"
}, [
  /* @__PURE__ */ n("path", { d: "M0 0h16v16H0z" }),
  /* @__PURE__ */ n("path", {
    d: "M5.4 12.2a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Zm5.6 0a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8ZM5.4 6.6a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8Zm5.6 0a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8ZM5.4 1a1.4 1.4 0 1 1 0 2.8 1.4 1.4 0 0 1 0-2.8ZM11 1a1.4 1.4 0 1 1 0 2.8A1.4 1.4 0 0 1 11 1Z",
    fill: "#999"
  })
], -1), Q = [
  K
], _u = /* @__PURE__ */ i({
  __name: "IconColourDrag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Q, 14, q));
  }
}), X = ["stroke-width"], Y = /* @__PURE__ */ n("path", {
  d: "M160 544h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zm416 0h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zM160 128h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32z",
  fill: "#ADCBFF"
}, null, -1), J = /* @__PURE__ */ n("path", {
  d: "M712.32 152.768a32 32 0 0 1 9.408 22.656v67.968H870.4c14.08 0 25.6 11.456 25.6 25.6v76.8a25.6 25.6 0 0 1-25.6 25.6H721.664l.064 56.768a32 32 0 0 1-54.592 22.656l-126.4-126.4a32 32 0 0 1 0-45.248l126.4-126.4a32 32 0 0 1 45.248 0z",
  fill: "#1763FB"
}, null, -1), tt = [
  Y,
  J
], yu = /* @__PURE__ */ i({
  __name: "IconColourEnterActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, tt, 14, X));
  }
}), et = ["stroke-width"], ot = /* @__PURE__ */ n("path", {
  d: "M160 544h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zm416 0h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zM160 128h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32z",
  fill: "#E7E7E7"
}, null, -1), rt = /* @__PURE__ */ n("path", {
  d: "M712.32 152.768a32 32 0 0 1 9.408 22.656v67.968H870.4c14.08 0 25.6 11.456 25.6 25.6v76.8a25.6 25.6 0 0 1-25.6 25.6H721.664l.064 56.768a32 32 0 0 1-54.592 22.656l-126.4-126.4a32 32 0 0 1 0-45.248l126.4-126.4a32 32 0 0 1 45.248 0z",
  fill: "#ABABAB"
}, null, -1), st = [
  ot,
  rt
], wu = /* @__PURE__ */ i({
  __name: "IconColourEnterNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, st, 14, et));
  }
}), nt = ["stroke-width"], it = /* @__PURE__ */ n("path", {
  d: "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0zm198.272 302.848a64 64 0 0 0-89.6 12.8l-103.936 110.08L412.8 315.648l-5.184-6.08a64 64 0 0 0-102.4 74.88l5.12 8 118.912 125.888L310.4 644.288l-5.12 8a64 64 0 0 0 107.52 68.736l103.936-110.08 103.936 110.08 5.184 6.144a64 64 0 0 0 102.4-74.88l-5.12-8L604.16 518.336l118.912-125.888 5.12-8a64 64 0 0 0-17.92-81.6z",
  fill: "#fe3333"
}, null, -1), lt = [
  it
], gu = /* @__PURE__ */ i({
  __name: "IconColourError",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, lt, 14, nt));
  }
}), at = ["stroke-width"], ct = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 3a1 1 0 0 1 1-1h4.52a1 1 0 0 1 .78.375l1.1 1.376c.065.08.122.164.172.249H13a2 2 0 0 1 2 2v6a2 2 0 0 1-2 2H3a2 2 0 0 1-2-2V3Z",
  fill: "#FD970D"
}, null, -1), dt = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1 4h13a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V4Z",
  fill: "#FFBF30"
}, null, -1), pt = [
  ct,
  dt
], vu = /* @__PURE__ */ i({
  __name: "IconColourFolder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, pt, 14, at));
  }
}), ht = ["stroke-width"], ut = /* @__PURE__ */ n("path", {
  d: "M8 15A7 7 0 1 1 8.001.999 7 7 0 0 1 8 15Zm.3-9.36a.54.54 0 0 0-.602 0l-1.85 1.344a.542.542 0 0 0-.186.572l.708 2.177a.541.541 0 0 0 .486.353h2.288a.54.54 0 0 0 .486-.353l.707-2.177a.54.54 0 0 0-.185-.572L8.3 5.64Zm4.458-1.713a6.28 6.28 0 0 0-2.383-1.724l.15.278a.362.362 0 0 1-.108.492L8.36 4.158a.878.878 0 0 1-.723 0L5.58 2.975a.362.362 0 0 1-.106-.492l.152-.28a6.295 6.295 0 0 0-2.429 1.775l.17-.031a.36.36 0 0 1 .434.255l.489 2.323a.873.873 0 0 1-.224.688l-1.76 1.589a.36.36 0 0 1-.502-.052l-.03-.031a6.225 6.225 0 0 0 1.005 2.747l.086-.56a.363.363 0 0 1 .382-.328l2.357.294a.872.872 0 0 1 .576.434l.93 2.182a.362.362 0 0 1-.211.457l-.334.153c.459.108.939.164 1.432.164.53 0 1.044-.065 1.535-.189l-.314-.143a.362.362 0 0 1-.211-.458l.93-2.181a.873.873 0 0 1 .576-.435l2.358-.293a.362.362 0 0 1 .383.328l.064.417c.51-.819.836-1.763.922-2.777l-.149.156a.363.363 0 0 1-.501.052L11.83 7.15a.878.878 0 0 1-.224-.688l.49-2.321a.36.36 0 0 1 .435-.255l.227.04Z",
  fill: "#D3D8E2"
}, null, -1), ft = /* @__PURE__ */ n("path", {
  d: "M7.698 5.639a.54.54 0 0 1 .602 0l1.852 1.345a.54.54 0 0 1 .186.572L9.63 9.733a.54.54 0 0 1-.486.353H6.856a.541.541 0 0 1-.486-.353l-.707-2.177a.542.542 0 0 1 .185-.572l1.85-1.345Z",
  fill: "#A6AAB7"
}, null, -1), _t = [
  ut,
  ft
], zu = /* @__PURE__ */ i({
  __name: "IconColourFootball_normal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, _t, 14, ht));
  }
}), yt = ["stroke-width"], wt = /* @__PURE__ */ n("path", {
  d: "M8 15A7 7 0 1 1 8.001.999 7 7 0 0 1 8 15Zm.3-9.36a.54.54 0 0 0-.602 0l-1.85 1.344a.542.542 0 0 0-.186.572l.708 2.177a.541.541 0 0 0 .486.353h2.288a.54.54 0 0 0 .486-.353l.707-2.177a.54.54 0 0 0-.185-.572L8.3 5.64Zm4.458-1.713a6.28 6.28 0 0 0-2.383-1.724l.15.278a.362.362 0 0 1-.108.492L8.36 4.158a.878.878 0 0 1-.723 0L5.58 2.975a.362.362 0 0 1-.106-.492l.152-.28a6.295 6.295 0 0 0-2.429 1.775l.17-.031a.36.36 0 0 1 .434.255l.489 2.323a.873.873 0 0 1-.224.688l-1.76 1.589a.36.36 0 0 1-.502-.052l-.03-.031a6.225 6.225 0 0 0 1.005 2.747l.086-.56a.363.363 0 0 1 .382-.328l2.357.294a.872.872 0 0 1 .576.434l.93 2.182a.362.362 0 0 1-.211.457l-.334.153c.459.108.939.164 1.432.164.53 0 1.044-.065 1.535-.189l-.314-.143a.362.362 0 0 1-.211-.458l.93-2.181a.873.873 0 0 1 .576-.435l2.358-.293a.362.362 0 0 1 .383.328l.064.417c.51-.819.836-1.763.922-2.777l-.149.156a.363.363 0 0 1-.501.052L11.83 7.15a.878.878 0 0 1-.224-.688l.49-2.321a.36.36 0 0 1 .435-.255l.227.04Z",
  fill: "#ABCDFF"
}, null, -1), gt = /* @__PURE__ */ n("path", {
  d: "M7.698 5.639a.54.54 0 0 1 .602 0l1.852 1.345a.54.54 0 0 1 .186.572L9.63 9.733a.54.54 0 0 1-.486.353H6.856a.541.541 0 0 1-.486-.353l-.707-2.177a.542.542 0 0 1 .185-.572l1.85-1.345Z",
  fill: "#326BFB"
}, null, -1), vt = [
  wt,
  gt
], $u = /* @__PURE__ */ i({
  __name: "IconColourFootballActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, vt, 14, yt));
  }
}), zt = ["stroke-width"], $t = /* @__PURE__ */ n("path", {
  d: "M8 15A7 7 0 1 1 8.001.999 7 7 0 0 1 8 15Zm.3-9.36a.54.54 0 0 0-.602 0l-1.85 1.344a.542.542 0 0 0-.186.572l.708 2.177a.541.541 0 0 0 .486.353h2.288a.54.54 0 0 0 .486-.353l.707-2.177a.54.54 0 0 0-.185-.572L8.3 5.64Zm4.458-1.713a6.28 6.28 0 0 0-2.383-1.724l.15.278a.362.362 0 0 1-.108.492L8.36 4.158a.878.878 0 0 1-.723 0L5.58 2.975a.362.362 0 0 1-.106-.492l.152-.28a6.295 6.295 0 0 0-2.429 1.775l.17-.031a.36.36 0 0 1 .434.255l.489 2.323a.873.873 0 0 1-.224.688l-1.76 1.589a.36.36 0 0 1-.502-.052l-.03-.031a6.225 6.225 0 0 0 1.005 2.747l.086-.56a.363.363 0 0 1 .382-.328l2.357.294a.872.872 0 0 1 .576.434l.93 2.182a.362.362 0 0 1-.211.457l-.334.153c.459.108.939.164 1.432.164.53 0 1.044-.065 1.535-.189l-.314-.143a.362.362 0 0 1-.211-.458l.93-2.181a.873.873 0 0 1 .576-.435l2.358-.293a.362.362 0 0 1 .383.328l.064.417c.51-.819.836-1.763.922-2.777l-.149.156a.363.363 0 0 1-.501.052L11.83 7.15a.878.878 0 0 1-.224-.688l.49-2.321a.36.36 0 0 1 .435-.255l.227.04Z",
  fill: "#D3D8E2"
}, null, -1), mt = /* @__PURE__ */ n("path", {
  d: "M7.698 5.639a.54.54 0 0 1 .602 0l1.852 1.345a.54.54 0 0 1 .186.572L9.63 9.733a.54.54 0 0 1-.486.353H6.856a.541.541 0 0 1-.486-.353l-.707-2.177a.542.542 0 0 1 .185-.572l1.85-1.345Z",
  fill: "#A6AAB7"
}, null, -1), kt = [
  $t,
  mt
], mu = /* @__PURE__ */ i({
  __name: "IconColourFootballNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, kt, 14, zt));
  }
}), St = ["stroke-width"], xt = /* @__PURE__ */ n("path", {
  d: "m313.856 260.352 427.712-.448c4.608 0 9.152-2.624 11.712-6.784a103.872 103.872 0 0 0-14.72-127.168 100.032 100.032 0 0 0-142.784 0L527.68 196.48l-68.48-70.016a100.032 100.032 0 0 0-142.784 0 103.872 103.872 0 0 0-14.272 127.104 14.08 14.08 0 0 0 11.712 6.784z",
  fill: "#ADCBFF"
}, null, -1), Ct = /* @__PURE__ */ n("path", {
  d: "M883.84 296.768H171.648c-41.6 0-75.648 33.152-75.648 74.24 0 40.96 33.536 73.664 75.648 73.664h712.704c41.6 0 75.648-33.152 75.648-74.24 0-40.96-34.048-73.664-76.16-73.664z",
  fill: "#005CFF"
}, null, -1), Bt = /* @__PURE__ */ n("path", {
  d: "M478.464 481.472H181.312V851.52c0 59.648 47.808 108.48 106.24 108.48H497.28V481.472h-18.816zm370.816 0H557.312V960h210.816c58.432 0 106.24-48.832 106.24-108.48V481.472h-24.96z",
  fill: "#ADCBFF"
}, null, -1), Mt = [
  xt,
  Ct,
  Bt
], ku = /* @__PURE__ */ i({
  __name: "IconColourGiftActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Mt, 14, St));
  }
}), Zt = ["stroke-width"], It = /* @__PURE__ */ n("path", {
  d: "m313.856 260.352 427.712-.448c4.608 0 9.152-2.624 11.712-6.784a103.872 103.872 0 0 0-14.72-127.168 100.032 100.032 0 0 0-142.784 0L527.68 196.48l-68.48-70.016a100.032 100.032 0 0 0-142.784 0 103.872 103.872 0 0 0-14.272 127.104 14.08 14.08 0 0 0 11.712 6.784z",
  fill: "#E7E7E7"
}, null, -1), bt = /* @__PURE__ */ n("path", {
  d: "M883.84 296.768H171.648c-41.6 0-75.648 33.152-75.648 74.24 0 40.96 33.536 73.664 75.648 73.664h712.704c41.6 0 75.648-33.152 75.648-74.24 0-40.96-34.048-73.664-76.16-73.664z",
  fill: "#ABABAB"
}, null, -1), Wt = /* @__PURE__ */ n("path", {
  d: "M478.464 481.472H181.312V851.52c0 59.648 47.808 108.48 106.24 108.48H497.28V481.472h-18.816zm370.816 0H557.312V960h210.816c58.432 0 106.24-48.832 106.24-108.48V481.472h-24.96z",
  fill: "#E7E7E7"
}, null, -1), Ht = [
  It,
  bt,
  Wt
], Su = /* @__PURE__ */ i({
  __name: "IconColourGiftNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ht, 14, Zt));
  }
}), Vt = ["stroke-width"], At = /* @__PURE__ */ n("path", {
  d: "M364.608 755.136a86.272 86.272 0 0 1 59.968 24.32c7.872 7.616 13.888 16.64 18.176 27.008 4.224 10.368 6.336 21.376 6.336 33.024 0 11.584-2.112 22.592-6.4 32.96-4.224 10.432-10.24 19.456-18.112 27.072-7.872 7.68-16.96 13.76-27.264 18.304-10.24 4.608-21.184 6.912-32.64 6.912-12.16 0-23.232-2.304-33.216-6.912a95.168 95.168 0 0 1-26.752-18.304 78.592 78.592 0 0 1-18.176-27.072 86.528 86.528 0 0 1-6.4-32.96c0-11.648 2.176-22.656 6.4-33.024 4.224-10.368 10.24-19.392 18.176-27.072a83.392 83.392 0 0 1 59.968-24.32zm377.792 1.856c11.52 0 22.592 2.112 33.216 6.4 10.56 4.288 19.648 10.24 27.2 17.92 7.616 7.616 13.632 16.64 18.176 27.008 4.544 10.368 6.848 21.376 6.848 33.024 0 11.584-2.304 22.592-6.848 32.96a85.824 85.824 0 0 1-78.592 52.224c-11.456 0-22.4-2.24-32.64-6.848a87.296 87.296 0 0 1-44.992-45.376 81.536 81.536 0 0 1-6.784-32.96c0-11.648 2.24-22.656 6.784-33.024 4.544-10.368 10.624-19.392 18.176-27.072a84.352 84.352 0 0 1 59.52-24.32z",
  fill: "#1763FB"
}, null, -1), Lt = /* @__PURE__ */ n("path", {
  d: "M895.04 231.872c16.96 0 30.08 2.304 39.488 6.976 9.408 4.608 16 10.304 19.968 17.088 3.968 6.784 5.76 14.016 5.44 21.76a73.6 73.6 0 0 1-3.2 19.84l-11.328 34.176a3417.906 3417.906 0 0 1-19.52 56.896 8923.9 8923.9 0 0 0-21.312 61.44C897.6 470.4 892.288 486.4 888.64 498.112c-7.808 24.704-17.856 41.792-29.952 51.328-12.096 9.6-26.88 14.336-44.48 14.336H337.28l13.632 83.2h457.792c29.056 0 43.52 12.608 43.52 37.888a57.6 57.6 0 0 1-8.576 31.872c-5.76 8.96-17.088 13.44-34.048 13.44H333.76a52.928 52.928 0 0 1-30.464-8.32 69.632 69.632 0 0 1-20.416-21.76 133.12 133.12 0 0 1-13.184-29.12 269.952 269.952 0 0 1-7.68-29.568 1379.2 1379.2 0 0 0-4.992-26.816A450590.336 450590.336 0 0 1 219.328 411.2a46011.463 46011.463 0 0 0-39.04-208h-68.224a36.352 36.352 0 0 1-22.72-6.912 59.968 59.968 0 0 1-14.976-16.64 64.704 64.704 0 0 1-8.192-20.8A102.08 102.08 0 0 1 64 138.496a40.96 40.96 0 0 1 12.288-30.464c8.128-8 19.2-12.032 33.152-12.032h91.712c12.16 0 21.76 1.856 29.056 5.568 7.232 3.648 12.992 8.32 17.28 13.824a53.952 53.952 0 0 1 9.088 17.6c1.792 6.144 3.328 11.392 4.48 15.68 1.28 4.928 2.432 11.904 3.648 20.8 1.28 8.96 2.432 18.048 3.648 27.264 1.792 11.136 3.648 22.848 5.44 35.2H895.04z",
  fill: "#ADCBFF"
}, null, -1), Nt = [
  At,
  Lt
], xu = /* @__PURE__ */ i({
  __name: "IconColourGoodsActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Nt, 14, Vt));
  }
}), Ft = ["stroke-width"], Gt = /* @__PURE__ */ n("path", {
  d: "M364.608 755.136a86.272 86.272 0 0 1 59.968 24.32c7.872 7.616 13.888 16.64 18.176 27.008 4.224 10.368 6.336 21.376 6.336 33.024 0 11.584-2.112 22.592-6.4 32.96-4.224 10.432-10.24 19.456-18.112 27.072-7.872 7.68-16.96 13.76-27.264 18.304-10.24 4.608-21.184 6.912-32.64 6.912-12.16 0-23.232-2.304-33.216-6.912a95.168 95.168 0 0 1-26.752-18.304 78.592 78.592 0 0 1-18.176-27.072 86.528 86.528 0 0 1-6.4-32.96c0-11.648 2.176-22.656 6.4-33.024 4.224-10.368 10.24-19.392 18.176-27.072a83.392 83.392 0 0 1 59.968-24.32zm377.792 1.856c11.52 0 22.592 2.112 33.216 6.4 10.56 4.288 19.648 10.24 27.2 17.92 7.616 7.616 13.632 16.64 18.176 27.008 4.544 10.368 6.848 21.376 6.848 33.024 0 11.584-2.304 22.592-6.848 32.96a85.824 85.824 0 0 1-78.592 52.224c-11.456 0-22.4-2.24-32.64-6.848a87.296 87.296 0 0 1-44.992-45.376 81.536 81.536 0 0 1-6.784-32.96c0-11.648 2.24-22.656 6.784-33.024 4.544-10.368 10.624-19.392 18.176-27.072a84.352 84.352 0 0 1 59.52-24.32z",
  fill: "#ABABAB"
}, null, -1), Dt = /* @__PURE__ */ n("path", {
  d: "M895.04 231.872c16.96 0 30.08 2.304 39.488 6.976 9.408 4.608 16 10.304 19.968 17.088 3.968 6.784 5.76 14.016 5.44 21.76a73.6 73.6 0 0 1-3.2 19.84l-11.328 34.176a3417.906 3417.906 0 0 1-19.52 56.896 8923.9 8923.9 0 0 0-21.312 61.44C897.6 470.4 892.288 486.4 888.64 498.112c-7.808 24.704-17.856 41.792-29.952 51.328-12.096 9.6-26.88 14.336-44.48 14.336H337.28l13.632 83.2h457.792c29.056 0 43.52 12.608 43.52 37.888a57.6 57.6 0 0 1-8.576 31.872c-5.76 8.96-17.088 13.44-34.048 13.44H333.76a52.928 52.928 0 0 1-30.464-8.32 69.632 69.632 0 0 1-20.416-21.76 133.12 133.12 0 0 1-13.184-29.12 269.952 269.952 0 0 1-7.68-29.568 1379.2 1379.2 0 0 0-4.992-26.816A450590.336 450590.336 0 0 1 219.328 411.2a46011.463 46011.463 0 0 0-39.04-208h-68.224a36.352 36.352 0 0 1-22.72-6.912 59.968 59.968 0 0 1-14.976-16.64 64.704 64.704 0 0 1-8.192-20.8A102.08 102.08 0 0 1 64 138.496a40.96 40.96 0 0 1 12.288-30.464c8.128-8 19.2-12.032 33.152-12.032h91.712c12.16 0 21.76 1.856 29.056 5.568 7.232 3.648 12.992 8.32 17.28 13.824a53.952 53.952 0 0 1 9.088 17.6c1.792 6.144 3.328 11.392 4.48 15.68 1.28 4.928 2.432 11.904 3.648 20.8 1.28 8.96 2.432 18.048 3.648 27.264 1.792 11.136 3.648 22.848 5.44 35.2H895.04z",
  fill: "#E7E7E7"
}, null, -1), Et = [
  Gt,
  Dt
], Cu = /* @__PURE__ */ i({
  __name: "IconColourGoodsNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Et, 14, Ft));
  }
}), Ut = ["stroke-width"], Ot = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.647 14.646a.5.5 0 0 0 .707 0l.353-.353 3.475-3.475a.5.5 0 0 0 0-.707l-.353-.354a.5.5 0 0 0-.707 0l-2.367 2.367V2.528a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v9.605L4.879 9.757a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707l3.475 3.475.354.354Z",
  fill: "#07D091"
}, null, -1), Rt = [
  Ot
], Bu = /* @__PURE__ */ i({
  __name: "IconColourIconDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Rt, 14, Ut));
  }
}), jt = ["stroke-width"], Pt = /* @__PURE__ */ n("rect", {
  x: "2",
  y: "7",
  width: "12",
  height: "2",
  rx: "1",
  fill: "#D8D8D8"
}, null, -1), Tt = [
  Pt
], Mu = /* @__PURE__ */ i({
  __name: "IconColourIconMinus",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Tt, 14, jt));
  }
}), qt = ["stroke-width"], Kt = /* @__PURE__ */ n("path", {
  "clip-rule": "evenodd",
  d: "M7.647 1.353a.5.5 0 0 1 .707 0l.353.354 3.475 3.475a.5.5 0 0 1 0 .707l-.353.354a.5.5 0 0 1-.707 0L8.755 3.876v9.597a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V3.867L4.879 6.243a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707l3.475-3.475z",
  fill: "#ff4940",
  "fill-rule": "evenodd"
}, null, -1), Qt = [
  Kt
], Zu = /* @__PURE__ */ i({
  __name: "IconColourIconUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      fill: "none",
      viewBox: "0 0 16 16",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Qt, 14, qt));
  }
}), Xt = ["stroke-width"], Yt = /* @__PURE__ */ n("path", {
  d: "M276.89 349.389a77.824 77.824 0 0 0 78.37-75.913c.614-41.301-35.499-77.824-77.005-77.687a78.097 78.097 0 0 0-76.595 76.185c-.273 41.507 34.474 77.142 75.23 77.415zM679.117 489.13v443.323c0 9.763 1.16 19.661-4.233 28.74-10.103 17.136-28.945 20.003-47.104 5.257a3642.436 3642.436 0 0 1-98.509-83.558c-53.589-47.377-53.248-47.446-124.245-47.787-47.582-.136-95.164 1.775-142.404-7.236C138.65 804.045 50.176 708.335 40.277 582.588a1978.231 1978.231 0 0 1 0-311.365C50.927 136.875 150.733 36.727 285.082 21.504c57.89-6.69 115.916-3.277 173.875-3.891 65.194-.546 130.457.341 195.72-.546 18.842-.273 24.713 6.144 24.645 24.78-.547 149.095-.273 298.19-.273 447.284h.136z",
  fill: "#016DF5"
}, null, -1), Jt = /* @__PURE__ */ n("path", {
  d: "M737.553 421.41V44.783c0-27.307 2.458-28.536 29.423-25.464 64.17 7.305 123.563 26.624 174.421 67.858 64.717 52.565 97.417 122.606 109.432 203.776 7.304 49.493 3.413 99.191 3.891 148.82.683 54.273.341 108.545 0 162.817 0 25.395-10.445 35.499-35.772 35.908-20.89.341-41.779 1.092-62.6-.205-10.65-.682-83.968-.682-219.955 0l1.16-216.883z",
  fill: "#FFC926"
}, null, -1), te = /* @__PURE__ */ n("path", {
  d: "M956.416 638.293c-15.155 3.414-24.235 10.24-27.238 20.48-22.05 74.07-69.291 126.02-140.63 155.512a305.835 305.835 0 0 1-35.294 11.059c-9.898 2.73-15.018-1.911-15.428-11.81a408.03 408.03 0 0 1-.341-19.593V638.293h218.863z",
  fill: "#F69B18"
}, null, -1), ee = [
  Yt,
  Jt,
  te
], Iu = /* @__PURE__ */ i({
  __name: "IconColourKim",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1092 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ee, 14, Xt));
  }
}), oe = ["stroke-width"], re = /* @__PURE__ */ n("path", {
  d: "M160 544h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zm416 0h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zM160 128h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32z",
  fill: "#ADCBFF"
}, null, -1), se = /* @__PURE__ */ n("path", {
  d: "m744.32 120.768 158.464 158.4a32 32 0 0 1 0 45.248l-158.464 158.4a32 32 0 0 1-45.248 0l-158.336-158.4a32 32 0 0 1 0-45.248l158.4-158.4a32 32 0 0 1 45.248 0z",
  fill: "#005CFF"
}, null, -1), ne = [
  re,
  se
], bu = /* @__PURE__ */ i({
  __name: "IconColourManageActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ne, 14, oe));
  }
}), ie = ["stroke-width"], le = /* @__PURE__ */ n("path", {
  d: "M160 544h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zm416 0h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zM160 128h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32z",
  fill: "#E7E7E7"
}, null, -1), ae = /* @__PURE__ */ n("path", {
  d: "m744.32 120.768 158.464 158.4a32 32 0 0 1 0 45.248l-158.464 158.4a32 32 0 0 1-45.248 0l-158.336-158.4a32 32 0 0 1 0-45.248l158.4-158.4a32 32 0 0 1 45.248 0z",
  fill: "#ABABAB"
}, null, -1), ce = [
  le,
  ae
], Wu = /* @__PURE__ */ i({
  __name: "IconColourManageNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ce, 14, ie));
  }
}), de = ["stroke-width"], pe = /* @__PURE__ */ n("path", {
  d: "M96 176v544c0 26.496 21.504 48 48 48h736a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48H144a48 48 0 0 0-48 48z",
  fill: "#ADCBFF"
}, null, -1), he = /* @__PURE__ */ n("path", {
  d: "M64 880c0 26.496 21.504 48 48 48h800a48 48 0 1 0 0-96H112a48 48 0 0 0-48 48zm420.672-572.288a48 48 0 0 1 74.88 32.832L560 347.2v116.352l132.672-91.84a48 48 0 0 1 62.336 6.592l4.48 5.568a48 48 0 0 1-6.656 62.336l-5.504 4.48-208 144a48 48 0 0 1-74.88-32.832L464 555.2V438.72l-132.672 91.904a48 48 0 0 1-62.336-6.592l-4.48-5.504a48 48 0 0 1 6.656-62.336l5.504-4.48 208-144z",
  fill: "#1763FB"
}, null, -1), ue = [
  pe,
  he
], Hu = /* @__PURE__ */ i({
  __name: "IconColourMonitorActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ue, 14, de));
  }
}), fe = ["stroke-width"], _e = /* @__PURE__ */ n("path", {
  d: "M96 176v544c0 26.496 21.504 48 48 48h736a48 48 0 0 0 48-48V176a48 48 0 0 0-48-48H144a48 48 0 0 0-48 48z",
  fill: "#E7E7E7"
}, null, -1), ye = /* @__PURE__ */ n("path", {
  d: "M64 880c0 26.496 21.504 48 48 48h800a48 48 0 1 0 0-96H112a48 48 0 0 0-48 48zm420.672-572.288a48 48 0 0 1 74.88 32.832L560 347.2v116.352l132.672-91.84a48 48 0 0 1 62.336 6.592l4.48 5.568a48 48 0 0 1-6.656 62.336l-5.504 4.48-208 144a48 48 0 0 1-74.88-32.832L464 555.2V438.72l-132.672 91.904a48 48 0 0 1-62.336-6.592l-4.48-5.504a48 48 0 0 1 6.656-62.336l5.504-4.48 208-144z",
  fill: "#979797"
}, null, -1), we = [
  _e,
  ye
], Vu = /* @__PURE__ */ i({
  __name: "IconColourMonitorNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, we, 14, fe));
  }
}), ge = ["stroke-width"], ve = /* @__PURE__ */ n("circle", {
  cx: "8",
  cy: "7.998",
  r: "6.5",
  transform: "rotate(-90 8 7.998)",
  fill: "#D2E6FF"
}, null, -1), ze = /* @__PURE__ */ n("path", {
  d: "M6.643 5.88a.5.5 0 0 1 0-.706l.353-.354a.5.5 0 0 1 .707 0l2.824 2.823a.5.5 0 0 1 0 .708l-2.824 2.823a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l2.115-2.116-2.115-2.116Z",
  fill: "#326BFB"
}, null, -1), $e = [
  ve,
  ze
], Au = /* @__PURE__ */ i({
  __name: "IconColourMoredetails",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, $e, 14, ge));
  }
}), me = ["stroke-width"], ke = /* @__PURE__ */ n("path", {
  d: "M524.8 50.752a448 448 0 0 1 131.328 19.584l-.064 444.544c0 24.064 19.008 43.584 42.432 43.584a43.072 43.072 0 0 0 42.432-43.584V106.24A448 448 0 1 1 524.8 50.752z",
  fill: "#ADCBFF"
}, null, -1), Se = /* @__PURE__ */ n("path", {
  d: "M396.8 498.752a128 128 0 1 0 256 0 128 128 0 0 0-256 0z",
  fill: "#005CFF"
}, null, -1), xe = /* @__PURE__ */ n("path", {
  d: "M656.064 70.336c29.76 9.088 58.176 21.12 84.928 35.904v408.64a43.072 43.072 0 0 1-42.496 43.584 43.072 43.072 0 0 1-42.432-43.584z",
  fill: "#FFF"
}, null, -1), Ce = /* @__PURE__ */ n("path", {
  d: "M515.008 730.88c-107.776 0-200.576-78.208-221.632-186.816-20.992-108.608 35.52-217.344 135.104-259.712 99.584-42.368 214.464-6.592 274.368 85.44a236.8 236.8 0 0 1-28.096 293.056 221.44 221.44 0 0 1-159.744 67.968zm0-355.2c-48.448 0-92.16 30.08-110.656 76.032a125.44 125.44 0 0 0 25.984 134.08c34.24 35.2 85.76 45.696 130.56 26.688a123.136 123.136 0 0 0 73.92-113.728c-.064-67.84-53.632-122.88-119.808-123.008z",
  fill: "#FDFDFF"
}, null, -1), Be = [
  ke,
  Se,
  xe,
  Ce
], Lu = /* @__PURE__ */ i({
  __name: "IconColourMusicActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Be, 14, me));
  }
}), Me = ["stroke-width"], Ze = /* @__PURE__ */ n("path", {
  d: "M656.064 70.336c29.76 9.088 58.176 21.12 84.928 35.904v408.64a43.072 43.072 0 0 1-42.496 43.584 43.072 43.072 0 0 1-42.432-43.584z",
  fill: "#FFF"
}, null, -1), Ie = /* @__PURE__ */ n("path", {
  d: "M524.8 50.752a448 448 0 0 1 131.328 19.584l-.064 444.544c0 24.064 19.008 43.584 42.432 43.584a43.072 43.072 0 0 0 42.432-43.584V106.24A448 448 0 1 1 524.8 50.752z",
  fill: "#D8D8D8"
}, null, -1), be = /* @__PURE__ */ n("path", {
  d: "M396.8 498.752a128 128 0 1 0 256 0 128 128 0 0 0-256 0z",
  fill: "#979797"
}, null, -1), We = /* @__PURE__ */ n("path", {
  d: "M515.008 730.88c-107.776 0-200.576-78.208-221.632-186.816-20.992-108.608 35.52-217.344 135.104-259.712 99.584-42.368 214.464-6.592 274.368 85.44a236.8 236.8 0 0 1-28.096 293.056 221.44 221.44 0 0 1-159.744 67.968zm0-355.2c-48.448 0-92.16 30.08-110.656 76.032a125.44 125.44 0 0 0 25.984 134.08c34.24 35.2 85.76 45.696 130.56 26.688a123.136 123.136 0 0 0 73.92-113.728c-.064-67.84-53.632-122.88-119.808-123.008z",
  fill: "#FDFDFF"
}, null, -1), He = [
  Ze,
  Ie,
  be,
  We
], Nu = /* @__PURE__ */ i({
  __name: "IconColourMusicNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, He, 14, Me));
  }
}), Ve = ["stroke-width"], Ae = /* @__PURE__ */ n("path", { d: "m256 134.336 218.624 145.728-53.248 79.872L304 281.728V896h-96V281.728L90.624 359.936l-53.248-79.872L256 134.336zm512 819.328 218.624-145.728-53.248-79.872L816 806.272V192h-96v614.272l-117.376-78.208-53.248 79.872L768 953.664z" }, null, -1), Le = [
  Ae
], Fu = /* @__PURE__ */ i({
  __name: "IconColourOrderNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Le, 14, Ve));
  }
}), Ne = ["stroke-width"], Fe = /* @__PURE__ */ n("path", {
  d: "M576 336c0 26.496 21.504 48 48 48h272v528a48 48 0 0 1-48 48H176a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48h400z",
  fill: "#ADCBFF"
}, null, -1), Ge = /* @__PURE__ */ n("path", {
  d: "m640 64 256 256H688a48 48 0 0 1-48-48V64zM288 768h384a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32zm0-160h224a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32z",
  fill: "#005CFF"
}, null, -1), De = [
  Fe,
  Ge
], Gu = /* @__PURE__ */ i({
  __name: "IconColourPageActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, De, 14, Ne));
  }
}), Ee = ["stroke-width"], Ue = /* @__PURE__ */ n("path", {
  d: "M576 336c0 26.496 21.504 48 48 48h272v528a48 48 0 0 1-48 48H176a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48h400z",
  fill: "#E7E7E7"
}, null, -1), Oe = /* @__PURE__ */ n("path", {
  d: "m640 64 256 256H688a48 48 0 0 1-48-48V64zM288 768h384a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32zm0-160h224a32 32 0 0 0 32-32v-32a32 32 0 0 0-32-32H288a32 32 0 0 0-32 32v32a32 32 0 0 0 32 32z",
  fill: "#ABABAB"
}, null, -1), Re = [
  Ue,
  Oe
], Du = /* @__PURE__ */ i({
  __name: "IconColourPageNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Re, 14, Ee));
  }
}), je = ["stroke-width"], Pe = /* @__PURE__ */ n("path", {
  d: "M448 161.28V512a64 64 0 0 0 64 64h350.72A384 384 0 1 1 448 161.28z",
  fill: "#ADCBFF"
}, null, -1), Te = /* @__PURE__ */ n("path", {
  d: "M512 128a384 384 0 0 1 384 384H576a64 64 0 0 1-64-64z",
  fill: "#1763FB"
}, null, -1), qe = [
  Pe,
  Te
], Eu = /* @__PURE__ */ i({
  __name: "IconColourPieActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, qe, 14, je));
  }
}), Ke = ["stroke-width"], Qe = /* @__PURE__ */ n("path", {
  d: "M448 161.28V512a64 64 0 0 0 64 64h350.72A384 384 0 1 1 448 161.28z",
  fill: "#D8D8D8"
}, null, -1), Xe = /* @__PURE__ */ n("path", {
  d: "M512 128a384 384 0 0 1 384 384H576a64 64 0 0 1-64-64z",
  fill: "#979797"
}, null, -1), Ye = [
  Qe,
  Xe
], Uu = /* @__PURE__ */ i({
  __name: "IconColourPieNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ye, 14, Ke));
  }
}), Je = ["stroke-width"], to = /* @__PURE__ */ n("path", {
  d: "m354.368 126.592 520.768 331.392a64 64 0 0 1 0 108.032L354.368 897.408A64 64 0 0 1 256 843.392V180.608a64 64 0 0 1 98.368-54.016z",
  fill: "#fff"
}, null, -1), eo = [
  to
], Ou = /* @__PURE__ */ i({
  __name: "IconColourPlay",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, eo, 14, Je));
  }
}), oo = ["stroke-width"], ro = /* @__PURE__ */ n("path", {
  d: "M160 544h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zm416 0h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zM160 128h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32z",
  fill: "#ADCBFF"
}, null, -1), so = /* @__PURE__ */ n("path", {
  d: "M715.008 152.768a32 32 0 0 0-9.408 22.656l.064 67.968H556.928a25.6 25.6 0 0 0-25.6 25.6v76.8c0 14.08 11.52 25.6 25.6 25.6h148.736v56.768a32 32 0 0 0 54.592 22.656l126.4-126.4a32 32 0 0 0 0-45.248l-126.4-126.4a32 32 0 0 0-45.248 0z",
  fill: "#1763FB"
}, null, -1), no = [
  ro,
  so
], Ru = /* @__PURE__ */ i({
  __name: "IconColourQuitActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, no, 14, oo));
  }
}), io = ["stroke-width"], lo = /* @__PURE__ */ n("path", {
  d: "M160 544h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zm416 0h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V576a32 32 0 0 1 32-32zM160 128h288a32 32 0 0 1 32 32v288a32 32 0 0 1-32 32H160a32 32 0 0 1-32-32V160a32 32 0 0 1 32-32z",
  fill: "#E7E7E7"
}, null, -1), ao = /* @__PURE__ */ n("path", {
  d: "M715.008 152.768a32 32 0 0 0-9.408 22.656l.064 67.968H556.928a25.6 25.6 0 0 0-25.6 25.6v76.8c0 14.08 11.52 25.6 25.6 25.6h148.736v56.768a32 32 0 0 0 54.592 22.656l126.4-126.4a32 32 0 0 0 0-45.248l-126.4-126.4a32 32 0 0 0-45.248 0z",
  fill: "#ABABAB"
}, null, -1), co = [
  lo,
  ao
], ju = /* @__PURE__ */ i({
  __name: "IconColourQuitNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, co, 14, io));
  }
}), po = ["stroke-width"], ho = /* @__PURE__ */ n("path", {
  d: "M576 336c0 26.496 21.504 48 48 48h272v528a48 48 0 0 1-48 48H176a48 48 0 0 1-48-48V112a48 48 0 0 1 48-48h400z",
  fill: "#ADCBFF"
}, null, -1), uo = /* @__PURE__ */ n("path", {
  d: "m640 64 256 256H688a48 48 0 0 1-48-48V64zM676.736 511.68a48 48 0 0 1 72.576 62.528l-4.672 5.376-256 256a48 48 0 0 1-62.528 4.672l-5.376-4.672L287.872 702.72a48 48 0 0 1 62.528-72.576l5.376 4.672 98.88 98.944 222.08-222.08z",
  fill: "#1763FB"
}, null, -1), fo = [
  ho,
  uo
], Pu = /* @__PURE__ */ i({
  __name: "IconColourReviewActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, fo, 14, po));
  }
}), _o = ["stroke-width"], yo = /* @__PURE__ */ n("path", {
  d: "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0zm46.272 726.72.64-.832 1.28-1.152 1.408-1.6 1.6-2.112 246.272-328.576 5.12-8a64 64 0 0 0-107.52-68.8L502.08 589.056 370.432 474.368l-7.616-5.696a64 64 0 0 0-76.48 102.208l183.616 160 1.664 1.28 1.984 1.728 1.92 1.408 1.984 1.28a52.672 52.672 0 0 0 9.088 4.864l1.792.768a64.064 64.064 0 0 0 12.416 3.52l2.56.384a65.728 65.728 0 0 0 7.68.576h2.048l2.112-.128 4.672-.384a59.904 59.904 0 0 0 10.88-2.304l2.496-.832a61.44 61.44 0 0 0 19.968-11.392l3.584-3.328 1.216-1.152.32-.512-.448.512.384-.448z",
  fill: "#1EC75F"
}, null, -1), wo = [
  yo
], Tu = /* @__PURE__ */ i({
  __name: "IconColourSuccess",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, wo, 14, _o));
  }
}), go = ["stroke-width"], vo = /* @__PURE__ */ n("path", {
  d: "M512 960a448 448 0 1 1 93.44-886.272l-46.72 219.136A224 224 0 1 0 736 512h224a448 448 0 0 1-448 448z",
  fill: "#ADCBFF"
}, null, -1), zo = /* @__PURE__ */ n("path", {
  d: "M384 512a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z",
  fill: "#005CFF"
}, null, -1), $o = /* @__PURE__ */ n("path", {
  d: "M844.8 238.592 856.192 64l-61.056 49.344-111.872 97.92-36.928 152.704-111.744 94.912L587.52 512 696 413.248l141.12 3.84L970.688 291.84l45.76-41.792z",
  fill: "#005CFF"
}, null, -1), mo = [
  vo,
  zo,
  $o
], qu = /* @__PURE__ */ i({
  __name: "IconColourTargetActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, mo, 14, go));
  }
}), ko = ["stroke-width"], So = /* @__PURE__ */ n("path", {
  d: "M512 960a448 448 0 1 1 93.44-886.272l-46.72 219.136A224 224 0 1 0 736 512h224a448 448 0 0 1-448 448z",
  fill: "#E7E7E7"
}, null, -1), xo = /* @__PURE__ */ n("path", {
  d: "M384 512a128 128 0 1 0 256 0 128 128 0 1 0-256 0Z",
  fill: "#ABABAB"
}, null, -1), Co = /* @__PURE__ */ n("path", {
  d: "M844.8 238.592 856.192 64l-61.056 49.344-111.872 97.92-36.928 152.704-111.744 94.912L587.52 512 696 413.248l141.12 3.84L970.688 291.84l45.76-41.792z",
  fill: "#ABABAB"
}, null, -1), Bo = [
  So,
  xo,
  Co
], Ku = /* @__PURE__ */ i({
  __name: "IconColourTargetNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Bo, 14, ko));
  }
}), Mo = ["stroke-width"], Zo = /* @__PURE__ */ n("path", {
  d: "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0z",
  fill: "#FFA600"
}, null, -1), Io = /* @__PURE__ */ n("path", {
  d: "M512 179.2a72.384 72.384 0 0 1 72.32 76.672L566.208 563.2a54.272 54.272 0 0 1-108.416 0L439.68 255.872A72.384 72.384 0 0 1 512 179.2zm0 665.6a76.8 76.8 0 1 0 0-153.6 76.8 76.8 0 0 0 0 153.6z",
  fill: "#FFF"
}, null, -1), bo = [
  Zo,
  Io
], Qu = /* @__PURE__ */ i({
  __name: "IconColourTishi",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, bo, 14, Mo));
  }
}), Wo = ["stroke-width"], Ho = /* @__PURE__ */ n("path", {
  d: "M152 128h272q56 0 56 56v144q0 56-56 56H152q-56 0-56-56V184q0-56 56-56ZM576 640h320a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V672a32 32 0 0 1 32-32z",
  fill: "#005CFF"
}, null, -1), Vo = /* @__PURE__ */ n("path", {
  d: "M600 128h272q56 0 56 56v336q0 56-56 56H600q-56 0-56-56V184q0-56 56-56ZM152 448h272q56 0 56 56v336q0 56-56 56H152q-56 0-56-56V504q0-56 56-56Z",
  fill: "#ADCBFF"
}, null, -1), Ao = [
  Ho,
  Vo
], Xu = /* @__PURE__ */ i({
  __name: "IconColourToolsActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ao, 14, Wo));
  }
}), Lo = ["stroke-width"], No = /* @__PURE__ */ n("path", {
  d: "M152 128h272q56 0 56 56v144q0 56-56 56H152q-56 0-56-56V184q0-56 56-56ZM576 640h320a32 32 0 0 1 32 32v192a32 32 0 0 1-32 32H576a32 32 0 0 1-32-32V672a32 32 0 0 1 32-32z",
  fill: "#ABABAB"
}, null, -1), Fo = /* @__PURE__ */ n("path", {
  d: "M600 128h272q56 0 56 56v336q0 56-56 56H600q-56 0-56-56V184q0-56 56-56ZM152 448h272q56 0 56 56v336q0 56-56 56H152q-56 0-56-56V504q0-56 56-56Z",
  fill: "#E7E7E7"
}, null, -1), Go = [
  No,
  Fo
], Yu = /* @__PURE__ */ i({
  __name: "IconColourToolsNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Go, 14, Lo));
  }
}), Do = ["stroke-width"], Eo = /* @__PURE__ */ n("path", {
  d: "M320 320a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z",
  fill: "#ADCBFF"
}, null, -1), Uo = /* @__PURE__ */ n("path", {
  d: "M329.024 608h365.952a203.008 203.008 0 0 1 198.4 160l17.792 82.432A64 64 0 0 1 848.64 928H175.36a64 64 0 0 1-62.528-77.568L130.688 768a203.008 203.008 0 0 1 198.4-160z",
  fill: "#005CFF"
}, null, -1), Oo = [
  Eo,
  Uo
], Ju = /* @__PURE__ */ i({
  __name: "IconColourUserActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Oo, 14, Do));
  }
}), Ro = ["stroke-width"], jo = /* @__PURE__ */ n("path", {
  d: "M320 320a192 192 0 1 0 384 0 192 192 0 1 0-384 0Z",
  fill: "#D8D8D8"
}, null, -1), Po = /* @__PURE__ */ n("path", {
  d: "M329.024 608h365.952a203.008 203.008 0 0 1 198.4 160l17.792 82.432A64 64 0 0 1 848.64 928H175.36a64 64 0 0 1-62.528-77.568L130.688 768a203.008 203.008 0 0 1 198.4-160z",
  fill: "#979797"
}, null, -1), To = [
  jo,
  Po
], t6 = /* @__PURE__ */ i({
  __name: "IconColourUserNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, To, 14, Ro));
  }
}), qo = ["stroke-width"], Ko = /* @__PURE__ */ n("path", {
  d: "M0 512a512 512 0 1 0 1024 0A512 512 0 1 0 0 512Z",
  fill: "#F80"
}, null, -1), Qo = /* @__PURE__ */ n("path", {
  d: "M745.344 271.104a50.24 50.24 0 0 1 71.808 0 52.032 52.032 0 0 1 4.928 67.008l-4.928 5.76-356.48 409.024a50.304 50.304 0 0 1-77.504-7.04l-3.712-6.336-182.08-217.216a51.84 51.84 0 0 1 22.656-69.056 50.304 50.304 0 0 1 64.64 16.96l143.68 168.896 316.992-368z",
  fill: "#FFF"
}, null, -1), Xo = [
  Ko,
  Qo
], e6 = /* @__PURE__ */ i({
  __name: "IconColourUserVerify",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Xo, 14, qo));
  }
}), Yo = ["stroke-width"], Jo = /* @__PURE__ */ n("path", {
  d: "M704 384v256l212.736 79.808A32 32 0 0 0 960 689.792V334.208a32 32 0 0 0-43.264-30.016L704 384z",
  fill: "#005CFF"
}, null, -1), tr = /* @__PURE__ */ n("path", {
  d: "M64 208v608c0 26.496 21.504 48 48 48h608a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48H112a48 48 0 0 0-48 48z",
  fill: "#ADCBFF"
}, null, -1), er = /* @__PURE__ */ n("path", {
  d: "M320 409.728v204.544a32 32 0 0 0 48.96 27.136l163.648-102.272a32 32 0 0 0 0-54.272L368.96 382.592A32 32 0 0 0 320 409.728z",
  fill: "#005CFF"
}, null, -1), or = [
  Jo,
  tr,
  er
], o6 = /* @__PURE__ */ i({
  __name: "IconColourVideoActive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, or, 14, Yo));
  }
}), rr = ["stroke-width"], sr = /* @__PURE__ */ n("path", {
  d: "M704 384v256l212.736 79.808A32 32 0 0 0 960 689.792V334.208a32 32 0 0 0-43.264-30.016L704 384z",
  fill: "#979797"
}, null, -1), nr = /* @__PURE__ */ n("path", {
  d: "M64 208v608c0 26.496 21.504 48 48 48h608a48 48 0 0 0 48-48V208a48 48 0 0 0-48-48H112a48 48 0 0 0-48 48z",
  fill: "#E7E7E7"
}, null, -1), ir = /* @__PURE__ */ n("path", {
  d: "M320 409.728v204.544a32 32 0 0 0 48.96 27.136l163.648-102.272a32 32 0 0 0 0-54.272L368.96 382.592A32 32 0 0 0 320 409.728z",
  fill: "#979797"
}, null, -1), lr = [
  sr,
  nr,
  ir
], r6 = /* @__PURE__ */ i({
  __name: "IconColourVideoNormal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, lr, 14, rr));
  }
}), ar = ["stroke-width"], cr = /* @__PURE__ */ n("path", {
  d: "M98.462 0a59.077 59.077 0 0 0-59.077 59.077v669.538c0 32.61 26.466 59.077 59.077 59.077h905.846a59.077 59.077 0 0 0 59.077-59.077V59.077A59.077 59.077 0 0 0 1004.308 0z",
  fill: "#e7e7e7"
}, null, -1), dr = /* @__PURE__ */ n("path", {
  d: "M521.452 170.93a31.508 31.508 0 0 1 59.865 0l33.713 103.817a31.508 31.508 0 0 0 29.932 21.74h109.096a31.508 31.508 0 0 1 18.51 57.03l-88.22 64.039a31.508 31.508 0 0 0-11.422 35.288l33.713 103.66a31.508 31.508 0 0 1-48.522 35.21l-88.222-63.96a31.508 31.508 0 0 0-37.021 0l-88.222 64.04a31.508 31.508 0 0 1-48.522-35.21l33.714-103.66a31.508 31.508 0 0 0-11.422-35.29l-88.221-64.039a31.508 31.508 0 0 1 18.51-57.029H457.65a31.508 31.508 0 0 0 29.933-21.74zM59.077 866.461a59.077 59.077 0 0 0 0 118.153h984.615a59.077 59.077 0 0 0 0-118.153z",
  fill: "#979797"
}, null, -1), pr = [
  cr,
  dr
], s6 = /* @__PURE__ */ i({
  __name: "IconColourXingGray",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1102 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, pr, 14, ar));
  }
}), hr = ["stroke-width"], ur = /* @__PURE__ */ n("path", {
  d: "M98.462 0a59.077 59.077 0 0 0-59.077 59.077v669.538c0 32.61 26.466 59.077 59.077 59.077h905.846a59.077 59.077 0 0 0 59.077-59.077V59.077A59.077 59.077 0 0 0 1004.308 0z",
  fill: "#adcbff"
}, null, -1), fr = /* @__PURE__ */ n("path", {
  d: "M521.452 170.93a31.508 31.508 0 0 1 59.865 0l33.713 103.817a31.508 31.508 0 0 0 29.932 21.74h109.096a31.508 31.508 0 0 1 18.51 57.03l-88.22 64.039a31.508 31.508 0 0 0-11.422 35.288l33.713 103.66a31.508 31.508 0 0 1-48.522 35.21l-88.222-63.96a31.508 31.508 0 0 0-37.021 0l-88.222 64.04a31.508 31.508 0 0 1-48.522-35.21l33.714-103.66a31.508 31.508 0 0 0-11.422-35.29l-88.221-64.039a31.508 31.508 0 0 1 18.51-57.029H457.65a31.508 31.508 0 0 0 29.933-21.74z",
  fill: "#005cff"
}, null, -1), _r = /* @__PURE__ */ n("path", {
  d: "M59.077 866.462a59.077 59.077 0 0 0 0 118.153h984.615a59.077 59.077 0 0 0 0-118.153z",
  fill: "#1763fb"
}, null, -1), yr = [
  ur,
  fr,
  _r
], n6 = /* @__PURE__ */ i({
  __name: "IconColourXing",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1102 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, yr, 14, hr));
  }
}), wr = ["stroke-width"], gr = /* @__PURE__ */ u('<g filter="url(#a)" fill-rule="evenodd" clip-rule="evenodd"><path d="M10 18.45v.53h9v-10h-9v9.471Z" fill="currentColor"></path><path d="m5.225 14.271 2.255 5.341 3.604-1.535-2.1-5.07h4.607L2 1.387v16.016l3.225-3.132Z" fill="currentColor"></path><path d="M18 9.981v8h-7v-8h7Zm-1 6h-5v1h5v-1Zm0-2h-5v1h5v-1Zm0-2h-5v1h5v-1Z" fill="currentColor"></path><path d="m5.537 12.534 2.37 5.636 1.844-.774-2.28-5.418h3.694L3 3.795v11.188l2.537-2.45Z" fill="currentColor"></path></g><defs><filter id="a" x=".2" y=".588" width="20.6" height="21.824" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31705"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31705" result="shape"></feBlend></filter></defs>', 2), vr = [
  gr
], i6 = /* @__PURE__ */ i({
  __name: "IconCursorArrowMenu",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 21 23",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, vr, 14, wr));
  }
}), zr = ["stroke-width"], $r = /* @__PURE__ */ n("path", {
  d: "m8.031.55-.062.999a4.872 4.872 0 0 0-1.14.061 3.6 3.6 0 0 0-.897.472 3.39 3.39 0 0 0-.958 1.325l.016-.037v5.12h1v.98h-1v4.15a3.4 3.4 0 0 0 .76 1.116l.167.152c.281.208.592.373.855.472a4.65 4.65 0 0 0 1.2.09l.055 1c-.489.026-.98-.01-1.525-.13a4.585 4.585 0 0 1-1.203-.646 4.392 4.392 0 0 1-.804-.884c-.216.332-.48.643-.792.928a3.89 3.89 0 0 1-1.255.632 5.66 5.66 0 0 1-1.48.099l.064-.998c.409.026.818 0 1.17-.069.323-.1.626-.255.86-.43a3.76 3.76 0 0 0 .944-1.368L4 13.597V9.47H3v-.98h1V3.401a3.785 3.785 0 0 0-.744-1.166l-.159-.157a2.903 2.903 0 0 0-.845-.448 4.68 4.68 0 0 0-1.22-.081L.968.55c.495-.032.993.001 1.53.111a3.91 3.91 0 0 1 1.24.65c.289.265.542.564.756.889.224-.331.499-.634.82-.904A4.58 4.58 0 0 1 6.561.65a5.69 5.69 0 0 1 1.47-.1Z",
  fill: "currentColor"
}, null, -1), mr = [
  $r
], l6 = /* @__PURE__ */ i({
  __name: "IconCursorBeamHorizontal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 9 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, mr, 14, zr));
  }
}), kr = ["stroke-width"], Sr = /* @__PURE__ */ n("path", {
  d: "m.55 1 .999.063c-.026.405.002.812.061 1.14.119.329.284.64.472.896a3.39 3.39 0 0 0 1.324.959L3.37 4.04h5.12v-1h.98v1l4.15.001c.425-.179.808-.442 1.116-.76l.152-.168a3.67 3.67 0 0 0 .472-.854 4.65 4.65 0 0 0 .09-1.201l.999-.055c.027.489-.01.98-.129 1.525-.15.422-.362.82-.647 1.203a4.39 4.39 0 0 1-.883.804c.332.216.642.48.927.792.276.363.486.77.633 1.255.098.487.13.985.099 1.48L15.45 8c.026-.408-.001-.818-.07-1.17a2.873 2.873 0 0 0-.43-.86 3.76 3.76 0 0 0-1.367-.944l.013.006H9.47v1h-.98v-1H3.401c-.44.179-.843.439-1.166.745l-.157.158c-.205.27-.36.572-.448.845A4.68 4.68 0 0 0 1.549 8l-.998.064a5.678 5.678 0 0 1 .11-1.53 3.91 3.91 0 0 1 .65-1.24 4.75 4.75 0 0 1 .89-.756 4.428 4.428 0 0 1-.904-.819A4.58 4.58 0 0 1 .65 2.469 5.69 5.69 0 0 1 .551 1Z",
  fill: "currentColor"
}, null, -1), xr = [
  Sr
], a6 = /* @__PURE__ */ i({
  __name: "IconCursorBeamVertical",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 9",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, xr, 14, kr));
  }
}), Cr = ["stroke-width"], Br = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M11.5 1.5v5h5v4h-5v5h-4v-5h-5v-4h5v-5h4Z" fill="currentColor"></path><path d="M10.5 2.5v4.999l5 .001v2l-5-.001V14.5h-2V9.499l-5 .001v-2l5-.001V2.5h2Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".7" width="17.6" height="17.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31937"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31937" result="shape"></feBlend></filter></defs>', 2), Mr = [
  Br
], c6 = /* @__PURE__ */ i({
  __name: "IconCursorCell",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 19 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Mr, 14, Cr));
  }
}), Zr = ["stroke-width"], Ir = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M21 24.25a9 9 0 1 0-18 0 9 9 0 0 0 18 0Z" fill="url(#b)"></path><path opacity=".6" d="m13.41 24.28 2.12-2.12a1 1 0 0 0-1.41-1.42L12 22.87l-2.12-2.12a1 1 0 1 0-1.41 1.42l2.12 2.11-2.12 2.12a1 1 0 0 0 1.41 1.41L12 25.69l2.12 2.12a1 1 0 0 0 1.41-1.41l-2.12-2.12Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2 17.75v-16l11.6 11.608H6.554l-.152.124L2 17.75Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.05v11.2l2.969-2.87.16-.138 5.036.008L3 4.05Z" fill="currentColor"></path></g><defs><linearGradient id="b" x1="12" y1="15.25" x2="12" y2="33.25" gradientUnits="userSpaceOnUse"><stop stop-color="#F1F1F1"></stop><stop offset="1" stop-color="#D6D6D6"></stop></linearGradient><filter id="a" x=".2" y=".95" width="22.6" height="35.1" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132546_33076"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132546_33076" result="shape"></feBlend></filter></defs>', 2), br = [
  Ir
], d6 = /* @__PURE__ */ i({
  __name: "IconCursorClose",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 23 37",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, br, 14, Zr));
  }
}), Wr = ["stroke-width"], Hr = /* @__PURE__ */ u('<g filter="url(#a)" fill-rule="evenodd" clip-rule="evenodd"><path d="M3 24.25a9 9 0 1 0 18.001-.001A9 9 0 0 0 3 24.25Z" fill="url(#b)"></path><path d="M13 23.25v-3a1 1 0 0 0-2 0v3H8a1 1 0 0 0 0 2h3v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2h-3ZM2 17.75v-16l11.6 11.608H6.554l-.152.124L2 17.75Z" fill="currentColor"></path><path d="M3 4.05v11.2l2.969-2.87.16-.138 5.036.008L3 4.05Z" fill="currentColor"></path></g><defs><linearGradient id="b" x1="12" y1="15.25" x2="12" y2="33.25" gradientUnits="userSpaceOnUse"><stop stop-color="#5CD331"></stop><stop offset="1" stop-color="#078C04"></stop></linearGradient><filter id="a" x=".2" y=".95" width="22.6" height="35.1" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31729"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31729" result="shape"></feBlend></filter></defs>', 2), Vr = [
  Hr
], p6 = /* @__PURE__ */ i({
  __name: "IconCursorCopy",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 23 37",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Vr, 14, Wr));
  }
}), Ar = ["stroke-width"], Lr = /* @__PURE__ */ n("path", {
  d: "M8.99 6V0H6.01v6H0v3h6.01v6h2.98V9H15V6H8.99Z",
  fill: "currentColor"
}, null, -1), Nr = /* @__PURE__ */ n("path", {
  d: "M8 7V1H7v6H1v1h6v6h1V8h6V7H8Z",
  fill: "currentColor"
}, null, -1), Fr = [
  Lr,
  Nr
], h6 = /* @__PURE__ */ i({
  __name: "IconCursorCross",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Fr, 14, Ar));
  }
}), Gr = ["stroke-width"], Dr = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M11.716 16.74c.175.421.007 2.016-.923 2.385-.93.37-2.118 0-2.118 0l-2.156-4.312-3.726 3.726V1.711l11.414 11.414H9.954c.21.4 1.54 3.08 1.762 3.616Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.793 4.125v12l3-3 2.5 5s.676.216 1 0c.324-.216.646-.65.5-1-.688-1.65-2.5-5-2.5-5h3.5l-8-8Z" fill="currentColor"></path></g><defs><filter id="a" x=".993" y=".911" width="15.014" height="21.179" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31698"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31698" result="shape"></feBlend></filter></defs>', 2), Er = [
  Dr
], u6 = /* @__PURE__ */ i({
  __name: "IconCursorDefault",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 23",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Er, 14, Gr));
  }
}), Ur = ["stroke-width"], Or = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M12.75 14.5a9.5 9.5 0 1 0 9.5 9.5 9.51 9.51 0 0 0-9.5-9.5Zm-3.39 4a6.42 6.42 0 0 1 3.39-1 6.51 6.51 0 0 1 6.5 6.5 6.42 6.42 0 0 1-1 3.39L9.36 18.5Zm3.39 12a6.51 6.51 0 0 1-6.5-6.5 6.42 6.42 0 0 1 1-3.42l8.94 8.94a6.42 6.42 0 0 1-3.42 1l-.02-.02Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 24a9 9 0 1 0 18.001-.001A9 9 0 0 0 3.75 24Zm4.826-5.61A6.963 6.963 0 0 1 12.75 17a7 7 0 0 1 7 7c0 1.567-.52 3.008-1.39 4.174L8.576 18.39ZM5.75 24c0-1.578.529-3.029 1.409-4.199l9.79 9.79A6.96 6.96 0 0 1 12.75 31a7 7 0 0 1-7-7Z" fill="url(#b)"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M2.75 17.5v-16l11.6 11.608H7.304l-.152.124L2.75 17.5Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 3.8V15l2.969-2.87.16-.138 5.036.008L3.75 3.8Z" fill="currentColor"></path></g><defs><linearGradient id="b" x1="12.75" y1="15" x2="12.75" y2="33" gradientUnits="userSpaceOnUse"><stop stop-color="#F1F1F1"></stop><stop offset="1" stop-color="#D6D6D6"></stop></linearGradient><filter id="a" x=".95" y=".7" width="23.1" height="35.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31738"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31738" result="shape"></feBlend></filter></defs>', 2), Rr = [
  Or
], f6 = /* @__PURE__ */ i({
  __name: "IconCursorDisabled",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 25 37",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Rr, 14, Ur));
  }
}), jr = ["stroke-width"], Pr = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M5.924 8.847c-.1-.37-.2-.85-.41-1.55-.21-.7-.34-.86-.47-1.23-.13-.37-.3-.72-.5-1.18-.183-.47-.337-.95-.46-1.44a1.43 1.43 0 0 1 .28-1.17 1.41 1.41 0 0 1 1.36-.35c.379.166.699.44.92.79.295.472.536.975.72 1.5.282.72.486 1.467.61 2.23l.09.45v-1.16c0-1-.06-1.82 0-2.94 0-.13.06-.59.08-.72a1.19 1.19 0 0 1 .67-1c.445-.2.955-.2 1.4 0 .399.179.665.564.69 1 0 .11.09 1 .09 1.11V6.827c.024-1.32.137-2.636.34-3.94a1.49 1.49 0 0 1 .79-.93 1.37 1.37 0 0 1 1.4.24c.288.316.458.723.48 1.15V6.897c.09-.28.19-.54.27-.74.08-.2.24-.61.36-.86.122-.238.259-.469.41-.69a1.38 1.38 0 0 1 .67-.56 1 1 0 0 1 1.3.59c.06.364.06.736 0 1.1a9.351 9.351 0 0 1-.35 1.65c-.13.45-.27 1.23-.34 1.6-.07.37-.23 1.38-.36 1.82a5.913 5.913 0 0 1-.79 1.47 7.237 7.237 0 0 0-1.19 1.81 4.042 4.042 0 0 0-.1 1c-.002.31.039.62.12.92a5.8 5.8 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.23.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92c-.28-.36-.63-1.09-1.24-2-.35-.5-1-1.09-1.28-1.58a1.75 1.75 0 0 1-.19-1.32 1.21 1.21 0 0 1 1.37-.86 2 2 0 0 1 1.24.54c.268.232.518.482.75.75.16.19.2.28.38.51.18.23.3.46.21.12" fill="currentColor"></path><path d="M5.924 8.847c-.1-.37-.2-.85-.41-1.55-.21-.7-.34-.86-.47-1.23-.13-.37-.3-.72-.5-1.18-.183-.47-.337-.95-.46-1.44a1.43 1.43 0 0 1 .28-1.17 1.41 1.41 0 0 1 1.36-.35c.379.166.699.44.92.79.295.472.536.975.72 1.5.282.72.486 1.467.61 2.23l.09.45v-1.16c0-1-.06-1.82 0-2.94 0-.13.06-.59.08-.72a1.19 1.19 0 0 1 .67-1c.445-.2.955-.2 1.4 0 .399.179.665.564.69 1 0 .11.09 1 .09 1.11V6.827c.024-1.32.137-2.636.34-3.94a1.49 1.49 0 0 1 .79-.93 1.37 1.37 0 0 1 1.4.24c.288.316.458.723.48 1.15V6.897c.09-.28.19-.54.27-.74.08-.2.24-.61.36-.86.122-.238.259-.469.41-.69a1.38 1.38 0 0 1 .67-.56 1 1 0 0 1 1.3.59c.06.364.06.736 0 1.1a9.351 9.351 0 0 1-.35 1.65c-.13.45-.27 1.23-.34 1.6-.07.37-.23 1.38-.36 1.82a5.913 5.913 0 0 1-.79 1.47 7.237 7.237 0 0 0-1.19 1.81 4.042 4.042 0 0 0-.1 1c-.002.31.039.62.12.92a5.8 5.8 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.23.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92c-.28-.36-.63-1.09-1.24-2-.35-.5-1-1.09-1.28-1.58a1.75 1.75 0 0 1-.19-1.32 1.21 1.21 0 0 1 1.37-.86 2 2 0 0 1 1.24.54c.268.232.518.482.75.75.16.19.2.28.38.51.18.23.3.46.21.12" stroke="currentColor" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round"></path><path d="M13.294 13.008V9.556a.374.374 0 0 0-.75 0v3.452a.375.375 0 0 0 .75 0ZM11.304 13.008l-.01-3.454a.374.374 0 0 0-.75.002l.01 3.454c0 .206.169.373.376.372a.374.374 0 0 0 .374-.374ZM8.549 9.557 8.569 13c.001.21.17.377.377.376a.376.376 0 0 0 .373-.38l-.02-3.444a.376.376 0 0 0-.377-.376.376.376 0 0 0-.373.38Z" fill="currentColor"></path></g><defs><filter id="a" x=".765" y=".552" width="17.468" height="17.695" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".4"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31867"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31867" result="shape"></feBlend></filter></defs>', 2), Tr = [
  Pr
], _6 = /* @__PURE__ */ i({
  __name: "IconCursorGrip",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 19 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Tr, 14, jr));
  }
}), qr = ["stroke-width"], Kr = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M4.659 1.492c.48-.18 1.43-.07 1.68.47s.4 1.24.41 1.07a6.39 6.39 0 0 1 .13-1.54 1.11 1.11 0 0 1 .69-.69 1.93 1.93 0 0 1 .92-.06c.31.064.585.243.77.5a5.48 5.48 0 0 1 .39 1.83 6.54 6.54 0 0 1 .27-1.58 1.24 1.24 0 0 1 .69-.48c.33-.06.67-.06 1 0a1.4 1.4 0 0 1 .68.49c.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 1 1 1.9.64v2.26a11.646 11.646 0 0 1-.24 1.74 5.874 5.874 0 0 1-.72 1.43 7.219 7.219 0 0 0-1.19 1.81 4.116 4.116 0 0 0-.1 1c-.001.31.04.62.12.92a5.786 5.786 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1 1.11-.67.08-2.06 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92a4.45 4.45 0 0 1-1.24-2c-.21-.94-.19-1.39 0-1.77a1.5 1.5 0 0 1 .85-.65 1.8 1.8 0 0 1 .88.06c.196.082.366.217.49.39.23.31.31.46.21.12s-.32-.59-.43-1a4.58 4.58 0 0 1-.38-1.53 1.14 1.14 0 0 1 .83-1" fill="currentColor"></path><path clip-rule="evenodd" d="M4.659 1.492c.48-.18 1.43-.07 1.68.47s.4 1.24.41 1.07a6.39 6.39 0 0 1 .13-1.54 1.11 1.11 0 0 1 .69-.69 1.93 1.93 0 0 1 .92-.06c.31.064.585.243.77.5a5.48 5.48 0 0 1 .39 1.83 6.54 6.54 0 0 1 .27-1.58 1.24 1.24 0 0 1 .69-.48c.33-.06.67-.06 1 0a1.4 1.4 0 0 1 .68.49c.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.002 1.002 0 1 1 1.9.64v2.26a11.646 11.646 0 0 1-.24 1.74 5.874 5.874 0 0 1-.72 1.43 7.216 7.216 0 0 0-1.19 1.81 4.116 4.116 0 0 0-.1 1c-.001.31.04.62.12.92a5.786 5.786 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1 1.11-.67.08-2.06 0-3.14 0 0 0 .19-1-.23-1.36-.42-.36-.83-.78-1.14-1.06l-.83-.92a4.45 4.45 0 0 1-1.24-2c-.21-.94-.19-1.39 0-1.77a1.5 1.5 0 0 1 .85-.65 1.8 1.8 0 0 1 .88.06c.196.082.366.217.49.39.23.31.31.46.21.12s-.32-.59-.43-1a4.58 4.58 0 0 1-.38-1.53c.02-.48.34-.897.8-1.04Z" stroke="currentColor" stroke-width=".75" stroke-linejoin="round"></path><path d="M12.41 9.168V5.716a.375.375 0 0 0-.75 0v3.452a.375.375 0 0 0 .75 0ZM10.43 9.167l-.02-3.454a.374.374 0 0 0-.75.005l.02 3.453a.374.374 0 0 0 .75-.004ZM7.66 5.722l.02 3.445c0 .208.17.377.376.375a.376.376 0 0 0 .373-.38l-.02-3.444a.376.376 0 0 0-.377-.376.376.376 0 0 0-.373.38Z" fill="currentColor"></path></g><defs><filter id="a" x=".914" y=".337" width="15.173" height="14.125" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".4"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31875"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31875" result="shape"></feBlend></filter></defs>', 2), Qr = [
  Kr
], y6 = /* @__PURE__ */ i({
  __name: "IconCursorGripping",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 15",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Qr, 14, qr));
  }
}), Xr = ["stroke-width"], Yr = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m4.195 2.603.047-.035a5.744 5.744 0 0 1 3.193-1.062c1.411-.092 2.793.437 3.71 1.384.948.8 1.452 2.008 1.355 3.16a4.025 4.025 0 0 1-.825 2.447c-.394.481-.85.907-1.305 1.224l-.544.44a.86.86 0 0 0-.262.333c-.06.145-.053.38-.044.575v1.045h-4l-.018-.933a8.446 8.446 0 0 1 .13-2.125c.097-.382.297-.703.59-1.007.198-.206.346-.328.818-.7l.597-.47a2.51 2.51 0 0 0 .38-.343.983.983 0 0 0 .173-.457c.003-.125-.038-.248-.16-.402-.12-.172-.325-.264-.595-.234a.984.984 0 0 0-.642.28 1.19 1.19 0 0 0-.293.749l-.027.972H2.578l-.075-.919a4.55 4.55 0 0 1 1.692-3.922Z" fill="currentColor"></path><path d="M4.82 3.384a4.79 4.79 0 0 1 2.68-.88 3.84 3.84 0 0 1 3 1.15 2.84 2.84 0 0 1 1 2.4 3 3 0 0 1-.6 1.81 5.837 5.837 0 0 1-1.16 1.08l-.53.43a1.87 1.87 0 0 0-.6.82c-.064.19-.104.609-.09.92h-2a7.402 7.402 0 0 1 .08-1.81c.11-.43.5-.73 1.06-1.17l.57-.45a3.35 3.35 0 0 0 .61-.58 2 2 0 0 0 .35-1 1.53 1.53 0 0 0-.34-1 1.57 1.57 0 0 0-1.47-.66 2 2 0 0 0-1.34.62 2.19 2.19 0 0 0-.54 1.38h-2a3.55 3.55 0 0 1 1.25-3" fill="currentColor"></path><path d="M9.52 11.504v4h-4v-4h4Z" fill="currentColor"></path><path d="M8.52 12.504h-2v2h2v-2Z" fill="currentColor"></path></g><defs><filter id="a" x=".688" y=".696" width="13.623" height="17.608" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31944"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31944" result="shape"></feBlend></filter></defs>', 2), Jr = [
  Yr
], w6 = /* @__PURE__ */ i({
  __name: "IconCursorHelp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Jr, 14, Xr));
  }
}), ts = ["stroke-width"], es = /* @__PURE__ */ u('<g filter="url(#a)" fill-rule="evenodd" clip-rule="evenodd"><path d="M12 33.25v-9H3a9 9 0 0 1 9-9v9h9a9 9 0 0 1-9 9Z" fill="currentColor"></path><path d="M12 15.25a9 9 0 0 1 9 9h-9v9a9 9 0 0 1-9-9h9v-9Z" fill="currentColor"></path><path d="M2 17.75v-16l11.6 11.608H6.554l-.152.124L2 17.75Z" fill="currentColor"></path><path d="M3 4.05v11.2l2.969-2.87.16-.138 5.036.008L3 4.05Z" fill="currentColor"></path></g><defs><filter id="a" x=".2" y=".95" width="22.6" height="35.1" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31720"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31720" result="shape"></feBlend></filter></defs>', 2), os = [
  es
], g6 = /* @__PURE__ */ i({
  __name: "IconCursorLoading",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 23 37",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, os, 14, ts));
  }
}), rs = ["stroke-width"], ss = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M6.5 1v7h-4l6 6 6-6h-4V1h-4Z" fill="currentColor"></path><path d="M9.5 2v7h2.59L8.5 12.59 4.91 9H7.5V2h2Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".2" width="15.6" height="16.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32096"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32096" result="shape"></feBlend></filter></defs>', 2), ns = [
  ss
], v6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ns, 14, rs));
  }
}), is = ["stroke-width"], ls = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m5.025 6.145-2.83-2.83v8.48l8.48.01-2.82-2.83 4.95-4.95-2.83-2.83-4.95 4.95Z" fill="currentColor"></path><path d="m11.385 4.025-4.95 4.95 1.83 1.83-5.07-.01v-5.07l1.83 1.83 4.95-4.95 1.41 1.42Z" fill="currentColor"></path></g><defs><filter id="a" x=".395" y=".395" width="14.21" height="14.21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32101"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32101" result="shape"></feBlend></filter></defs>', 2), as = [
  ls
], z6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveLeftDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, as, 14, is));
  }
}), cs = ["stroke-width"], ds = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M3.91 7.5 7.5 3.91V6.5h6V3.92l3.58 3.58-3.58 3.59V8.5h-6v2.59L3.91 7.5Zm-1.41 0 6 6v-4h4v4l6-6-6-6v4h-4v-4l-6 6Z" fill="currentColor"></path><path d="M11 8.5h2.52v2.59l3.56-3.59-3.56-3.58v2.6H7.5v-2.6L3.91 7.5l3.59 3.59V8.5H11Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".7" width="19.6" height="15.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32157"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32157" result="shape"></feBlend></filter></defs>', 2), ps = [
  ds
], $6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveLeftRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 21 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ps, 14, cs));
  }
}), hs = ["stroke-width"], us = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M2.195 1.195v8.48l2.83-2.82 4.95 4.95 2.83-2.83-4.95-4.95 2.83-2.83h-8.49Z" fill="currentColor"></path><path d="m9.975 10.385-4.95-4.95-1.83 1.83v-5.07h5.07l-1.83 1.83 4.95 4.95-1.41 1.41Z" fill="currentColor"></path></g><defs><filter id="a" x=".395" y=".395" width="14.21" height="14.21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32147"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32147" result="shape"></feBlend></filter></defs>', 2), fs = [
  us
], m6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveLeftUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, fs, 14, hs));
  }
}), _s = ["stroke-width"], ys = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m2 7.5 6 6v-4h7v-4H8v-4l-6 6Z" fill="currentColor"></path><path d="M14 8.5H7v2.59L3.41 7.5 7 3.92V6.5h7v2Z" fill="currentColor"></path></g><defs><filter id="a" x=".2" y=".7" width="16.6" height="15.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32142"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32142" result="shape"></feBlend></filter></defs>', 2), ws = [
  ys
], k6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveLeft",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ws, 14, _s));
  }
}), gs = ["stroke-width"], vs = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m2.195 4.025 4.95 4.95-2.83 2.83h8.49v-8.49l-2.83 2.83-4.95-4.95-2.83 2.83Z" fill="currentColor"></path><path d="m5.025 2.605 4.95 4.95 1.83-1.82v5.07h-5.07l1.82-1.83-4.95-4.95 1.42-1.42Z" fill="currentColor"></path></g><defs><filter id="a" x=".395" y=".395" width="14.21" height="14.21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32091"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32091" result="shape"></feBlend></filter></defs>', 2), zs = [
  vs
], S6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveRightDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, zs, 14, gs));
  }
}), $s = ["stroke-width"], ms = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M12.805 9.685v-8.49h-8.49l2.83 2.83-4.95 4.95 2.83 2.83 4.95-4.95 2.83 2.83Z" fill="currentColor"></path><path d="m3.605 8.975 4.95-4.95-1.82-1.83h5.07v5.07l-1.83-1.83-4.95 4.95-1.42-1.41Z" fill="currentColor"></path></g><defs><filter id="a" x=".395" y=".395" width="14.21" height="14.21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32081"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32081" result="shape"></feBlend></filter></defs>', 2), ks = [
  ms
], x6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveRightUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ks, 14, $s));
  }
}), Ss = ["stroke-width"], xs = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m9 13.5 6-6-6-6v4H2v4h7v4Z" fill="currentColor"></path><path d="M3 6.5h7V3.91l3.59 3.59L10 11.09V8.5H3v-2Z" fill="currentColor"></path></g><defs><filter id="a" x=".2" y=".7" width="16.6" height="15.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32086"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32086" result="shape"></feBlend></filter></defs>', 2), Cs = [
  xs
], C6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Cs, 14, Ss));
  }
}), Bs = ["stroke-width"], Ms = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m8.5 2.91 3.59 3.59H9.5v6h2.59L8.5 16.09 4.91 12.5H7.5v-6H4.91L8.5 2.91Zm0-1.41-6 6h4v4h-4l6 6 6-6h-4v-4h4l-6-6Z" fill="currentColor"></path><path d="M9.5 9V6.48h2.59L8.5 2.91 4.91 6.48H7.5v6.02H4.91l3.59 3.59 3.59-3.59H9.5V9Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".7" width="15.6" height="19.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32152"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32152" result="shape"></feBlend></filter></defs>', 2), Zs = [
  Ms
], B6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveUpDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Zs, 14, Bs));
  }
}), Is = ["stroke-width"], bs = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m6.755 8.585 4.07 4.07-2.82 2.83 8.47-.02.01-8.47-2.84 2.84-4.07-4.06-1.42-1.42 2.85-2.84h-8.49v8.48l2.83-2.82 1.41 1.41Z" fill="currentColor"></path><path d="m7.815 8.235 4.43 4.42-1.83 1.83 5.06-.02.01-5.05-1.84 1.84-4.43-4.42-2.47-2.48 1.84-1.84h-5.07v5.07l1.83-1.83 2.47 2.48Z" fill="currentColor"></path></g><defs><filter id="a" x=".715" y=".715" width="17.57" height="17.57" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32167"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32167" result="shape"></feBlend></filter></defs>', 2), Ws = [
  bs
], M6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveUpLeftDownRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 19 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ws, 14, Is));
  }
}), Hs = ["stroke-width"], Vs = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m12.245 8.585-4.07 4.07 2.83 2.83-8.48-.02-.01-8.47 2.84 2.84 4.08-4.06 1.41-1.42-2.84-2.84h8.48v8.48l-2.83-2.82-1.41 1.41Z" fill="currentColor"></path><path d="m11.185 8.235-4.43 4.42 1.83 1.83-5.06-.02-.01-5.05 1.84 1.84 4.43-4.42 2.47-2.48-1.84-1.84h5.07v5.07l-1.83-1.83-2.47 2.48Z" fill="currentColor"></path></g><defs><filter id="a" x=".715" y=".715" width="17.57" height="17.57" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32162"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32162" result="shape"></feBlend></filter></defs>', 2), As = [
  Vs
], Z6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveUpRightDownLeft",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 19 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, As, 14, Hs));
  }
}), Ls = ["stroke-width"], Ns = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m14.5 7-6-6-6 6h4v7h4V7h4Z" fill="currentColor"></path><path d="M7.5 13V6H4.91L8.5 2.41 12.09 6H9.5v7h-2Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".2" width="15.6" height="16.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132137_38728"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132137_38728" result="shape"></feBlend></filter></defs>', 2), Fs = [
  Ns
], I6 = /* @__PURE__ */ i({
  __name: "IconCursorMoveUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Fs, 14, Ls));
  }
}), Gs = ["stroke-width"], Ds = /* @__PURE__ */ u('<g filter="url(#a)"><path d="m10.5 1.5-8 8 5.22 5.22 2.78 2.78 8-8-8-8Zm-2 11h-1v-1h1v1Zm0-5h-1v-1h1v1Zm5 5h-1v-1h1v1Zm-1-6h1v1h-1v-1Z" fill="currentColor"></path><path d="m17.05 9.48-2.56-2.81V8.5H6.48V6.67L3.91 9.48l2.57 2.81v-1.81h8.01v1.81l2.56-2.81Z" fill="currentColor"></path><path d="M11.47 9.49h.01v-4h1.81l-2.8-2.57-2.81 2.57h1.81v8H7.67l2.8 2.57 2.81-2.57h-1.81v-4Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".7" width="19.6" height="19.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31711"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31711" result="shape"></feBlend></filter></defs>', 2), Es = [
  Ds
], b6 = /* @__PURE__ */ i({
  __name: "IconCursorMove",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 21 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Es, 14, Gs));
  }
}), Us = ["stroke-width"], Os = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M4.205 12.739c-.28-.36-.63-1.09-1.24-2-.35-.5-1.21-1.45-1.47-1.94a1.26 1.26 0 0 1-.15-1 1.32 1.32 0 0 1 1.43-1c.511.103.98.353 1.35.72.259.243.496.507.71.79.16.2.2.28.38.51.18.23.3.46.21.12-.07-.5-.19-1.34-.36-2.09-.13-.57-.16-.66-.28-1.09-.12-.43-.19-.79-.32-1.28a14.16 14.16 0 0 1-.28-1.46 2.82 2.82 0 0 1 .26-1.85 1.19 1.19 0 0 1 1.3-.22c.441.325.77.78.94 1.3a7.73 7.73 0 0 1 .52 2c.16 1 .47 2.46.48 2.76 0-.37-.07-1.15 0-1.5a1.07 1.07 0 0 1 .67-.8 2 2 0 0 1 .92-.06c.31.065.585.243.77.5.232.583.36 1.203.38 1.83a6.73 6.73 0 0 1 .28-1.62 1.24 1.24 0 0 1 .69-.48c.331-.06.67-.06 1 0 .271.09.509.261.68.49.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.003 1.003 0 0 1 1.9.64v2.26a11.727 11.727 0 0 1-.24 1.74 5.908 5.908 0 0 1-.72 1.43 7.214 7.214 0 0 0-1.19 1.81 4.004 4.004 0 0 0-.1 1c0 .31.04.62.12.92a5.853 5.853 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .18-1-.23-1.36-.41-.36-.83-.78-1.14-1.06l-.84-.96Z" fill="currentColor"></path><path clip-rule="evenodd" d="M4.205 12.739c-.28-.36-.63-1.09-1.24-2-.35-.5-1.21-1.45-1.47-1.94a1.26 1.26 0 0 1-.15-1 1.32 1.32 0 0 1 1.43-1c.511.103.98.353 1.35.72.259.243.496.507.71.79.16.2.2.28.38.51.18.23.3.46.21.12-.07-.5-.19-1.34-.36-2.09-.13-.57-.16-.66-.28-1.09-.12-.43-.19-.79-.32-1.28a14.16 14.16 0 0 1-.28-1.46 2.82 2.82 0 0 1 .26-1.85 1.19 1.19 0 0 1 1.3-.22c.441.325.77.78.94 1.3a7.73 7.73 0 0 1 .52 2c.16 1 .47 2.46.48 2.76 0-.37-.07-1.15 0-1.5a1.07 1.07 0 0 1 .67-.8 2 2 0 0 1 .92-.06c.31.065.585.243.77.5.232.583.36 1.203.38 1.83a6.73 6.73 0 0 1 .28-1.62 1.24 1.24 0 0 1 .69-.48c.331-.06.67-.06 1 0 .271.09.509.261.68.49.212.53.34 1.09.38 1.66 0 .14.07-.39.29-.74a1.003 1.003 0 0 1 1.9.64v2.26a11.727 11.727 0 0 1-.24 1.74 5.908 5.908 0 0 1-.72 1.43 7.214 7.214 0 0 0-1.19 1.81 4.004 4.004 0 0 0-.1 1c0 .31.04.62.12.92a5.853 5.853 0 0 1-1.23 0c-.39-.06-.87-.84-1-1.08a.38.38 0 0 0-.68 0c-.22.38-.71 1.07-1.05 1.11-.67.08-2.05 0-3.14 0 0 0 .18-1-.23-1.36-.41-.36-.83-.78-1.14-1.06l-.84-.96Z" stroke="currentColor" stroke-width=".75" stroke-linecap="round" stroke-linejoin="round"></path><path d="M12.685 13.285V9.833a.374.374 0 0 0-.75 0v3.452a.375.375 0 0 0 .75 0ZM10.706 13.284l-.02-3.454a.374.374 0 0 0-.75.004l.02 3.454a.374.374 0 0 0 .75-.004ZM7.936 9.838l.02 3.446a.376.376 0 1 0 .75-.004l-.02-3.446a.376.376 0 1 0-.75.004Z" fill="currentColor"></path></g><defs><filter id="a" x=".127" y=".471" width="16.747" height="17.859" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".4"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.5 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31859"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31859" result="shape"></feBlend></filter></defs>', 2), Rs = [
  Os
], W6 = /* @__PURE__ */ i({
  __name: "IconCursorPointing",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 19",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Rs, 14, Us));
  }
}), js = ["stroke-width"], Ps = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M2.5 1v3.98h6.01v1.06H5.04L10.51 12l5.46-5.96h-3.48V4.98h6.01V1h-16Z" fill="currentColor"></path><path d="M3.5 3.98h6v3.04H7.26l3.25 3.32 3.22-3.32h-2.25V3.98h6V2.02H3.5v1.96Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".2" width="19.6" height="14.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32025"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32025" result="shape"></feBlend></filter></defs>', 2), Ts = [
  Ps
], H6 = /* @__PURE__ */ i({
  __name: "IconCursorResizeDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 21 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ts, 14, js));
  }
}), qs = ["stroke-width"], Ks = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M9.5 1.5v6.01H8.48V4.04L2.5 9.51l5.98 5.46v-3.48H9.5v6.01h3.98v-6.01h1.06v3.47l5.96-5.47-5.96-5.46V7.5h-1.06v-6H9.5Z" fill="currentColor"></path><path d="m18.84 9.49-3.32-3.22v2.25H12.5V2.56h-.02v-.02h-1.94v6H7.48V6.26L4.16 9.51l3.32 3.22v-2.25h3.06v6h1.96v-6h3.02v2.26l3.32-3.25Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".7" width="21.6" height="19.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32040"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32040" result="shape"></feBlend></filter></defs>', 2), Qs = [
  Ks
], V6 = /* @__PURE__ */ i({
  __name: "IconCursorResizeLeftRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 23 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Qs, 14, qs));
  }
}), Xs = ["stroke-width"], Ys = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M9.557 1.5v6.01h-1.02V3.64l-6 5.87 6 5.89v-3.91h1.02v6.01h3.98v-16h-3.98Z" fill="currentColor"></path><path d="M10.537 2.5v6h-3.02V6.26l-3.32 3.25 3.32 3.22v-2.25h3.02v6h1.98V2.5h-1.98Z" fill="currentColor"></path></g><defs><filter id="a" x=".737" y=".7" width="14.6" height="19.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32030"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32030" result="shape"></feBlend></filter></defs>', 2), Js = [
  Ys
], A6 = /* @__PURE__ */ i({
  __name: "IconCursorResizeLeft",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Js, 14, Xs));
  }
}), t0 = ["stroke-width"], e0 = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M2 1.5v16h3.98v-6.01h1.06v3.47L13 9.49 7.04 4.03V7.5H5.98v-6H2Z" fill="currentColor"></path><path d="M5 16.48v-6h3.02v2.26l3.32-3.25-3.32-3.22v2.25H5v-6H3.02v13.96H5Z" fill="currentColor"></path></g><defs><filter id="a" x=".2" y=".7" width="14.6" height="19.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32005"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32005" result="shape"></feBlend></filter></defs>', 2), o0 = [
  e0
], L6 = /* @__PURE__ */ i({
  __name: "IconCursorResizeRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, o0, 14, t0));
  }
}), r0 = ["stroke-width"], s0 = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M10.49 1.5 5.03 7.46H8.5V8.5h-6v3.98h6v1.06H5.04l5.47 5.96 5.46-5.96h-3.48v-1.06h6.01V8.5h-6.01V7.46h3.47L10.49 1.5Z" fill="currentColor"></path><path d="M17.46 9.52h-5.98V6.48h2.26l-3.25-3.32-3.22 3.32h2.25v3.04h-6v1.96h6.02v3.04H7.26l3.25 3.32 3.22-3.32h-2.25v-3.04h6V9.52h-.02Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".7" width="19.6" height="21.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32035"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32035" result="shape"></feBlend></filter></defs>', 2), n0 = [
  s0
], N6 = /* @__PURE__ */ i({
  __name: "IconCursorResizeUpDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 21 23",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, n0, 14, r0));
  }
}), i0 = ["stroke-width"], l0 = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M5.03 6.96H8.5v1.06h-6V12h16V8.02h-6.01V6.96h3.47L10.49 1 5.03 6.96Z" fill="currentColor"></path><path d="M17.5 9.02h-6V5.98h2.24l-3.25-3.32-3.22 3.32h2.25v3.04h-6v1.96H17.5V9.02Z" fill="currentColor"></path></g><defs><filter id="a" x=".7" y=".2" width="19.6" height="14.6" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32010"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32010" result="shape"></feBlend></filter></defs>', 2), a0 = [
  l0
], F6 = /* @__PURE__ */ i({
  __name: "IconCursorResizeUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 21 15",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, a0, 14, i0));
  }
}), c0 = ["stroke-width"], d0 = /* @__PURE__ */ n("path", {
  opacity: ".72",
  d: "M12 12v11h-1V12h1Zm-1-1v1H0v-1h11Zm12 0v1H12v-1h11ZM12 0v11h-1V0h1Z",
  fill: "currentColor"
}, null, -1), p0 = /* @__PURE__ */ n("path", {
  opacity: ".15",
  d: "M17 11.5a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z",
  fill: "currentColor"
}, null, -1), h0 = /* @__PURE__ */ n("path", {
  opacity: ".3",
  d: "M11.5 17a5.5 5.5 0 1 0 0-11 5.5 5.5 0 0 0 0 11Z",
  stroke: "currentColor"
}, null, -1), u0 = [
  d0,
  p0,
  h0
], G6 = /* @__PURE__ */ i({
  __name: "IconCursorScreenshotSelect",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 23 23",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, u0, 14, c0));
  }
}), f0 = ["stroke-width"], _0 = /* @__PURE__ */ u('<g filter="url(#a)" fill-rule="evenodd" clip-rule="evenodd"><path d="M6 18c-1.93 0-3.5-1.57-3.5-3.5v-7C2.5 5.57 4.07 4 6 4h1c.466 0 .887-.51 1.105-.947C8.739 1.786 9.528 1 11.5 1h4c1.972 0 2.761.786 3.395 2.053.218.437.639.947 1.105.947h1c1.93 0 3.5 1.57 3.5 3.5v7c0 1.93-1.57 3.5-3.5 3.5H6Z" fill="currentColor"></path><path d="M13.5 15a5 5 0 0 1-5-5 5 5 0 0 1 5-5 5 5 0 0 1 5 5 5 5 0 0 1-5 5ZM21 5h-1c-1 0-1.684-.868-2-1.5-.5-1-1-1.5-2.5-1.5h-4C10 2 9.5 2.5 9 3.5 8.684 4.132 8 5 7 5H6a2.5 2.5 0 0 0-2.5 2.5v7A2.5 2.5 0 0 0 6 17h15a2.5 2.5 0 0 0 2.5-2.5v-7A2.5 2.5 0 0 0 21 5Z" fill="currentColor"></path><path d="M16.5 10a3.001 3.001 0 0 1-6 0 3.001 3.001 0 0 1 6 0Z" fill="currentColor"></path></g><defs><filter id="a" x=".5" y="0" width="26" height="21" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation="1"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_32191"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_32191" result="shape"></feBlend></filter></defs>', 2), y0 = [
  _0
], D6 = /* @__PURE__ */ i({
  __name: "IconCursorScreenshotShot",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 27 21",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, y0, 14, f0));
  }
}), w0 = ["stroke-width"], g0 = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M12.4 1.04H2.6l3.29 3.2-.57.63c-.365.485-.7.993-1 1.52a10 10 0 0 0-.67 2 13.378 13.378 0 0 0 0 2.13c.037.556.137 1.107.3 1.64a6 6 0 0 0 .63 1.38c.28.438.616.838 1 1.19.685.468 1.407.88 2.16 1.23a9.515 9.515 0 0 1-.94-1.75 12.267 12.267 0 0 1-.28-1.53c-.051-.528-.071-1.06-.06-1.59a5 5 0 0 1 .19-1.13c.162-.47.399-.913.7-1.31a6.47 6.47 0 0 1 .8-.91c.267-.26.551-.505.85-.73l3.4 3.23v-9.2Z" fill="currentColor"></path><path d="M11.4 8.04v-6h-6l1.85 1.78c-.14.15-.33.34-.44.48-.28.35-.44.54-.61.73-.17.19-.26.32-.38.47a5.472 5.472 0 0 0-.36.57c-.11.2-.23.46-.37.75a4.35 4.35 0 0 0-.32 1c-.08.33-.136.663-.17 1a7.12 7.12 0 0 0 0 .76 7 7 0 0 0 0 1c.089.59.25 1.169.48 1.72l.46.93a17.64 17.64 0 0 1-.12-2.28 5.73 5.73 0 0 1 .49-1.73 2.07 2.07 0 0 1 .19-.42l.36-.57c.21-.34.65-.87.76-1a9.25 9.25 0 0 1 .94-.92l.79-.67 2.45 2.4Z" fill="currentColor"></path></g><defs><filter id="a" x=".8" y=".24" width="13.4" height="18.52" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31779"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31779" result="shape"></feBlend></filter></defs>', 2), v0 = [
  g0
], E6 = /* @__PURE__ */ i({
  __name: "IconCursorShortcuts",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 15 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, v0, 14, w0));
  }
}), z0 = ["stroke-width"], $0 = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M7.798 1.696a5.1 5.1 0 0 1 4.156 8.057l4.348 4.349-1.202 1.202-4.349-4.35a5.1 5.1 0 1 1-2.953-9.259Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.798 11.046a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z" fill="currentColor"></path><path d="M10.348 5.946h-1.7v-1.7h-1.7v1.7h-1.7V7.63h1.7v1.717h1.7V7.63h1.7V5.946Z" fill="currentColor"></path></g><defs><filter id="a" x=".898" y=".896" width="17.203" height="17.208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31956"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31956" result="shape"></feBlend></filter></defs>', 2), m0 = [
  $0
], U6 = /* @__PURE__ */ i({
  __name: "IconCursorZoomIn",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 19 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, m0, 14, z0));
  }
}), k0 = ["stroke-width"], S0 = /* @__PURE__ */ u('<g filter="url(#a)"><path d="M7.798 1.696a5.1 5.1 0 0 1 4.156 8.057l4.348 4.349-1.202 1.202-4.349-4.35a5.1 5.1 0 1 1-2.953-9.259Z" fill="currentColor"></path><path fill-rule="evenodd" clip-rule="evenodd" d="M7.798 11.046a4.25 4.25 0 1 0 0-8.5 4.25 4.25 0 0 0 0 8.5Z" fill="currentColor"></path><path d="M10.349 5.963H5.266v1.683h5.083V5.963Z" fill="currentColor"></path></g><defs><filter id="a" x=".898" y=".896" width="17.203" height="17.208" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"><feFlood flood-opacity="0" result="BackgroundImageFix"></feFlood><feColorMatrix in="SourceAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"></feColorMatrix><feOffset dy="1"></feOffset><feGaussianBlur stdDeviation=".9"></feGaussianBlur><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.65 0"></feColorMatrix><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_132185_31955"></feBlend><feBlend in="SourceGraphic" in2="effect1_dropShadow_132185_31955" result="shape"></feBlend></filter></defs>', 2), x0 = [
  S0
], O6 = /* @__PURE__ */ i({
  __name: "IconCursorZoomOut",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 19 19",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, x0, 14, k0));
  }
}), C0 = ["stroke-width"], B0 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M10.783 2.573a.75.75 0 0 0 0 1.5v-1.5Zm2.12 2.25v8.113h1.5V4.823h-1.5Zm-.75 8.863H3.848v1.5h8.303v-1.5Zm-9.054-.75V4.823h-1.5v8.113h1.5Zm.75-8.863H5.23v-1.5H3.85v1.5Zm6.934 0h1.37v-1.5h-1.37v1.5Zm-6.934 9.613a.75.75 0 0 1-.75-.75h-1.5a2.25 2.25 0 0 0 2.25 2.25v-1.5Zm9.053-.75a.75.75 0 0 1-.75.75v1.5a2.25 2.25 0 0 0 2.25-2.25h-1.5Zm1.5-8.113a2.25 2.25 0 0 0-2.25-2.25v1.5a.75.75 0 0 1 .75.75h1.5Zm-11.303 0a.75.75 0 0 1 .75-.75v-1.5a2.25 2.25 0 0 0-2.25 2.25h1.5Z"
}, null, -1), M0 = ["strokeWidth"], Z0 = /* @__PURE__ */ n("circle", {
  cx: "5.204",
  cy: "8.151",
  r: "1.051",
  fill: "currentColor"
}, null, -1), I0 = /* @__PURE__ */ n("circle", {
  cx: "5.204",
  cy: "10.946",
  r: "1.051",
  fill: "currentColor"
}, null, -1), b0 = ["strokeWidth"], R6 = /* @__PURE__ */ i({
  __name: "IconDataAssetsList",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      B0,
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9.434 1.973H6.578a1.35 1.35 0 0 0 0 2.7h2.856a1.35 1.35 0 1 0 0-2.7ZM8 8.15h2.784"
      }, null, 8, M0),
      Z0,
      I0,
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M8 10.946h2.784"
      }, null, 8, b0)
    ], 14, C0));
  }
}), W0 = ["stroke-width"], H0 = ["strokeWidth"], V0 = ["strokeWidth"], j6 = /* @__PURE__ */ i({
  __name: "IconDataBackup",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M13.625 13.14V3.592a1.5 1.5 0 0 0-1.5-1.5H5.693a1.5 1.5 0 0 0-1.31.77L2.351 6.51v6.63a1.5 1.5 0 0 0 1.5 1.5h8.273a1.5 1.5 0 0 0 1.5-1.5Z"
      }, null, 8, H0),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M6.646 4.203v3.451M8.73 4.203v3.451m1.999-3.451v3.451"
      }, null, 8, V0)
    ], 14, W0));
  }
}), A0 = ["stroke-width"], L0 = /* @__PURE__ */ n("path", {
  d: "M3.6 7.7c1.158 0 2.1.942 2.1 2.1V14a.7.7 0 0 1-.7.7H2.2a.7.7 0 0 1-.7-.7V9.8c0-1.158.942-2.1 2.1-2.1Zm4.9-5.6c1.158 0 2.1.942 2.1 2.1V14a.7.7 0 0 1-.7.7H7.1a.7.7 0 0 1-.7-.7V4.2c0-1.158.942-2.1 2.1-2.1Zm4.9 2.8c1.158 0 2.1.942 2.1 2.1v7a.7.7 0 0 1-.7.7H12a.7.7 0 0 1-.7-.7V7c0-1.158.942-2.1 2.1-2.1ZM3.6 9.1a.7.7 0 0 0-.7.7v3.5h1.4V9.8a.7.7 0 0 0-.7-.7Zm4.9-5.6a.7.7 0 0 0-.7.7v9.1h1.4V4.2a.7.7 0 0 0-.7-.7Zm4.9 2.8a.7.7 0 0 0-.7.7v6.3h1.4V7a.7.7 0 0 0-.7-.7Z",
  fill: "currentColor"
}, null, -1), N0 = [
  L0
], P6 = /* @__PURE__ */ i({
  __name: "IconDataBarChart",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, N0, 14, A0));
  }
}), F0 = ["stroke-width"], G0 = ["strokeWidth"], T6 = /* @__PURE__ */ i({
  __name: "IconDataBarData",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9.53 11.281v-7.8m-3.861 7.8v-4.71m7.723 4.71V8.164M1.765 1.933v12.453h12.47"
      }, null, 8, G0)
    ], 14, F0));
  }
}), D0 = ["stroke-width"], E0 = ["strokeWidth"], U0 = ["strokeWidth"], O0 = ["strokeWidth"], R0 = ["strokeWidth"], j0 = ["strokeWidth"], q6 = /* @__PURE__ */ i({
  __name: "IconDataCloudDownload",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M4.346 11.757a3.055 3.055 0 1 1 0-6.11"
      }, null, 8, E0),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M3.647 6.405a4.371 4.371 0 1 1 8.742 0"
      }, null, 8, U0),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M11.654 11.757a3.055 3.055 0 1 0 0-6.11"
      }, null, 8, O0),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m5.608 11.877 2.409 2.408 2.408-2.408"
      }, null, 8, R0),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M8.017 14.285V8.86"
      }, null, 8, j0)
    ], 14, D0));
  }
}), P0 = ["stroke-width"], T0 = ["strokeWidth"], q0 = ["strokeWidth"], K0 = ["strokeWidth"], Q0 = ["strokeWidth"], X0 = ["strokeWidth"], K6 = /* @__PURE__ */ i({
  __name: "IconDataCloudUpload",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M4.346 11.757a3.055 3.055 0 1 1 0-6.11"
      }, null, 8, T0),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M3.647 6.405a4.371 4.371 0 1 1 8.742 0"
      }, null, 8, q0),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M11.654 11.757a3.055 3.055 0 1 0 0-6.11"
      }, null, 8, K0),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M10.426 11.269 8.017 8.86 5.61 11.27"
      }, null, 8, Q0),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M8.018 8.86v5.425"
      }, null, 8, X0)
    ], 14, P0));
  }
}), Y0 = ["stroke-width"], J0 = ["strokeWidth"], Q6 = /* @__PURE__ */ i({
  __name: "IconDataColumnChart",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9.355 13.716V3.809a1.35 1.35 0 1 0-2.699 0v9.907h2.7Zm-4.917 0V9.36a1.35 1.35 0 0 0-2.7 0v4.356h2.7Zm9.835 0V6.59a1.35 1.35 0 1 0-2.699 0v7.126h2.7Z"
      }, null, 8, J0)
    ], 14, Y0));
  }
}), t1 = ["stroke-width"], e1 = ["strokeWidth"], o1 = ["strokeWidth"], r1 = ["strokeWidth"], s1 = ["strokeWidth"], n1 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M8.794 11.916 6.224 9.67a.322.322 0 0 0-.46.036.336.336 0 0 0-.078.217v4.491a.33.33 0 0 0 .326.332.322.322 0 0 0 .212-.08l2.57-2.245a.337.337 0 0 0 0-.505Z"
}, null, -1), X6 = /* @__PURE__ */ i({
  __name: "IconDataDataInsert",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "3.409",
        cy: "2.932",
        r: "1.36",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, e1),
      n("circle", {
        cx: "12.59",
        cy: "2.932",
        r: "1.36",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, o1),
      n("circle", {
        cx: "12.59",
        cy: "12.168",
        r: "1.36",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, r1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.59 4.292v6.517M3.408 4.292v7.876h2.278"
      }, null, 8, s1),
      n1
    ], 14, t1));
  }
}), i1 = ["stroke-width"], l1 = ["strokeWidth"], a1 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m14.353 12.41.75-.007-.002-.307-.217-.216-.53.53Zm-2.12 2.12-.53.53.215.216.304.004.011-.75Zm2.14.03-.01.75.767.011-.007-.768-.75.007Zm-2.502-3.572 1.952 1.952 1.06-1.06-1.952-1.953-1.06 1.06ZM12.762 14l-1.952-1.953-1.06 1.061 1.952 1.952 1.06-1.06Zm.84-1.583.02 2.15 1.5-.014-.02-2.15-1.5.014Zm.78 1.393-2.14-.03-.02 1.5 2.14.03.02-1.5Z"
}, null, -1), c1 = ["strokeWidth"], Y6 = /* @__PURE__ */ i({
  __name: "IconDataDesign",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m3.487 5.785-2.26-2.26 2.12-2.12 2.26 2.26"
      }, null, 8, l1),
      a1,
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M1.153 11.515 11.337 1.331l3.397 3.396L4.549 14.91zM3.985 8.69l1.691 1.7m.572-3.964 1.69 1.7m.571-3.966 1.69 1.7"
      }, null, 8, c1)
    ], 14, i1));
  }
}), d1 = ["stroke-width"], p1 = ["strokeWidth"], h1 = ["strokeWidth"], u1 = ["strokeWidth"], J6 = /* @__PURE__ */ i({
  __name: "IconDataFlowline",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "3.098",
        cy: "3.277",
        r: "1.36",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, p1),
      n("circle", {
        cx: "12.903",
        cy: "13.042",
        r: "1.36",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, h1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M4.469 3.277h7.39a2.371 2.371 0 1 1 0 4.743H4.293a2.524 2.524 0 0 0 0 5.048h7.258"
      }, null, 8, u1)
    ], 14, d1));
  }
}), f1 = ["stroke-width"], _1 = ["strokeWidth"], y1 = ["strokeWidth"], t8 = /* @__PURE__ */ i({
  __name: "IconDataFoldingLineChart",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M1.599 1.72v12.84h12.848"
      }, null, 8, _1),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m4.64 8.98 3.446-3.445a.05.05 0 0 1 .07 0l2.635 2.634c.02.02.051.02.07 0l3.569-3.593"
      }, null, 8, y1)
    ], 14, f1));
  }
}), w1 = ["stroke-width"], g1 = ["strokeWidth"], e8 = /* @__PURE__ */ i({
  __name: "IconDataLineData",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.72 1.967H3.28a1.5 1.5 0 0 0-1.5 1.5v9.405a1.5 1.5 0 0 0 1.5 1.5h9.44a1.5 1.5 0 0 0 1.5-1.5V3.467a1.5 1.5 0 0 0-1.5-1.5ZM8 11.277V5.042m-3.106 6.235V8.159m6.211 3.118V9.7"
      }, null, 8, g1)
    ], 14, w1));
  }
}), v1 = ["stroke-width"], z1 = ["strokeWidth"], $1 = ["strokeWidth"], m1 = ["strokeWidth"], o8 = /* @__PURE__ */ i({
  __name: "IconDataMachineReview",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.851 1.876H3.15a1.5 1.5 0 0 0-1.5 1.5v6.15a1.5 1.5 0 0 0 1.5 1.5h9.702a1.5 1.5 0 0 0 1.5-1.5v-6.15a1.5 1.5 0 0 0-1.5-1.5Z"
      }, null, 8, z1),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m4.478 7.764 2.228-2.27a.05.05 0 0 1 .071 0l2.225 2.235c.02.02.05.02.07.001l2.451-2.335M1.78 14.442h12.44"
      }, null, 8, $1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M8 11.026v3.416"
      }, null, 8, m1)
    ], 14, v1));
  }
}), k1 = ["stroke-width"], S1 = ["strokeWidth"], x1 = ["strokeWidth"], C1 = ["strokeWidth"], r8 = /* @__PURE__ */ i({
  __name: "IconDataMultiServer",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.85 2.119H3.148a1.5 1.5 0 0 0-1.5 1.5v9.512a1.5 1.5 0 0 0 1.5 1.5h9.702a1.5 1.5 0 0 0 1.5-1.5V3.62a1.5 1.5 0 0 0-1.5-1.5Z"
      }, null, 8, S1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M1.648 6.315h12.703M1.648 10.513h12.703"
      }, null, 8, x1),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M4.525 4.214h4.137m2.844 0h0m0 4.2h0m0 4.199h0M4.525 8.414h4.137m-4.137 4.199h4.137"
      }, null, 8, C1)
    ], 14, k1));
  }
}), B1 = ["stroke-width"], M1 = ["strokeWidth"], s8 = /* @__PURE__ */ i({
  __name: "IconDataPeopleReview",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M8 2.609a2.63 2.63 0 1 1 0 5.26 2.63 2.63 0 0 1 0-5.26ZM2.749 14.55v-1.744a2.3 2.3 0 0 1 2.3-2.3h5.902a2.3 2.3 0 0 1 2.3 2.3v1.744a.1.1 0 0 1-.1.1H2.849a.1.1 0 0 1-.1-.1Z"
      }, null, 8, M1)
    ], 14, B1));
  }
}), Z1 = ["stroke-width"], I1 = ["strokeWidth"], b1 = ["strokeWidth"], n8 = /* @__PURE__ */ i({
  __name: "IconDataPieChart",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        strokeWidth: e.strokeWidth,
        d: "M5.26 2.44a6.304 6.304 0 0 0 2.77 11.97 6.309 6.309 0 0 0 5.657-3.512"
      }, null, 8, I1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M14.277 8.265A6.355 6.355 0 0 0 7.922 1.91v6.355h6.355Z"
      }, null, 8, b1)
    ], 14, Z1));
  }
}), W1 = ["stroke-width"], H1 = ["strokeWidth"], V1 = ["strokeWidth"], A1 = ["strokeWidth"], i8 = /* @__PURE__ */ i({
  __name: "IconDataPopData",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "9.751",
        cy: "4.983",
        r: "3.184",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, H1),
      n("circle", {
        cx: "4.802",
        cy: "11.288",
        r: "2.452",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, V1),
      n("circle", {
        cx: "11.842",
        cy: "12.714",
        r: "1.807",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, A1)
    ], 14, W1));
  }
}), L1 = ["stroke-width"], N1 = ["strokeWidth"], F1 = ["strokeWidth"], G1 = ["strokeWidth"], l8 = /* @__PURE__ */ i({
  __name: "IconDataServer",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.851 2.092H3.15a1.5 1.5 0 0 0-1.5 1.5v9.633a1.5 1.5 0 0 0 1.5 1.5h9.702a1.5 1.5 0 0 0 1.5-1.5V3.592a1.5 1.5 0 0 0-1.5-1.5Z"
      }, null, 8, N1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M1.65 8.375h12.702"
      }, null, 8, F1),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M4.525 5.627h4.137m2.844 0h0m0 5.573h0m-6.981 0h4.137"
      }, null, 8, G1)
    ], 14, L1));
  }
}), D1 = ["stroke-width"], E1 = ["strokeWidth"], U1 = ["strokeWidth"], O1 = ["strokeWidth"], a8 = /* @__PURE__ */ i({
  __name: "IconDataWeb",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.851 2.092H3.15a1.5 1.5 0 0 0-1.5 1.5v9.633a1.5 1.5 0 0 0 1.5 1.5h9.702a1.5 1.5 0 0 0 1.5-1.5V3.592a1.5 1.5 0 0 0-1.5-1.5Z"
      }, null, 8, E1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M1.65 6.341h12.702"
      }, null, 8, U1),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M4.491 4.154h0m2.122 0h0"
      }, null, 8, O1)
    ], 14, D1));
  }
}), R1 = ["stroke-width"], j1 = ["strokeWidth"], P1 = ["strokeWidth"], T1 = ["strokeWidth"], c8 = /* @__PURE__ */ i({
  __name: "IconDataWorkbench",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 17",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.851 2.092H3.15a1.5 1.5 0 0 0-1.5 1.5v6.15a1.5 1.5 0 0 0 1.5 1.5h9.702a1.5 1.5 0 0 0 1.5-1.5v-6.15a1.5 1.5 0 0 0-1.5-1.5Z"
      }, null, 8, j1),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m4.478 7.98 2.228-2.27a.05.05 0 0 1 .071 0l2.225 2.235c.02.02.05.02.07 0l2.451-2.335M1.78 14.658h12.44"
      }, null, 8, P1),
      n("path", {
        stroke: "currentColor",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M8 11.242v3.416"
      }, null, 8, T1)
    ], 14, R1));
  }
}), q1 = ["stroke-width"], K1 = ["strokeWidth"], d8 = /* @__PURE__ */ i({
  __name: "IconDirectionAscendingOrder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9.5 2.75H.75M9.5 8H.75m8.75 5.25H.75m12 1.5v-13l2.5 2.75"
      }, null, 8, K1)
    ], 14, q1));
  }
}), Q1 = ["stroke-width"], X1 = ["strokeWidth"], p8 = /* @__PURE__ */ i({
  __name: "IconDirectionBackToBottom",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M12.5 6.25 8 10.75l-4.5-4.5M8 .75v10M14.25 15H1.75"
      }, null, 8, X1)
    ], 14, Q1));
  }
}), Y1 = ["stroke-width"], J1 = ["strokeWidth"], h8 = /* @__PURE__ */ i({
  __name: "IconDirectionBackToRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m6.25 3.5 4.5 4.5-4.5 4.5M.75 8h10M15 1.75v12.5"
      }, null, 8, J1)
    ], 14, Y1));
  }
}), tn = ["stroke-width"], en = ["strokeWidth"], u8 = /* @__PURE__ */ i({
  __name: "IconDirectionBackToUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M3.5 9.75 8 5.25l4.5 4.5M8 15.25v-10M1.75 1h12.5"
      }, null, 8, en)
    ], 14, tn));
  }
}), on = ["stroke-width"], rn = ["strokeWidth"], f8 = /* @__PURE__ */ i({
  __name: "IconDirectionDescendingOrder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9.5 2.75H.75M9.5 8H.75m8.75 5.25H.75m12-11.5v13l2.5-2.75"
      }, null, 8, rn)
    ], 14, on));
  }
}), sn = ["stroke-width"], nn = ["strokeWidth"], _8 = /* @__PURE__ */ i({
  __name: "IconDirectionDownArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M11.5 10.5 7.75 14 4 10.5M7.75 2v12"
      }, null, 8, nn)
    ], 14, sn));
  }
}), ln = ["stroke-width"], an = ["strokeWidth"], cn = ["strokeWidth"], y8 = /* @__PURE__ */ i({
  __name: "IconDirectionDownCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.002",
        cy: "8.004",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, an),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m11 7-3 3-3-3"
      }, null, 8, cn)
    ], 14, ln));
  }
}), dn = ["stroke-width"], pn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m8.392 10.323 3.484-3.988a.5.5 0 0 0-.056-.713.522.522 0 0 0-.336-.122H4.516A.511.511 0 0 0 4 6.006a.5.5 0 0 0 .124.33l3.484 3.987a.523.523 0 0 0 .784 0Z"
}, null, -1), hn = [
  pn
], w8 = /* @__PURE__ */ i({
  __name: "IconDirectionDownFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, hn, 14, dn));
  }
}), un = ["stroke-width"], fn = ["strokeWidth"], _n = ["strokeWidth"], g8 = /* @__PURE__ */ i({
  __name: "IconDirectionDownLineCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.002",
        cy: "8.004",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, fn),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M10 7 8 9 6 7m2-3v5m-2 2h4"
      }, null, 8, _n)
    ], 14, un));
  }
}), yn = ["stroke-width"], wn = ["strokeWidth"], v8 = /* @__PURE__ */ i({
  __name: "IconDirectionDown",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m11 7-3 3-3-3"
      }, null, 8, wn)
    ], 14, yn));
  }
}), gn = ["stroke-width"], vn = ["strokeWidth"], z8 = /* @__PURE__ */ i({
  __name: "IconDirectionExchange",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M2 6.5h12l-4-4m4 7H2l4 4"
      }, null, 8, vn)
    ], 14, gn));
  }
}), zn = ["stroke-width"], $n = ["strokeWidth"], $8 = /* @__PURE__ */ i({
  __name: "IconDirectionExpand",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M1.871 6.121V1.88h4.243M14.243 10v4.242H10"
      }, null, 8, $n)
    ], 14, zn));
  }
}), mn = ["stroke-width"], kn = ["strokeWidth"], m8 = /* @__PURE__ */ i({
  __name: "IconDirectionLeftArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M5.5 11.5 2 7.75 5.5 4M14 7.75H2"
      }, null, 8, kn)
    ], 14, mn));
  }
}), Sn = ["stroke-width"], xn = ["strokeWidth"], Cn = ["strokeWidth"], k8 = /* @__PURE__ */ i({
  __name: "IconDirectionLeftCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "7.996",
        cy: "8.002",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        transform: "rotate(90 7.996 8.002)"
      }, null, 8, xn),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9 11 6 8l3-3"
      }, null, 8, Cn)
    ], 14, Sn));
  }
}), Bn = ["stroke-width"], Mn = ["strokeWidth"], S8 = /* @__PURE__ */ i({
  __name: "IconDirectionLeftDoubleArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M7 11 4 8l3-3m5 6L9 8l3-3"
      }, null, 8, Mn)
    ], 14, Bn));
  }
}), Zn = ["stroke-width"], In = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m5.677 8.392 3.988 3.484a.5.5 0 0 0 .713-.056.522.522 0 0 0 .122-.336V4.516A.511.511 0 0 0 9.994 4a.5.5 0 0 0-.33.124L5.678 7.608a.523.523 0 0 0 0 .784Z"
}, null, -1), bn = [
  In
], x8 = /* @__PURE__ */ i({
  __name: "IconDirectionLeftFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, bn, 14, Zn));
  }
}), Wn = ["stroke-width"], Hn = ["strokeWidth"], C8 = /* @__PURE__ */ i({
  __name: "IconDirectionLeft",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9 11 6 8l3-3"
      }, null, 8, Hn)
    ], 14, Wn));
  }
}), Vn = ["stroke-width"], An = ["strokeWidth"], B8 = /* @__PURE__ */ i({
  __name: "IconDirectionLogout",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M10.5 3.5 15 8l-4.5 4.5M5.75 8H15M.75 2.75v10.5"
      }, null, 8, An)
    ], 14, Vn));
  }
}), Ln = ["stroke-width"], Nn = ["strokeWidth"], Fn = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M5.312 9.424 3.262 8l2.05-1.424v2.848Z"
}, null, -1), M8 = /* @__PURE__ */ i({
  __name: "IconDirectionMenuFold",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        strokeWidth: e.strokeWidth,
        d: "M3.614 3.667h10M8.969 8h4.645M3.61 12.333h10.004"
      }, null, 8, Nn),
      Fn
    ], 14, Ln));
  }
}), Gn = ["stroke-width"], Dn = ["strokeWidth"], En = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  stroke: "currentColor",
  d: "M3.107 6.576 5.157 8l-2.05 1.424V6.576Z"
}, null, -1), Z8 = /* @__PURE__ */ i({
  __name: "IconDirectionMenuUnfold",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        strokeWidth: e.strokeWidth,
        d: "M3.614 3.667h10M8.969 8h4.645M3.61 12.333h10.004"
      }, null, 8, Dn),
      En
    ], 14, Gn));
  }
}), Un = ["stroke-width"], On = ["strokeWidth"], I8 = /* @__PURE__ */ i({
  __name: "IconDirectionNext",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M9 5.5V2l6 5.5-6 6v-4s-1.505-.492-3 0c-1.616.532-3.24 2.067-3.5 2.5C2.9 6.8 7 5.667 9 5.5Z"
      }, null, 8, On)
    ], 14, Un));
  }
}), Rn = ["stroke-width"], jn = ["strokeWidth"], b8 = /* @__PURE__ */ i({
  __name: "IconDirectionOrderArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m1.5 4.5 2.5-2 2.5 2M4 12.75V2.5m10.5 9-2.5 2-2.5-2M12 3.25V13.5"
      }, null, 8, jn)
    ], 14, Rn));
  }
}), Pn = ["stroke-width"], Tn = ["strokeWidth"], W8 = /* @__PURE__ */ i({
  __name: "IconDirectionOrder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m5.5 4.5 2.5-2 2.5 2m0 7-2.5 2-2.5-2"
      }, null, 8, Tn)
    ], 14, Pn));
  }
}), qn = ["stroke-width"], Kn = ["strokeWidth"], H8 = /* @__PURE__ */ i({
  __name: "IconDirectionPrevious",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M7 5.5V2L1 7.5l6 6v-4s1.505-.492 3 0c1.616.532 3.24 2.067 3.5 2.5C13.1 6.8 9 5.667 7 5.5Z"
      }, null, 8, Kn)
    ], 14, qn));
  }
}), Qn = ["stroke-width"], Xn = ["strokeWidth"], V8 = /* @__PURE__ */ i({
  __name: "IconDirectionRightArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M10.5 4.5 14 8.25 10.5 12M2 8.25h12"
      }, null, 8, Xn)
    ], 14, Qn));
  }
}), Yn = ["stroke-width"], Jn = ["strokeWidth"], ti = ["strokeWidth"], A8 = /* @__PURE__ */ i({
  __name: "IconDirectionRightCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.004",
        cy: "7.998",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        transform: "rotate(-90 8.004 7.998)"
      }, null, 8, Jn),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m7 5 3 3-3 3"
      }, null, 8, ti)
    ], 14, Yn));
  }
}), ei = ["stroke-width"], oi = ["strokeWidth"], L8 = /* @__PURE__ */ i({
  __name: "IconDirectionRightDoubleArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m9 5 3 3-3 3M4 5l3 3-3 3"
      }, null, 8, oi)
    ], 14, ei));
  }
}), ri = ["stroke-width"], si = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M10.323 7.608 6.335 4.124a.5.5 0 0 0-.713.056.522.522 0 0 0-.122.336v6.968c0 .285.227.516.506.516a.5.5 0 0 0 .33-.124l3.987-3.484a.523.523 0 0 0 0-.784Z"
}, null, -1), ni = [
  si
], N8 = /* @__PURE__ */ i({
  __name: "IconDirectionRightFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ni, 14, ri));
  }
}), ii = ["stroke-width"], li = ["strokeWidth"], F8 = /* @__PURE__ */ i({
  __name: "IconDirectionRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m7 5 3 3-3 3"
      }, null, 8, li)
    ], 14, ii));
  }
}), ai = ["stroke-width"], ci = ["strokeWidth"], G8 = /* @__PURE__ */ i({
  __name: "IconDirectionShrink",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M5.879 1.879v4.243H1.636m8.485 8.242v-4.242h4.243"
      }, null, 8, ci)
    ], 14, ai));
  }
}), di = ["stroke-width"], pi = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M6.821 7.608 2.833 4.124a.5.5 0 0 0-.713.056.522.522 0 0 0-.122.336v6.968c0 .285.227.516.506.516a.5.5 0 0 0 .33-.124L6.82 8.392a.523.523 0 0 0 0-.784Zm7.004 0L9.837 4.124a.5.5 0 0 0-.713.056.522.522 0 0 0-.122.336v6.968c0 .285.227.516.506.516a.5.5 0 0 0 .33-.124l3.987-3.484a.523.523 0 0 0 0-.784Z"
}, null, -1), hi = [
  pi
], D8 = /* @__PURE__ */ i({
  __name: "IconDirectionSkipNextFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, hi, 14, di));
  }
}), ui = ["stroke-width"], fi = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m9.179 8.392 3.987 3.484a.5.5 0 0 0 .714-.056.522.522 0 0 0 .122-.336V4.516A.511.511 0 0 0 13.496 4a.5.5 0 0 0-.33.124L9.18 7.608a.523.523 0 0 0 0 .784Zm-7.004 0 3.988 3.484a.5.5 0 0 0 .713-.056.522.522 0 0 0 .122-.336V4.516A.511.511 0 0 0 6.492 4a.5.5 0 0 0-.33.124L2.176 7.608a.523.523 0 0 0 0 .784Z"
}, null, -1), _i = [
  fi
], E8 = /* @__PURE__ */ i({
  __name: "IconDirectionSkipPreviousFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, _i, 14, ui));
  }
}), yi = ["stroke-width"], wi = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.5 10.005a.5.5 0 0 1 .5-.5h5.004a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5L11 11.004V15a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5v-4.995ZM7.503 7a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 6l4.003.001V2.005a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5V7Z",
  fill: "currentColor"
}, null, -1), gi = [
  wi
], U8 = /* @__PURE__ */ i({
  __name: "IconDirectionUnexpand",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, gi, 14, yi));
  }
}), vi = ["stroke-width"], zi = ["strokeWidth"], O8 = /* @__PURE__ */ i({
  __name: "IconDirectionUpArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M4.5 5.5 8.25 2 12 5.5M8.25 14V2"
      }, null, 8, zi)
    ], 14, vi));
  }
}), $i = ["stroke-width"], mi = ["strokeWidth"], ki = ["strokeWidth"], R8 = /* @__PURE__ */ i({
  __name: "IconDirectionUpCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "7.998",
        cy: "7.996",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        transform: "rotate(180 7.998 7.996)"
      }, null, 8, mi),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m5 9 3-3 3 3"
      }, null, 8, ki)
    ], 14, $i));
  }
}), Si = ["stroke-width"], xi = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "m8.392 14.323 3.484-3.988a.5.5 0 0 0-.056-.713.522.522 0 0 0-.336-.122H4.516a.511.511 0 0 0-.516.506.5.5 0 0 0 .124.33l3.484 3.987a.523.523 0 0 0 .784 0ZM7.608 1.677 4.124 5.665a.5.5 0 0 0 .056.713.522.522 0 0 0 .336.122h6.968A.511.511 0 0 0 12 5.994a.5.5 0 0 0-.124-.33L8.392 1.678a.523.523 0 0 0-.784 0Z"
}, null, -1), Ci = [
  xi
], j8 = /* @__PURE__ */ i({
  __name: "IconDirectionUpDownFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ci, 14, Si));
  }
}), Bi = ["stroke-width"], Mi = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M7.608 5.677 4.124 9.665a.5.5 0 0 0 .056.713.522.522 0 0 0 .336.122h6.968A.511.511 0 0 0 12 9.994a.5.5 0 0 0-.124-.33L8.392 5.678a.523.523 0 0 0-.784 0Z"
}, null, -1), Zi = [
  Mi
], P8 = /* @__PURE__ */ i({
  __name: "IconDirectionUpFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Zi, 14, Bi));
  }
}), Ii = ["stroke-width"], bi = ["strokeWidth"], Wi = ["strokeWidth"], T8 = /* @__PURE__ */ i({
  __name: "IconDirectionUpLineCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "7.998",
        cy: "7.996",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        transform: "rotate(180 7.998 7.996)"
      }, null, 8, bi),
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m6 9 2-2 2 2m-2 3V7m2-2H6"
      }, null, 8, Wi)
    ], 14, Ii));
  }
}), Hi = ["stroke-width"], Vi = ["strokeWidth"], q8 = /* @__PURE__ */ i({
  __name: "IconDirectionUp",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "m5 9 3-3 3 3"
      }, null, 8, Vi)
    ], 14, Hi));
  }
}), Ai = ["stroke-width"], Li = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h13Zm-3.5 5.748a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h6Zm4 6.252a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), Ni = [
  Li
], K8 = /* @__PURE__ */ i({
  __name: "IconEditorAlignCenter",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ni, 14, Ai));
  }
}), Fi = ["stroke-width"], Gi = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h13ZM8 7.752a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h6ZM15.5 14a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), Di = [
  Gi
], Q8 = /* @__PURE__ */ i({
  __name: "IconEditorAlignLeft1",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Di, 14, Fi));
  }
}), Ei = ["stroke-width"], Ui = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h6Zm7.5 4.5A.5.5 0 0 0 15 6H2a.5.5 0 0 0-.5.5V7a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-.5Zm-7 3.5a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V10Zm7 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), Oi = [
  Ui
], X8 = /* @__PURE__ */ i({
  __name: "IconEditorAlignLeft",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Oi, 14, Ei));
  }
}), Ri = ["stroke-width"], ji = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h13Zm0 5.752a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h6ZM15.5 14a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), Pi = [
  ji
], Y8 = /* @__PURE__ */ i({
  __name: "IconEditorAlignRight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Pi, 14, Ri));
  }
}), Ti = ["stroke-width"], qi = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m9.244.925 5.752 3.287a1 1 0 0 1 .504.868v6.84a1 1 0 0 1-.504.868l-5.752 3.287a1.5 1.5 0 0 1-1.488 0l-5.752-3.287a1 1 0 0 1-.504-.868V5.08a1 1 0 0 1 .504-.868L7.756.925a1.5 1.5 0 0 1 1.488 0ZM3.82 4.902l4.68 2.73 4.68-2.73L8.5 2.228 3.82 4.902ZM7.75 8.93 3 6.16v5.469l4.75 2.715V8.93Zm1.5 5.413V8.93L14 6.16v5.468l-4.75 2.716Z",
  fill: "currentColor"
}, null, -1), Ki = [
  qi
], J8 = /* @__PURE__ */ i({
  __name: "IconEditorArchive",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ki, 14, Ti));
  }
}), Qi = ["stroke-width"], Xi = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.25 15.5a.76.76 0 0 0 .743-.672l.007-.106V4.156l1.22 1.264a.731.731 0 0 0 1.06 0 .8.8 0 0 0 .073-1.012l-.073-.088-2.495-2.587a.762.762 0 0 0-.2-.151.725.725 0 0 0-.67 0 .758.758 0 0 0-.35.377.797.797 0 0 0-.058.213v.001a.815.815 0 0 0-.007.105v12.444c0 .43.336.778.75.778Zm-2.75-7c0-.414-.32-.75-.714-.75H1.214l-.097.007A.739.739 0 0 0 .5 8.5c0 .414.32.75.714.75h8.572l.097-.007A.739.739 0 0 0 10.5 8.5Zm-.714-6c.394 0 .714.336.714.75 0 .38-.269.693-.617.743L9.786 4H1.214C.82 4 .5 3.664.5 3.25c0-.38.269-.693.617-.743l.097-.007h8.572Zm.714 11.25c0-.414-.32-.75-.714-.75H1.214l-.097.007a.74.74 0 0 0-.617.743c0 .414.32.75.714.75h8.572l.097-.007a.74.74 0 0 0 .617-.743Z",
  fill: "currentColor"
}, null, -1), Yi = [
  Xi
], tf = /* @__PURE__ */ i({
  __name: "IconEditorAscendingOrder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Yi, 14, Qi));
  }
}), Ji = ["stroke-width"], tl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.793 4.35a.5.5 0 0 1-.35-.857L4.335.643a.5.5 0 0 1 .702 0l2.894 2.85a.5.5 0 0 1-.35.857H5.458v11.657a.5.5 0 0 1-.5.5h-.543a.5.5 0 0 1-.5-.5V4.35H1.793Zm13.343 5.455a.5.5 0 0 1 .47.327l.25.683a.5.5 0 0 1-.152.559l-4.26 3.495 4.056.001a.5.5 0 0 1 .5.5v.52a.5.5 0 0 1-.5.5H9.663a.5.5 0 0 1-.47-.327l-.25-.683a.5.5 0 0 1 .151-.559l4.26-3.498-4.055.001a.5.5 0 0 1-.5-.5v-.52a.5.5 0 0 1 .5-.5h5.837ZM11.688.507a.5.5 0 0 0-.473.34l-2.32 6.851a.5.5 0 0 0 .475.66h.572a.5.5 0 0 0 .474-.34l.73-2.156h2.484l.714 2.154a.5.5 0 0 0 .474.343h.613a.5.5 0 0 0 .473-.66L13.585.846a.5.5 0 0 0-.473-.34h-1.424Zm1.439 3.836h-1.468L12.4 2.15l.727 2.193Z",
  fill: "currentColor"
}, null, -1), el = [
  tl
], ef = /* @__PURE__ */ i({
  __name: "IconEditorAsendSort",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, el, 14, Ji));
  }
}), ol = ["stroke-width"], rl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.706.655a.723.723 0 0 0-.95.048l-.072.081a.742.742 0 0 0 .048.96l.738.782-4.114 4.157-.089.1a1.236 1.236 0 0 0 .089 1.635l3.683 3.723.099.09a1.205 1.205 0 0 0 1.618-.09l4.178-4.222.087-.097a1.237 1.237 0 0 0-.067-1.616L6.786.728l-.08-.073Zm-2.728 6.47L7.475 3.59l3.261 3.456-.076.077H3.978Zm8.534 2.131 1.03-1.15 1.031 1.15c.14.156.246.334.318.533a1.8 1.8 0 0 1 0 1.234 1.625 1.625 0 0 1-.318.532c-.14.156-.299.274-.478.355a1.33 1.33 0 0 1-1.105 0 1.437 1.437 0 0 1-.478-.355 1.639 1.639 0 0 1-.317-.533 1.785 1.785 0 0 1 0-1.233c.072-.2.178-.377.317-.533Z",
  fill: "currentColor"
}, null, -1), sl = [
  rl
], of = /* @__PURE__ */ i({
  __name: "IconEditorBackgroundColor",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, sl, 14, ol));
  }
}), nl = ["stroke-width"], il = /* @__PURE__ */ n("path", {
  d: "M14.9 14.1a.8.8 0 1 1 0 1.6H2.1a.8.8 0 0 1 0-1.6h12.8Zm-8.8-4a.8.8 0 0 1 0 1.6h-4a.8.8 0 0 1 0-1.6h4Zm9.37-3.765a.811.811 0 0 1 0 1.13l-3.647 3.726a.772.772 0 0 1-1.107 0L8.73 9.163a.811.811 0 0 1 0-1.132.77.77 0 0 1 1.107 0l1.433 1.464 3.093-3.16a.771.771 0 0 1 1.107 0ZM6.1 6.1a.8.8 0 1 1 0 1.6h-4a.8.8 0 0 1 0-1.6h4Zm8.8-4a.8.8 0 1 1 0 1.6H2.1a.8.8 0 0 1 0-1.6h12.8Z",
  fill: "currentColor"
}, null, -1), ll = [
  il
], rf = /* @__PURE__ */ i({
  __name: "IconEditorBatchAdjust",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ll, 14, nl));
  }
}), al = ["stroke-width"], cl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.684 2C11.792 2 13.5 3.623 13.5 5.625c0 1.085-.502 2.059-1.297 2.723l-.197.152.022.014c.846.627 1.407 1.585 1.467 2.668l.005.193c0 1.938-1.6 3.52-3.613 3.62L9.684 15H4.816c-.681 0-1.242-.492-1.31-1.122L3.5 13.75V3.25c0-.647.518-1.18 1.181-1.244L4.816 2h4.868ZM5.08 9.25v4.25h4.605c1.182 0 2.15-.87 2.231-1.973l.006-.152c0-1.123-.916-2.042-2.077-2.12l-.16-.005H5.08Zm0-1.5h4.605c1.236 0 2.237-.951 2.237-2.125 0-1.123-.916-2.042-2.077-2.12l-.16-.005H5.08v4.25Z",
  fill: "currentColor"
}, null, -1), dl = [
  cl
], sf = /* @__PURE__ */ i({
  __name: "IconEditorBold",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, dl, 14, al));
  }
}), pl = ["stroke-width"], hl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 13.5V9.25h4.75v4.25H3Zm6.25 0H14V9.25H9.25v4.25Zm0-5.75H14V3.5H9.25v4.25ZM7.75 3.5H3v4.25h4.75V3.5ZM15.5 3v11.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-12A.5.5 0 0 1 2 2h13a.5.5 0 0 1 .5.5V3Z",
  fill: "currentColor"
}, null, -1), ul = [
  hl
], nf = /* @__PURE__ */ i({
  __name: "IconEditorBorders",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ul, 14, pl));
  }
}), fl = ["stroke-width"], _l = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 15.5H5V14H3.5v1.5Zm4.264-2.024h1.5v-1.5h-1.5v1.5Zm0-2h1.5v-1.5h-1.5v1.5Zm1.502-2.25h-1.5v-1.5h1.5v1.5Zm-5.5 0h1.5v-1.5h-1.5v1.5Zm3.5 0h-1.5v-1.5h1.5v1.5Zm2.5 0h1.5v-1.5h-1.5v1.5Zm3.5 0h-1.5v-1.5h1.5v1.5Zm-5.502-2.25h1.5v-1.5h-1.5v1.5Zm1.5-2h-1.5v-1.5h1.5v1.5ZM7 15.5l-1.5.001V14H7v1.5Zm.75.001h1.5V14h-1.5v1.5Zm3.75 0H10V14h1.5v1.5Zm.5 0h1.5V14H12v1.5Zm3.5 0H14V14h1.5v1.5ZM5 3H3.5V1.5H5V3Zm2-.002L5.5 3V1.5H7v1.5ZM7.75 3h1.5v-1.5h-1.5V3Zm3.75 0H10v-1.5h1.5v1.5Zm.5 0h1.5v-1.5H12v1.5Zm3.5 0H14V1.5h1.5V3ZM3 13.5H1.5V12H3v1.5Zm0-2H1.5V10H3v1.5ZM1.503 9.25h1.5v-1.5h-1.5v1.5ZM3 6.999H1.5V5.5H3V7ZM1.5 5H3V3.5H1.5V5ZM14 13.5h1.5V12H14v1.5Zm0-2h1.5V10H14v1.5Zm1.503-2.25h-1.5v-1.5h1.5v1.5ZM14 6.999h1.5V5.5H14V7Zm1.5-2H14V3.5h1.5V5ZM3 3H1.5V1.5H3V3Z",
  fill: "currentColor"
}, null, -1), yl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 15.5h14V14h-14v1.5Z",
  fill: "currentColor"
}, null, -1), wl = [
  _l,
  yl
], lf = /* @__PURE__ */ i({
  __name: "IconEditorBottomBorder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, wl, 14, fl));
  }
}), gl = ["stroke-width"], vl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5.5a6 6 0 0 1 3.001 11.197L11.5 13.5h-6v-1.803A6 6 0 0 1 8.5.5Zm0 1.5a4.5 4.5 0 0 0-2.443 8.28l.194.119.75.433L7 12h3l.001-1.168.749-.434A4.5 4.5 0 0 0 8.5 2Zm3 13.5a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5v-.5ZM9.25 8.807l-.004 3.19-1.5-.001.004-3.182-1.428-1.43a.5.5 0 0 1 0-.707l.355-.354a.5.5 0 0 1 .707.001l1.113 1.115 1.119-1.117a.5.5 0 0 1 .707.001l.353.354a.5.5 0 0 1 0 .707L9.25 8.807Z",
  fill: "currentColor"
}, null, -1), zl = [
  vl
], af = /* @__PURE__ */ i({
  __name: "IconEditorBulb",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, zl, 14, gl));
  }
}), $l = ["stroke-width"], ml = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11 4H6v2a.5.5 0 0 1-.5.5H5a.5.5 0 0 1-.5-.5V4H3v3.5h11V4h-1.5v2a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 11 6V4Zm0-1.5H2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V3a.5.5 0 0 0-.5-.5h-4ZM14 9H3v5h11V9Z",
  fill: "currentColor"
}, null, -1), kl = [
  ml
], cf = /* @__PURE__ */ i({
  __name: "IconEditorCalender",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, kl, 14, $l));
  }
}), Sl = ["stroke-width"], xl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h13Zm0 11.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h13Zm.5-5.25a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-.5Z",
  fill: "currentColor"
}, null, -1), Cl = [
  xl
], df = /* @__PURE__ */ i({
  __name: "IconEditorCatalogue",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Cl, 14, Sl));
  }
}), Bl = ["stroke-width"], Ml = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 2.5a1 1 0 0 0-1-1h-12a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-12Zm-1.556.556v10.888H3.056V3.056h10.888Zm-2.542 2.668a.5.5 0 0 0-.705.047L7.943 8.917l-1.65-1.65a.5.5 0 0 0-.708 0l-.393.392a.5.5 0 0 0 0 .707l2.45 2.45a.5.5 0 0 0 .73-.025l3.495-3.995a.5.5 0 0 0-.047-.706l-.418-.366Z",
  fill: "currentColor"
}, null, -1), Zl = [
  Ml
], pf = /* @__PURE__ */ i({
  __name: "IconEditorCheckbox",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Zl, 14, Bl));
  }
}), Il = ["stroke-width"], bl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 1.5H1.5V3H3V1.5Zm6.263 2.023h-1.5v1.5h1.5v-1.5Zm0 2h-1.5v1.5h1.5v-1.5Zm-1.497 2.25h1.5v1.5h-1.5v-1.5Zm-2.5 0h-1.5v1.5h1.5v-1.5Zm.5 0h1.5v1.5h-1.5v-1.5Zm5.5 0h-1.5v1.5h1.5v-1.5Zm.498 0h1.5v1.5h-1.5v-1.5Zm-2.5 2.25h-1.5v1.5h1.5v-1.5Zm-1.5 2h1.5v1.5h-1.5v-1.5ZM3.5 1.5H5V3H3.5V1.5Zm3.5 0H5.5V3H7V1.5Zm.75 0h1.499V3h-1.5V1.5Zm3.749 0h-1.5V3h1.5V1.5Zm.5 0h1.499V3h-1.5V1.5Zm3.498 0h-1.5V3h1.5V1.5ZM5 14H3.5v1.5H5V14Zm2 0H5.5v1.5H7V14Zm.75 0h1.5v1.5h-1.5V14Zm3.749 0h-1.5v1.5h1.5V14Zm.5 0h1.5v1.5h-1.5V14Zm3.499 0h-1.5v1.5h1.5V14ZM3 3.5H1.5V5H3V3.5Zm0 2H1.5V7H3V5.5ZM1.503 7.75h1.5v1.5h-1.5v-1.5ZM3 10H1.5v1.5H3V10Zm-1.5 2H3v1.5H1.5V12Zm12.498-8.5h1.5V5h-1.5V3.5Zm0 2h1.5V7h-1.5V5.5ZM15.5 7.75H14v1.5h1.5v-1.5ZM13.998 10h1.5v1.5h-1.5V10Zm1.5 2h-1.5v1.5h1.5V12ZM3 14H1.5v1.5H3V14Z",
  fill: "currentColor"
}, null, -1), Wl = [
  bl
], hf = /* @__PURE__ */ i({
  __name: "IconEditorClearBorders",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Wl, 14, Il));
  }
}), Hl = ["stroke-width"], Vl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 2a.5.5 0 0 0-.5.5v12a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-12A.5.5 0 0 0 15 2H2Zm1 1.5v10h11v-10H3Z",
  fill: "currentColor"
}, null, -1), Al = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.121 6.707a.5.5 0 0 0 0 .707l1.415 1.415-1.414 1.413a.5.5 0 0 0 0 .708l.353.353a.5.5 0 0 0 .707 0l2.475-2.475-1.06-1.06-1.415-1.415a.5.5 0 0 0-.707 0l-.354.354Z",
  fill: "currentColor"
}, null, -1), Ll = /* @__PURE__ */ n("rect", {
  x: "12",
  y: "10.25",
  width: "1.5",
  height: "3",
  rx: ".5",
  transform: "rotate(90 12 10.25)",
  fill: "currentColor"
}, null, -1), Nl = [
  Vl,
  Al,
  Ll
], uf = /* @__PURE__ */ i({
  __name: "IconEditorCodeSquare",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Nl, 14, Hl));
  }
}), Fl = ["stroke-width"], Gl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 3.5v10h11v-10H3ZM15.5 14v.5a.5.5 0 0 1-.5.5H2c-.017 0-.034 0-.051-.003A.5.5 0 0 1 1.5 14.5v-12A.5.5 0 0 1 2 2h13a.5.5 0 0 1 .5.5V14ZM5 6a.5.5 0 0 0-.5.5V7a.5.5 0 0 0 .5.5h3.293l-1.429 2H5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.793l-.548.768a.5.5 0 0 0 .116.697l.407.29a.5.5 0 0 0 .697-.116L7.636 11H12a.5.5 0 0 0 .5-.5V10a.5.5 0 0 0-.5-.5H8.708l1.428-2H12a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 12 6h-.792l.548-.767a.5.5 0 0 0-.116-.698l-.407-.29a.5.5 0 0 0-.698.116L9.365 6H5Z",
  fill: "currentColor"
}, null, -1), Dl = [
  Gl
], ff = /* @__PURE__ */ i({
  __name: "IconEditorCondition",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Dl, 14, Fl));
  }
}), El = ["stroke-width"], Ul = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.994 3.106A1.75 1.75 0 0 0 13.25 1.5h-7l-.144.006A1.75 1.75 0 0 0 4.5 3.25v.5H6v-.5l.007-.057A.25.25 0 0 1 6.25 3h7l.057.007a.25.25 0 0 1 .193.243v7l-.007.057a.25.25 0 0 1-.243.193h-.5V12h.5l.143-.006A1.75 1.75 0 0 0 15 10.25v-7l-.006-.144ZM9.75 4.5h-6A2.25 2.25 0 0 0 1.5 6.75v6A2.25 2.25 0 0 0 3.75 15h6A2.25 2.25 0 0 0 12 12.75v-6A2.25 2.25 0 0 0 9.75 4.5Zm-6 1.5h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 3.75 6Z",
  fill: "currentColor"
}, null, -1), Ol = [
  Ul
], _f = /* @__PURE__ */ i({
  __name: "IconEditorCopy",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ol, 14, El));
  }
}), Rl = ["stroke-width"], jl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.677 2.396a.5.5 0 0 1 .707 0L8.5 6.513l4.116-4.117a.5.5 0 0 1 .707 0l.354.354a.5.5 0 0 1 0 .707L9.56 7.573l1.415 1.416a3 3 0 1 1-1.06 1.06L8.5 8.634l-1.415 1.415a3 3 0 1 1-1.06-1.06l1.414-1.416-4.116-4.116a.5.5 0 0 1 0-.707l.354-.354Zm.823 7.677a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Zm8 0a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3Z",
  fill: "currentColor"
}, null, -1), Pl = [
  jl
], yf = /* @__PURE__ */ i({
  __name: "IconEditorCut",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Pl, 14, Rl));
  }
}), Tl = ["stroke-width"], ql = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 2H2a.5.5 0 0 0-.5.5v5A.5.5 0 0 0 2 8h4a.5.5 0 0 0 .5-.5V7a.5.5 0 0 0-.5-.5H3v-3h8a.5.5 0 0 0 .5-.5v-.5A.5.5 0 0 0 11 2h-1Zm4.207.354a.5.5 0 0 1 .707 0l.354.353a.5.5 0 0 1 0 .707L10.59 8.091a.75.75 0 0 1-.977.073L9.53 8.09 7.354 5.914a.5.5 0 0 1 0-.707l.353-.353a.5.5 0 0 1 .707 0L10.061 6.5l4.146-4.146ZM15 9a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-5A.5.5 0 0 1 2 9h13Zm-1 1.5H3v3h11v-3Z",
  fill: "currentColor"
}, null, -1), Kl = [
  ql
], wf = /* @__PURE__ */ i({
  __name: "IconEditorDataCheck",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Kl, 14, Tl));
  }
}), Ql = ["stroke-width"], Xl = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 2.5A.5.5 0 0 1 2 2h13a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-12Zm1.5 11v-10h11v10H3Zm5.25-8a.5.5 0 0 0-.5.5v5a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V6a.5.5 0 0 0-.5-.5h-.5ZM5 7.5a.5.5 0 0 0-.5.5v3a.5.5 0 0 0 .5.5h.5A.5.5 0 0 0 6 11V8a.5.5 0 0 0-.5-.5H5ZM11 9a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V9Z",
  fill: "currentColor"
}, null, -1), Yl = [
  Xl
], gf = /* @__PURE__ */ i({
  __name: "IconEditorData",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Yl, 14, Ql));
  }
}), Jl = ["stroke-width"], t5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 2.5A.5.5 0 0 0 15 2H2a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-.5ZM15 6a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 10 6h5Zm0 3.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-5a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .5-.5h5Zm0 4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h13Zm-9.5-7a.5.5 0 0 0-.8-.4l-2.667 2a.5.5 0 0 0 0 .8l2.667 2a.5.5 0 0 0 .8-.4v-4Z",
  fill: "currentColor"
}, null, -1), e5 = [
  t5
], vf = /* @__PURE__ */ i({
  __name: "IconEditorDedent",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, e5, 14, Jl));
  }
}), o5 = ["stroke-width"], r5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.25 1.5a.76.76 0 0 1 .743.672l.007.106v10.566l1.22-1.264a.731.731 0 0 1 1.06 0 .8.8 0 0 1 .073 1.012l-.073.088-2.495 2.587a.762.762 0 0 1-.2.151.725.725 0 0 1-.81-.093.77.77 0 0 1-.21-.284.798.798 0 0 1-.058-.213v-.001a.814.814 0 0 1-.007-.105V2.278c0-.43.336-.778.75-.778ZM9.786 7.75c.394 0 .714.336.714.75 0 .38-.269.693-.617.743l-.097.007H1.214C.82 9.25.5 8.914.5 8.5c0-.38.269-.693.617-.743l.097-.007h8.572Zm0-5.25c.394 0 .714.336.714.75 0 .38-.269.693-.617.743L9.786 4H1.214C.82 4 .5 3.664.5 3.25c0-.38.269-.693.617-.743l.097-.007h8.572Zm.714 11.25c0-.414-.32-.75-.714-.75H1.214l-.097.007a.74.74 0 0 0-.617.743c0 .414.32.75.714.75h8.572l.097-.007a.74.74 0 0 0 .617-.743Z",
  fill: "currentColor"
}, null, -1), s5 = [
  r5
], zf = /* @__PURE__ */ i({
  __name: "IconEditorDescendingOrder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, s5, 14, o5));
  }
}), n5 = ["stroke-width"], i5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m9 2.25 1.937 1.877L12.5 2.25h1l1.763 2.14a.5.5 0 0 1-.073.708l-.385.308a.5.5 0 0 1-.703-.078L13 3.95l-1.5 1.8h-1L8.561 3.872 7 5.75H6L4.438 3.872 2.884 5.427a.5.5 0 0 1-.707 0l-.35-.35a.5.5 0 0 1 .005-.71L4 2.25h1l1.5 1.799L8 2.25h1Zm-4.5 11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h2.5Zm5 0a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h2Zm6 .5a.5.5 0 0 0-.5-.5h-2.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5H15a.5.5 0 0 0 .5-.5v-.5Zm0-4.75a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V9Z",
  fill: "currentColor"
}, null, -1), l5 = [
  i5
], $f = /* @__PURE__ */ i({
  __name: "IconEditorDivider",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, l5, 14, n5));
  }
}), a5 = ["stroke-width"], c5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.97.651c.174-.179.444-.199.639-.06l.069.06 3.182 3.291a.53.53 0 0 1 .058.66l-.058.071-7.468 7.723H2.003a.505.505 0 0 1-.492-.424l-.008-.093V8.374L8.971.65Zm.355 1.828L3.003 9.016v1.828h1.768l6.322-6.537-1.768-1.828ZM15.5 14.466a.509.509 0 0 0-.5-.517H2c-.276 0-.5.231-.5.517v.517c0 .285.224.517.5.517h13c.276 0 .5-.232.5-.517v-.517Z",
  fill: "currentColor"
}, null, -1), d5 = [
  c5
], mf = /* @__PURE__ */ i({
  __name: "IconEditorEdit",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, d5, 14, a5));
  }
}), p5 = ["stroke-width"], h5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 .5c.276 0 .5.256.5.571V15.93c0 .315-.224.571-.5.571h-.5c-.276 0-.5-.256-.5-.571V1.07C1 .756 1.224.5 1.5.5H2Zm13.5 0c.276 0 .5.256.5.571V15.93c0 .315-.224.571-.5.571H15c-.276 0-.5-.256-.5-.571V1.07c0-.315.224-.571.5-.571h.5ZM8.064 3.066a4.857 4.857 0 0 1 4.852 4.621l.005.236v.602a4.255 4.255 0 0 1-4.028 4.25l-.226.005h-.238v2.256a.571.571 0 0 1-.975.403l-3.192-3.192a.571.571 0 0 1 0-.808l3.193-3.192a.571.571 0 0 1 .976.405l-.001 2.414h.238a2.542 2.542 0 0 0 2.535-2.36l.005-.182v-.601a3.143 3.143 0 0 0-2.95-3.137l-.193-.006H6.952a.571.571 0 0 1-.571-.571v-.572c0-.315.256-.571.571-.571h1.112Z",
  fill: "currentColor"
}, null, -1), u5 = [
  h5
], kf = /* @__PURE__ */ i({
  __name: "IconEditorEnter",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, u5, 14, p5));
  }
}), f5 = ["stroke-width"], _5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m1.566 10.116 7.792-7.793a1.25 1.25 0 0 1 1.768 0l4.3 4.3a1.25 1.25 0 0 1 .016 1.75L10.506 13.5h4.736a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H5.002a.75.75 0 0 1-.53-.219l-2.905-2.897c-.43-.428-.487-1.1-.105-1.649l.104-.12Zm8.485 1.693-4.03-4.03-3.22 3.217 2.51 2.504h3.112l1.628-1.691Z",
  fill: "currentColor"
}, null, -1), y5 = [
  _5
], Sf = /* @__PURE__ */ i({
  __name: "IconEditorEraser",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, y5, 14, f5));
  }
}), w5 = ["stroke-width"], g5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.462 9.809c.038.092.038.208.038.441v4.5c0 .233 0 .35-.038.441a.5.5 0 0 1-.27.27c-.092.039-.209.039-.442.039h-4.5c-.233 0-.35 0-.441-.038a.5.5 0 0 1-.27-.27C9.5 15.1 9.5 14.982 9.5 14.75s0-.35.038-.441a.5.5 0 0 1 .27-.27c.093-.039.209-.039.442-.039H14v-3.75c0-.233 0-.35.038-.441a.5.5 0 0 1 .27-.27c.092-.039.209-.039.442-.039s.35 0 .441.038a.5.5 0 0 1 .27.27ZM1.5 6.75c0 .233 0 .35.038.441a.5.5 0 0 0 .27.27c.093.039.209.039.442.039s.35 0 .441-.038a.5.5 0 0 0 .27-.27C3 7.098 3 6.982 3 6.75V3h3.75c.233 0 .35 0 .441-.038a.5.5 0 0 0 .27-.27c.039-.093.039-.209.039-.442s0-.35-.038-.441a.5.5 0 0 0-.27-.27C7.098 1.5 6.982 1.5 6.75 1.5h-4.5c-.233 0-.35 0-.441.038a.5.5 0 0 0-.27.27c-.039.093-.039.209-.039.442v4.5Z",
  fill: "currentColor"
}, null, -1), v5 = [
  g5
], xf = /* @__PURE__ */ i({
  __name: "IconEditorExpand",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, v5, 14, w5));
  }
}), z5 = ["stroke-width"], $5 = /* @__PURE__ */ n("path", {
  d: "M2.404 2.405a.7.7 0 0 1 .99 0l11.203 11.203a.7.7 0 1 1-.99.99l-1.56-1.559c-1.076.688-2.283 1.064-3.547 1.064-2.962 0-5.622-2.044-6.953-5.342a.734.734 0 0 1 0-.518c.556-1.38 1.345-2.533 2.29-3.414L2.404 3.395a.7.7 0 0 1 0-.99Zm2.422 3.412c-.755.691-1.398 1.6-1.871 2.685 1.14 2.598 3.242 4.2 5.545 4.2.887 0 1.744-.238 2.526-.684l-1.114-1.115c-.417.246-.894.4-1.412.4a2.8 2.8 0 0 1-2.8-2.801c0-.518.152-.995.398-1.412L4.826 5.817ZM8.5 2.9c2.962 0 5.623 2.045 6.953 5.343a.733.733 0 0 1 0 .518 9.752 9.752 0 0 1-1.604 2.696l-.994-.995a8.413 8.413 0 0 0 1.19-1.96C12.905 5.904 10.803 4.3 8.5 4.3a4.88 4.88 0 0 0-1.554.252L5.86 3.468A6.447 6.447 0 0 1 8.5 2.9ZM7.148 8.14a1.404 1.404 0 0 0 1.715 1.715L7.148 8.139ZM8.5 5.7a2.8 2.8 0 0 1 2.773 3.179L8.122 5.73c.126-.022.252-.029.378-.029Z",
  fill: "currentColor"
}, null, -1), m5 = [
  $5
], Cf = /* @__PURE__ */ i({
  __name: "IconEditorEyeInvisible",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, m5, 14, z5));
  }
}), k5 = ["stroke-width"], S5 = /* @__PURE__ */ n("path", {
  d: "m1.5 8.5-.742-.106-.016.106.016.106L1.5 8.5Zm13.858 0 .743.106.015-.106-.015-.106-.743.106Zm-13.116.106A6.252 6.252 0 0 1 8.43 3.25v-1.5A7.752 7.752 0 0 0 .758 8.394l1.484.212ZM8.43 3.25a6.252 6.252 0 0 1 6.187 5.356l1.485-.212A7.752 7.752 0 0 0 8.429 1.75v1.5Zm6.187 5.144a6.252 6.252 0 0 1-6.187 5.356v1.5a7.752 7.752 0 0 0 7.672-6.644l-1.485-.212ZM8.429 13.75a6.252 6.252 0 0 1-6.187-5.356l-1.484.212a7.752 7.752 0 0 0 7.671 6.644v-1.5Z",
  fill: "currentColor"
}, null, -1), x5 = ["strokeWidth"], Bf = /* @__PURE__ */ i({
  __name: "IconEditorEye",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      S5,
      n("circle", {
        cx: "8.429",
        cy: "8.5",
        r: "2",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, x5)
    ], 14, k5));
  }
}), C5 = ["stroke-width"], B5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.5 5.5a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-.25v2.25H9.5V12.5a2 2 0 0 1 2-2h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-1.855-1.25H4.75a1 1 0 0 1-.993-.883l-.007-.117V11.5H3.5a2 2 0 0 1-2-2v-2a2 2 0 0 1 2-2h.25V2.75a1 1 0 0 1 .883-.993l.117-.007 4.896-.001A2 2 0 0 1 11.5.5h2a2 2 0 0 1 2 2v2a2 2 0 0 1-2 2h-2a2 2 0 0 1-2-2V3.25H5.25V5.5h.25Zm5.5 7v2a.5.5 0 0 0 .41.492l.09.008h2a.5.5 0 0 0 .492-.41L14 14.5v-2a.5.5 0 0 0-.41-.492L13.5 12h-2a.5.5 0 0 0-.492.41L11 12.5Zm0-10v2a.5.5 0 0 0 .41.492L11.5 5h2a.5.5 0 0 0 .492-.41L14 4.5v-2a.5.5 0 0 0-.41-.492L13.5 2h-2a.5.5 0 0 0-.492.41L11 2.5Zm-8 5v2a.5.5 0 0 0 .41.492L3.5 10h2a.5.5 0 0 0 .492-.41L6 9.5v-2a.5.5 0 0 0-.41-.492L5.5 7h-2a.5.5 0 0 0-.492.41L3 7.5Z",
  fill: "currentColor"
}, null, -1), M5 = [
  B5
], Mf = /* @__PURE__ */ i({
  __name: "IconEditorFlowchart",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, M5, 14, C5));
  }
}), Z5 = ["stroke-width"], I5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m8.811 3.75-2-2H2.5A1.75 1.75 0 0 0 .75 3.5v10c0 .966.784 1.75 1.75 1.75h12a1.75 1.75 0 0 0 1.75-1.75v-8l-.006-.144A1.75 1.75 0 0 0 14.5 3.75H8.811Zm-2.622-.5 2 2H14.5a.25.25 0 0 1 .25.25v8a.25.25 0 0 1-.25.25h-12a.25.25 0 0 1-.25-.25v-10a.25.25 0 0 1 .25-.25h3.689Z",
  fill: "currentColor"
}, null, -1), b5 = [
  I5
], Zf = /* @__PURE__ */ i({
  __name: "IconEditorFolder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, b5, 14, Z5));
  }
}), W5 = ["stroke-width"], H5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.84 1.5h1.441L13 11.5h-1.44l-1.271-3.42H6.712L5.44 11.5H4l3.717-9.996h.125L7.841 1.5ZM7.3 6.502H9.7L8.5 3.272l-1.201 3.23Z",
  fill: "currentColor"
}, null, -1), V5 = /* @__PURE__ */ n("path", {
  d: "M13 13a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H4a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 4 13h9Z",
  fill: "currentColor"
}, null, -1), A5 = [
  H5,
  V5
], If = /* @__PURE__ */ i({
  __name: "IconEditorFontColor",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, A5, 14, W5));
  }
}), L5 = ["stroke-width"], N5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 1.75a.25.25 0 0 1 .25-.25h9.5a.25.25 0 0 1 .25.25v1h2c.647 0 1.18.492 1.243 1.122L15.75 4v3.5a1.25 1.25 0 0 1-1.122 1.244l-.128.006H8.25v1.75h.725c.014 0 .025.011.025.025V14a1.5 1.5 0 0 1-3 0v-3.475c0-.014.011-.025.025-.025h.725v-2c0-.647.492-1.18 1.122-1.244L8 7.25h6.25v-3H12.5v1a.25.25 0 0 1-.25.25h-9.5a.25.25 0 0 1-.25-.25v-3.5Z",
  fill: "currentColor"
}, null, -1), F5 = [
  N5
], bf = /* @__PURE__ */ i({
  __name: "IconEditorFormatPainter",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, F5, 14, L5));
  }
}), G5 = ["stroke-width"], D5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.136 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H5.113l5.544 4.265a.5.5 0 0 1 .195.396v.68a.5.5 0 0 1-.195.395l-5.545 4.265h9.026a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H3.363a.5.5 0 0 1-.472-.337l-.228-.66a.5.5 0 0 1 .166-.559l6.379-4.944-6.379-4.945a.5.5 0 0 1-.166-.558l.228-.66A.5.5 0 0 1 3.363 2h10.774Z",
  fill: "currentColor"
}, null, -1), E5 = [
  D5
], Wf = /* @__PURE__ */ i({
  __name: "IconEditorFormula",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, E5, 14, G5));
  }
}), U5 = ["stroke-width"], O5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 2a.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2Zm6.999 1v11h5.5V3h-5.5ZM3 8.708v1.586L6.706 14h.293v-1.293L3 8.708Zm0-3v1.586l3.999 3.999V9.707L3 5.708ZM3 3v1.294l3.999 3.999V6.707L3.292 3H3Zm1.706 0 2.293 2.293V3H4.706ZM3 11.708V14h2.292L3 11.708Z",
  fill: "currentColor"
}, null, -1), R5 = [
  O5
], Hf = /* @__PURE__ */ i({
  __name: "IconEditorFreezeColumn",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, R5, 14, U5));
  }
}), j5 = ["stroke-width"], P5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3 13.5v-.793l4.5-4.5v1.586L3.793 13.5H3Zm-1.5.5V2.5A.5.5 0 0 1 2 2h13a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V14Zm7.5-.5h5v-5H9v5Zm-1.5 0H5.207L7.5 11.207V13.5Zm3.293-10L3 11.293V9.707L9.207 3.5h1.586Zm-3 0L3 8.293V6.707L6.207 3.5h1.586Zm-3 0L3 5.293V3.5h1.793ZM14 4.707V7h-2.293L14 4.707ZM8.707 7h1.586l3.5-3.5h-1.586L8.707 7Z",
  fill: "currentColor"
}, null, -1), T5 = [
  P5
], Vf = /* @__PURE__ */ i({
  __name: "IconEditorFreezeColumns",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, T5, 14, j5));
  }
}), q5 = ["stroke-width"], K5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 1.5a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h13Zm-1 6.999H3v5.5h11v-5.5ZM8.292 3H6.706L3 6.706v.293h1.293L8.292 3Zm3 0H9.706L5.707 6.999h1.586L11.292 3ZM14 3h-1.294L8.707 6.999h1.586L14 3.292V3Zm0 1.706-2.293 2.293H14V4.706ZM5.292 3H3v2.292L5.292 3Z",
  fill: "currentColor"
}, null, -1), Q5 = [
  K5
], Af = /* @__PURE__ */ i({
  __name: "IconEditorFreezeRow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Q5, 14, q5));
  }
}), X5 = ["stroke-width"], Y5 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.5 2a.75.75 0 0 1 .743.648l.007.102V8h6.5V2.75a.75.75 0 0 1 1.493-.102l.007.102v12a.75.75 0 0 1-1.493.102l-.007-.102V9.5h-6.5v5.25a.75.75 0 0 1-1.493.102l-.007-.102v-12A.75.75 0 0 1 4.5 2Z",
  fill: "currentColor"
}, null, -1), J5 = [
  Y5
], Lf = /* @__PURE__ */ i({
  __name: "IconEditorHeader",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, J5, 14, X5));
  }
}), ta = ["stroke-width"], ea = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 2.5v12a.5.5 0 0 0 .5.5h12.97a.5.5 0 0 0 .5-.5v-3l.03-.03-.03-.03V2.5a.5.5 0 0 0-.5-.5H2a.498.498 0 0 0-.5.5Zm12.473 11v-1.44l-2.042-2.045-2.468 2.061a.747.747 0 0 1-.922.029l-.087-.075-2.499-2.504-2.958 2.595V13.5h10.976Zm0-3.56V3.5H2.997v6.628l2.5-2.192a.747.747 0 0 1 .934-.042l.088.076 2.51 2.514 2.469-2.06a.747.747 0 0 1 .921-.029l.087.075 1.467 1.47ZM10.979 7.5c.827 0 1.497-.672 1.497-1.5s-.67-1.5-1.497-1.5c-.826 0-1.497.672-1.497 1.5s.67 1.5 1.497 1.5Z",
  fill: "currentColor"
}, null, -1), oa = [
  ea
], Nf = /* @__PURE__ */ i({
  __name: "IconEditorImage",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, oa, 14, ta));
  }
}), ra = ["stroke-width"], sa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 2.5A.5.5 0 0 0 15 2H2a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-.5ZM15 6a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 9 6h6Zm0 3.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H9a.5.5 0 0 1-.5-.5V10a.5.5 0 0 1 .5-.5h6Zm0 4a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h13Zm-13.5-7a.5.5 0 0 1 .8-.4l2.667 2a.5.5 0 0 1 0 .8l-2.667 2a.5.5 0 0 1-.8-.4v-4Z",
  fill: "currentColor"
}, null, -1), na = [
  sa
], Ff = /* @__PURE__ */ i({
  __name: "IconEditorIndent",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, na, 14, ra));
  }
}), ia = ["stroke-width"], la = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 1.5H3V3H1.5V1.5Zm2 0H5V3H3.5V1.5Zm3.5 0H5.5V3H7V1.5Zm.75 0h1.499V3h-1.5V1.5Zm3.749 0h-1.5V3h1.5V1.5Zm.5 0h1.499V3h-1.5V1.5Zm3.498 0h-1.5V3h1.5V1.5ZM5 14H3.5v1.5H5V14Zm2 0H5.5v1.5H7V14Zm.75 0h1.5v1.5h-1.5V14Zm3.749 0h-1.5v1.5h1.5V14Zm.5 0h1.5v1.5h-1.5V14Zm3.499 0h-1.5v1.5h1.5V14ZM3 3.5H1.5V5H3V3.5Zm0 2H1.5V7H3V5.5ZM1.503 7.75h1.5v1.5h-1.5v-1.5ZM3 10H1.5v1.5H3V10Zm-1.5 2H3v1.5H1.5V12Zm12.498-8.5h1.5V5h-1.5V3.5Zm0 2h1.5V7h-1.5V5.5ZM15.5 7.75H14v1.5h1.5v-1.5ZM13.998 10h1.5v1.5h-1.5V10Zm1.5 2h-1.5v1.5h1.5V12ZM3 14H1.5v1.5H3V14Z",
  fill: "currentColor"
}, null, -1), aa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.273 3.5h-1.5v4.251H3.5v1.5h4.272V13.5h1.5V9.251H13.5v-1.5H9.273V3.5Z",
  fill: "currentColor"
}, null, -1), ca = [
  la,
  aa
], Gf = /* @__PURE__ */ i({
  __name: "IconEditorInnerBorders",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ca, 14, ia));
  }
}), da = ["stroke-width"], pa = /* @__PURE__ */ n("path", {
  d: "M14.499 7.157V9.37L9.37 14.5H7.156L14.5 7.157Zm0-5.457v2.214L3.913 14.5H1.7L14.5 1.7Z",
  fill: "currentColor"
}, null, -1), ha = [
  pa
], Df = /* @__PURE__ */ i({
  __name: "IconEditorInputDrag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ha, 14, da));
  }
}), ua = ["stroke-width"], fa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.993 2.398A.75.75 0 0 0 .5 2.5v12l.007.102A.75.75 0 0 0 2 14.5V9.25h6.5v5.25l.007.102A.75.75 0 0 0 10 14.5v-12l-.007-.102A.75.75 0 0 0 8.5 2.5v5.25H2V2.5l-.007-.102Zm14.519 7.6a.75.75 0 0 0-.75-.75h-3l-.102.008a.75.75 0 0 0 .102 1.493h.564l-.666 3h-.898l-.102.007a.75.75 0 0 0 .102 1.493h3l.101-.007a.75.75 0 0 0-.101-1.493h-.566l.667-3h.899l.101-.007a.75.75 0 0 0 .649-.743Z",
  fill: "currentColor"
}, null, -1), _a = [
  fa
], Ef = /* @__PURE__ */ i({
  __name: "IconEditorItalicHeader",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, _a, 14, ua));
  }
}), ya = ["stroke-width"], wa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.5 2.5A.5.5 0 0 0 13 2H6a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5v-.5Zm-2 11.5a.5.5 0 0 0-.5-.5H4a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h7a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), ga = /* @__PURE__ */ n("path", {
  d: "M9.123 2.483a.5.5 0 0 1 .612-.354l.483.13a.5.5 0 0 1 .354.612L7.578 14.043a.5.5 0 0 1-.612.353l-.483-.13a.5.5 0 0 1-.354-.612L9.123 2.483Z",
  fill: "currentColor"
}, null, -1), va = [
  wa,
  ga
], Uf = /* @__PURE__ */ i({
  __name: "IconEditorItalic",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, va, 14, ya));
  }
}), za = ["stroke-width"], $a = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M16.5 4.786A2.286 2.286 0 0 0 14.214 2.5H2.786A2.286 2.286 0 0 0 .5 4.786v8a2.286 2.286 0 0 0 2.286 2.285h11.428a2.286 2.286 0 0 0 2.286-2.285v-8ZM2.786 4.1h11.428l.111.01c.332.053.575.34.575.676v8l-.01.11a.686.686 0 0 1-.676.575H2.786l-.111-.009a.686.686 0 0 1-.575-.676v-8l.01-.111a.686.686 0 0 1 .676-.575Z",
  fill: "currentColor"
}, null, -1), ma = /* @__PURE__ */ n("path", {
  d: "M4.729 6.5c.533 0 .8.267.8.8s-.267.8-.8.8c-.534 0-.8-.267-.8-.8s.266-.8.8-.8ZM7.7 6.5c.534 0 .8.267.8.8s-.266.8-.8.8c-.533 0-.8-.267-.8-.8s.267-.8.8-.8ZM10.671 6.5h1.6c.533 0 .8.267.8.8s-.267.8-.8.8h-1.6c-.533 0-.8-.267-.8-.8s.267-.8.8-.8ZM4.729 9.928h7.543c.533 0 .8.267.8.8 0 .534-.267.8-.8.8H4.729c-.534 0-.8-.266-.8-.8 0-.533.266-.8.8-.8Z",
  fill: "currentColor"
}, null, -1), ka = [
  $a,
  ma
], Of = /* @__PURE__ */ i({
  __name: "IconEditorKeyboard",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ka, 14, za));
  }
}), Sa = ["stroke-width"], xa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.5 5.5V2h.554a.5.5 0 0 0 .5-.5V1a.5.5 0 0 0-.5-.5h-7a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5H5.5v3.5L3.504 9.16l-.01.005.004.006-1.578 2.892A3 3 0 0 0 4.554 16.5h7.893a3 3 0 0 0 2.633-4.437L11.5 5.5ZM7 2v3.882L5.67 8.322c.276-.048.553-.072.831-.072 1.011 0 1.574.298 2.359 1.051l.172.169c.622.622.886.78 1.47.78.393 0 .924-.181 1.577-.558L10 5.882V2H7ZM3.237 12.782l1.358-2.491.24-.12.242-.112A3.576 3.576 0 0 1 6.5 9.75c.584 0 .848.158 1.47.78l.172.169c.784.754 1.348 1.051 2.358 1.051.682 0 1.442-.252 2.296-.74l.967 1.772.063.13A1.5 1.5 0 0 1 12.446 15H4.554l-.145-.007a1.5 1.5 0 0 1-1.172-2.211Z",
  fill: "currentColor"
}, null, -1), Ca = [
  xa
], Rf = /* @__PURE__ */ i({
  __name: "IconEditorLab",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ca, 14, Sa));
  }
}), Ba = ["stroke-width"], Ma = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 1.5H3v14H1.5v-14Z",
  fill: "currentColor"
}, null, -1), Za = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 1.5H5V3H3.5V1.5Zm4.264 2.024h1.5v1.5h-1.5v-1.5Zm0 2h1.5v1.5h-1.5v-1.5Zm1.503 2.25h-1.5v1.5h1.5v-1.5Zm-5.5 0h1.5v1.5h-1.5v-1.5Zm3.5 0h-1.5v1.5h1.5v-1.5Zm2.5 0h1.5v1.5h-1.5v-1.5Zm3.5 0h-1.5v1.5h1.5v-1.5Zm-5.503 2.25h1.5v1.5h-1.5v-1.5Zm1.5 2h-1.5v1.5h1.5v-1.5ZM7 1.5 5.5 1.5V3H7V1.5Zm.75-.001h1.5V3h-1.5V1.5Zm3.75 0H10V3h1.5V1.5Zm.5 0h1.5V3H12V1.5Zm3.5 0H14V3h1.5V1.5ZM5 14H3.5v1.5H5V14Zm2 .002L5.5 14v1.5H7v-1.5ZM7.75 14h1.5v1.5h-1.5V14Zm3.75 0H10v1.5h1.5v-1.5Zm.5 0h1.5v1.5H12v-1.5Zm3.5 0H14v1.5h1.5V14Zm0-10.5H14V5h1.5V3.5Zm0 2H14V7h1.5V5.5Zm-1.497 2.25h1.5v1.5h-1.5v-1.5Zm1.497 2.25H14v1.5h1.5V10ZM14 12h1.5v1.5H14V12Z",
  fill: "currentColor"
}, null, -1), Ia = [
  Ma,
  Za
], jf = /* @__PURE__ */ i({
  __name: "IconEditorLeftBorder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ia, 14, Ba));
  }
}), ba = ["stroke-width"], Wa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h13Zm.5 4.5A.5.5 0 0 0 15 6H9a.5.5 0 0 0-.5.5V7a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.5Zm0 3.5a.5.5 0 0 0-.5-.5H9a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V10Zm0 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V14ZM1.683 6.68a.5.5 0 0 0 .385.82h2.864a.5.5 0 0 0 .385-.82L3.884 4.96a.5.5 0 0 0-.768 0L1.683 6.68Zm.385 2.82a.5.5 0 0 0-.385.82l1.433 1.72a.5.5 0 0 0 .768 0l1.433-1.72a.5.5 0 0 0-.385-.82H2.068Z",
  fill: "currentColor"
}, null, -1), Ha = [
  Wa
], Pf = /* @__PURE__ */ i({
  __name: "IconEditorLineHeight",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ha, 14, ba));
  }
}), Va = ["stroke-width"], Aa = /* @__PURE__ */ n("path", {
  d: "M12.528 10.514a.713.713 0 0 1 0-1.008l.503-.503a3.561 3.561 0 1 0-5.035-5.036l-.503.504a.712.712 0 1 1-1.008-1.006v-.001l.505-.504a4.985 4.985 0 1 1 7.05 7.051l-.504.504a.712.712 0 0 1-1.008 0Zm-2.014 3.022-.504.504a4.986 4.986 0 0 1-7.05-7.051l.504-.504A.713.713 0 0 1 4.47 7.494l-.503.503a3.562 3.562 0 1 0 5.035 5.036l.504-.503a.713.713 0 0 1 1.008 1.006Zm.503-7.554a.713.713 0 0 1 0 1.008L6.99 11.018a.713.713 0 0 1-1.007-1.007l4.028-4.03a.712.712 0 0 1 1.007 0Z",
  fill: "currentColor"
}, null, -1), La = [
  Aa
], Tf = /* @__PURE__ */ i({
  __name: "IconEditorLink",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, La, 14, Va));
  }
}), Na = ["stroke-width"], Fa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 2h13Zm-4 3.5a4 4 0 0 1 3.095 6.534l2.112 2.112a.5.5 0 0 1 0 .708l-.353.353a.5.5 0 0 1-.708 0L12.94 13A4 4 0 1 1 11 5.5ZM11 7a2.5 2.5 0 1 0 0 5 2.5 2.5 0 0 0 0-5ZM5 6a.5.5 0 0 1 .5.5V7a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 6h3Zm.5 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h3a.5.5 0 0 0 .5-.5V10Zm2 4a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h5a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), Ga = [
  Fa
], qf = /* @__PURE__ */ i({
  __name: "IconEditorListSearch",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ga, 14, Na));
  }
}), Da = ["stroke-width"], Ea = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7 1.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5A.5.5 0 0 1 6 5V3H2v11h4v-2a.5.5 0 0 1 .5-.5H7a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5H1a.5.5 0 0 1-.5-.5V2a.5.5 0 0 1 .5-.5h6Zm3 0a.5.5 0 0 0-.5.5v2.988a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5V3h4v11h-4v-2.011a.5.5 0 0 0-.5-.5H10a.5.5 0 0 0-.5.5V15a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5h-6Zm1.149 5.114a.5.5 0 0 1 .82.384v.685h1.497a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5h-1.497v.68a.5.5 0 0 1-.82.384l-1.72-1.432a.5.5 0 0 1 0-.769l1.72-1.432Zm-6.15 1.069H3.499a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1.498v.68a.5.5 0 0 0 .82.384l1.72-1.432a.5.5 0 0 0 0-.769l-1.72-1.432a.5.5 0 0 0-.82.384v.685Z",
  fill: "currentColor"
}, null, -1), Ua = [
  Ea
], Kf = /* @__PURE__ */ i({
  __name: "IconEditorMergeCells",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ua, 14, Da));
  }
}), Oa = ["stroke-width"], Ra = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.214 1c.592 0 1.072.48 1.072 1.071V4.15l1.306 1.305c.257-.11.54-.17.837-.17H9.57c.297 0 .58.06.837.17l1.306-1.305V2.071A1.072 1.072 0 0 1 12.786 1h2.143C15.52 1 16 1.48 16 2.071v2.143c0 .592-.48 1.072-1.071 1.072h-2.08l-1.304 1.306c.11.257.17.54.17.837V9.57c0 1.184-.96 2.143-2.144 2.143H7.43c-.297 0-.58-.06-.837-.169L5.286 12.85v2.079c0 .591-.48 1.071-1.072 1.071H2.071C1.48 16 1 15.52 1 14.929v-2.143a1.071 1.071 0 0 1 1.071-1.072H4.15l1.307-1.306a2.136 2.136 0 0 1-.17-.837V7.43c0-.297.06-.58.169-.837L4.15 5.286H2.071C1.48 5.286 1 4.806 1 4.214V2.071C1 1.48 1.48 1 2.071 1h2.143Zm10.179 10.179a1.072 1.072 0 0 1 1.071 1.071v2.143c0 .592-.48 1.071-1.071 1.071H12.25c-.592 0-1.071-.48-1.071-1.071V12.25c0-.592.48-1.071 1.071-1.071h2.143ZM3.679 13.32H2.607v1.072H3.68V13.32Zm10.179-.535h-1.072v1.071h1.072v-1.071ZM9.57 6.893H7.428a.536.536 0 0 0-.527.44l-.008.096V9.57c0 .26.184.481.439.527l.096.01h2.143c.259 0 .48-.186.527-.44l.009-.097V7.43a.536.536 0 0 0-.44-.528l-.096-.008ZM3.68 2.607H2.607V3.68H3.68V2.607Zm10.714 0H13.32V3.68h1.072V2.607Z",
  fill: "currentColor"
}, null, -1), ja = [
  Ra
], Qf = /* @__PURE__ */ i({
  __name: "IconEditorMindMap",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ja, 14, Oa));
  }
}), Pa = ["stroke-width"], Ta = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m7.076 7.5-3.464-6h1.732L8.5 6.964 11.654 1.5h1.732l-3.464 6H12.5V9H9.25v1.5h3.25V12H9.25v3.5h-1.5V12H4.5v-1.5h3.25V9H4.5V7.5h2.576Z",
  fill: "currentColor"
}, null, -1), qa = [
  Ta
], Xf = /* @__PURE__ */ i({
  __name: "IconEditorMoney",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, qa, 14, Pa));
  }
}), Ka = ["stroke-width"], Qa = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.16 1.255A4.876 4.876 0 0 0 3.5 6.125V8.94l-.711.724a.95.95 0 0 0-.273.661l-.003.723.006.1.007.053.02.099a.95.95 0 0 0 .917.698H13.57a.95.95 0 0 0 .95-.95v-.703l-.008-.124a.95.95 0 0 0-.354-.622l-.905-.715V6.126A4.876 4.876 0 0 0 8.377 1.25l-.217.005Zm.217 1.495a3.376 3.376 0 0 1 3.375 3.376v3.122l.009.113a.75.75 0 0 0 .277.475l.837.661H4.073l.712-.723a.75.75 0 0 0 .216-.526V6.126A3.376 3.376 0 0 1 8.377 2.75ZM7.252 13.091a.099.099 0 0 0-.097-.093H5.917a.163.163 0 0 0-.163.167 2.75 2.75 0 0 0 5.493-.065.1.1 0 0 0-.1-.102h-1.27a.135.135 0 0 0-.134.127 1.25 1.25 0 0 1-2.49-.034Z",
  fill: "currentColor"
}, null, -1), Xa = [
  Qa
], Yf = /* @__PURE__ */ i({
  __name: "IconEditorNotificaiton",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Xa, 14, Ka));
  }
}), Ya = ["stroke-width"], Ja = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.056 1c.255 0 .467.177.51.41l.009.09V4h.518a.51.51 0 0 1 .519.5c0 .245-.184.45-.426.492L4.093 5H2.02a.51.51 0 0 1-.518-.5c0-.245.183-.45.425-.492L2.02 4h.519V2h-.519a.514.514 0 0 1-.51-.41l-.008-.09c0-.245.183-.45.425-.492L2.02 1h1.037ZM15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H7.704a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5H15Zm0 5.75a.5.5 0 0 1 .5.5v.502a.5.5 0 0 1-.5.5H7.704a.5.5 0 0 1-.5-.5V8.25a.5.5 0 0 1 .5-.5H15Zm.5 6.25a.5.5 0 0 0-.5-.5H7.704a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5H15a.5.5 0 0 0 .5-.5V14ZM4.567 7.205c.151-.321-.09-.705-.474-.705H2.02l-.093.008A.506.506 0 0 0 1.501 7l.008.09c.044.233.256.41.51.41h1.104L1.588 9.723l-.042.072c-.152.321.089.705.473.705h2.074l.093-.008A.505.505 0 0 0 4.612 10l-.009-.09a.514.514 0 0 0-.51-.41H2.988l1.537-2.223.042-.072ZM4.093 12c.385 0 .625.384.474.705l-.042.072L3.68 14l.845 1.224c.213.308.015.714-.346.77L4.093 16H2.02a.51.51 0 0 1-.518-.5c0-.245.183-.45.425-.492L2.02 15h1.105l-.5-.723a.485.485 0 0 1-.047-.467l.048-.087.498-.723H2.019a.514.514 0 0 1-.51-.41l-.008-.09c0-.245.183-.45.425-.492L2.02 12h2.074Z",
  fill: "currentColor"
}, null, -1), t2 = [
  Ja
], Jf = /* @__PURE__ */ i({
  __name: "IconEditorOrderedList",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, t2, 14, Ya));
  }
}), e2 = ["stroke-width"], o2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5V2ZM3 3h11v11H3V3Z",
  fill: "currentColor"
}, null, -1), r2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.708 3.5h1.579V5h-1.58V3.5Zm0 2h1.579V7h-1.58V5.5ZM9.29 7.75H7.71v1.5h1.58v-1.5Zm-5.79 0h1.579v1.5H3.5v-1.5Zm3.684 0H5.605v1.5h1.58v-1.5Zm2.631 0h1.58v1.5h-1.58v-1.5Zm3.685 0h-1.579v1.5H13.5v-1.5ZM7.708 10h1.579v1.5h-1.58V10Zm1.579 2h-1.58v1.5h1.58V12Z",
  fill: "currentColor"
}, null, -1), s2 = [
  o2,
  r2
], t9 = /* @__PURE__ */ i({
  __name: "IconEditorOuterBorders",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, s2, 14, e2));
  }
}), n2 = ["stroke-width"], i2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.643 1.005a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.75a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-4.75Zm0 10.25a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v4.75a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-4.75Zm-6.5-8.75a.5.5 0 0 1 .5.5v11a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5h.5Zm10.712 9.141a.5.5 0 0 1-.854-.353V9.25H6.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h5.501V5.707a.5.5 0 0 1 .854-.354l2.792 2.793a.5.5 0 0 1 0 .707l-2.793 2.793Z",
  fill: "currentColor"
}, null, -1), l2 = [
  i2
], e9 = /* @__PURE__ */ i({
  __name: "IconEditorOveflow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, l2, 14, n2));
  }
}), a2 = ["stroke-width"], c2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.253 2.5a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h3.75v10H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h4.753a.5.5 0 0 0 .5-.5V14c0-.018-.001-.035-.003-.052V3.052A.506.506 0 0 0 7.253 3v-.5Zm8.247 0A.5.5 0 0 0 15 2H9.75v1H9.75v11.5h.002v.5H15a.5.5 0 0 0 .5-.5V14a.5.5 0 0 0-.5-.5h-3.75v-10H15a.5.5 0 0 0 .5-.5v-.5ZM2.6 6.45a.5.5 0 0 1 .7-.1l.4.3a.5.5 0 0 1 .1.7L2.937 8.5 3.8 9.65a.5.5 0 0 1-.1.7l-.4.3a.5.5 0 0 1-.7-.1L1.287 8.8a.5.5 0 0 1 0-.6L2.6 6.45Zm11.1-.1a.5.5 0 0 1 .7.1l1.313 1.75a.5.5 0 0 1 0 .6L14.4 10.55a.5.5 0 0 1-.7.1l-.4-.3a.5.5 0 0 1-.1-.7l.864-1.15-.864-1.15a.5.5 0 0 1 .1-.7l.4-.3Z",
  fill: "currentColor"
}, null, -1), d2 = [
  c2
], o9 = /* @__PURE__ */ i({
  __name: "IconEditorPageBreak",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, d2, 14, a2));
  }
}), p2 = ["stroke-width"], h2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2 2a.5.5 0 0 0-.5.5v3A.5.5 0 0 0 2 6h.5a.5.5 0 0 0 .5-.5v-2h11v2a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-3A.5.5 0 0 0 15 2H2Zm13.5 12.5V10a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v3.5H3V10a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v4.5a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5ZM11 4.5a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V5a.5.5 0 0 1 .5-.5h5ZM3 7a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 7h1Zm4 0a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 6 7h1Zm4.5.5A.5.5 0 0 0 11 7h-1a.5.5 0 0 0-.5.5V8a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5ZM15 7a.5.5 0 0 1 .5.5V8a.5.5 0 0 1-.5.5h-1a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 14 7h1Z",
  fill: "currentColor"
}, null, -1), u2 = [
  h2
], r9 = /* @__PURE__ */ i({
  __name: "IconEditorPageHeadFoot",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, u2, 14, p2));
  }
}), f2 = ["stroke-width"], _2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 2.5A.5.5 0 0 1 2 2h13a.5.5 0 0 1 .5.5v12a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-12Zm1.5 11v-10h11v10H3Zm8.25-8.25a.5.5 0 0 0-.5-.5H9.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h.25v1.5H9.5a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h2a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-.25v-2.5ZM7 7.75a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H5.5a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5H7Zm5 3.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-.5Z",
  fill: "currentColor"
}, null, -1), y2 = [
  _2
], s9 = /* @__PURE__ */ i({
  __name: "IconEditorPageNumber",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, y2, 14, f2));
  }
}), w2 = ["stroke-width"], g2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.743 2.398A.75.75 0 0 0 1.25 2.5v12l.007.102A.75.75 0 0 0 2.75 14.5V9.25h6.5v5.25l.007.102a.75.75 0 0 0 1.493-.102v-12l-.007-.102A.75.75 0 0 0 9.25 2.5v5.25h-6.5V2.5l-.007-.102ZM14.531 8.99c.278-.198.435-.26.676-.26.437 0 .741.305.741.744v5.02c0 .405-.294.713-.69.713-.395 0-.69-.308-.69-.714v-3.915l-.52.366a.81.81 0 0 1-.213.109l-.116.028-.11.008a.619.619 0 0 1-.627-.639c0-.248.108-.43.342-.597l1.207-.863Z",
  fill: "currentColor"
}, null, -1), v2 = [
  g2
], n9 = /* @__PURE__ */ i({
  __name: "IconEditorPrimaryHeader",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, v2, 14, w2));
  }
}), z2 = ["stroke-width"], $2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 4.5V1l6 5-6 5V7.5c-4.103 0-7.359 3.577-9 8.5C1 9.5 3.436 5.32 10 4.5Z",
  fill: "currentColor"
}, null, -1), m2 = [
  $2
], i9 = /* @__PURE__ */ i({
  __name: "IconEditorRedo",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, m2, 14, z2));
  }
}), k2 = ["stroke-width"], S2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 1.5H14v14h1.5v-14Z",
  fill: "currentColor"
}, null, -1), x2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.5 1.5H12V3h1.5V1.5ZM9.236 3.524h-1.5v1.5h1.5v-1.5Zm0 2h-1.5v1.5h1.5v-1.5Zm-1.503 2.25h1.5v1.5h-1.5v-1.5Zm5.5 0h-1.5v1.5h1.5v-1.5Zm-3.5 0h1.5v1.5h-1.5v-1.5Zm-2.5 0h-1.5v1.5h1.5v-1.5Zm-3.5 0h1.5v1.5h-1.5v-1.5Zm5.503 2.25h-1.5v1.5h1.5v-1.5Zm-1.5 2h1.5v1.5h-1.5v-1.5ZM10 1.5l1.5-.001V3H10V1.5ZM9.25 1.5h-1.5V3h1.5V1.5Zm-3.75 0H7V3H5.5V1.5Zm-.5 0H3.5V3H5V1.5Zm-3.5 0H3V3H1.5V1.5ZM12 14h1.5v1.5H12V14Zm-2 .002L11.5 14v1.5H10v-1.5ZM9.25 14h-1.5v1.5h1.5V14ZM5.5 14H7v1.5H5.5v-1.5Zm-.5 0H3.5v1.5H5v-1.5Zm-3.5 0H3v1.5H1.5V14Zm0-10.5H3V5H1.5V3.5Zm0 2H3V7H1.5V5.5Zm1.497 2.25h-1.5v1.5h1.5v-1.5ZM1.5 10.001H3v1.5H1.5V10ZM3 12H1.5v1.5H3V12Z",
  fill: "currentColor"
}, null, -1), C2 = [
  S2,
  x2
], l9 = /* @__PURE__ */ i({
  __name: "IconEditorRightBorder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, C2, 14, k2));
  }
}), B2 = ["stroke-width"], M2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.993 2.398A.75.75 0 0 0 .5 2.5v12l.007.102A.75.75 0 0 0 2 14.5V9.25h6.5v5.25l.007.102A.75.75 0 0 0 10 14.5v-12l-.007-.102A.75.75 0 0 0 8.5 2.5v5.25H2V2.5l-.007-.102Zm10.05 8.007c.13-.92 1.057-1.629 2.202-1.629 1.205 0 2.1.808 2.1 1.916 0 .727-.313 1.257-1.346 2.315l-.851.874h1.647c.314 0 .567.181.653.462l.022.098.007.103c0 .383-.291.662-.682.662H12.69c-.396 0-.69-.263-.69-.639 0-.245.07-.387.296-.625l1.94-2.025c.572-.61.705-.841.705-1.182 0-.379-.283-.646-.697-.646-.458 0-.747.22-.893.68-.102.314-.323.488-.65.488-.392 0-.674-.277-.674-.662 0-.068.005-.13.016-.19Z",
  fill: "currentColor"
}, null, -1), Z2 = [
  M2
], a9 = /* @__PURE__ */ i({
  __name: "IconEditorSecondHeader",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Z2, 14, B2));
  }
}), I2 = ["stroke-width"], b2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.5 2a.5.5 0 0 0-.5-.5H1a.5.5 0 0 0-.5.5v13a.5.5 0 0 0 .5.5h6a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2H2V3h4v2a.5.5 0 0 0 .5.5H7a.5.5 0 0 0 .5-.5V2Zm2 0a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 .5.5v13a.5.5 0 0 1-.5.5h-6a.5.5 0 0 1-.5-.5v-3.011a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v2.01h4V3h-4v1.99a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5V2Zm1.747 4.998a.5.5 0 0 1 .82-.384l1.719 1.432a.5.5 0 0 1 0 .769l-1.719 1.432a.5.5 0 0 1-.82-.384v-.68H9.75a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h1.497v-.685Zm-6.348-.384a.5.5 0 0 1 .82.384v.685h1.498a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H5.719v.68a.5.5 0 0 1-.82.384l-1.72-1.432a.5.5 0 0 1 0-.769L4.9 6.614Z",
  fill: "currentColor"
}, null, -1), W2 = [
  b2
], c9 = /* @__PURE__ */ i({
  __name: "IconEditorSplitCells",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, W2, 14, I2));
  }
}), H2 = ["stroke-width"], V2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5 1.5c2.508 0 4.622 1.587 4.744 3.696l.006.193h-1.5c0-1.232-1.416-2.333-3.25-2.333s-3.25 1.1-3.25 2.333c0 .269.067.532.192.778h-1.6c-.06-.25-.092-.51-.092-.778C3.75 3.185 5.916 1.5 8.5 1.5ZM2.253 7.723a.778.778 0 0 0 .025 1.555H8.5l.202.004c1.735.078 3.048 1.143 3.048 2.33 0 1.231-1.416 2.332-3.25 2.332s-3.25-1.1-3.25-2.333h-1.5l.006.193C3.878 13.914 5.992 15.5 8.5 15.5c2.584 0 4.75-1.685 4.75-3.889 0-.887-.35-1.69-.939-2.333h2.411a.778.778 0 0 0 .025-1.555H2.253Z",
  fill: "currentColor"
}, null, -1), A2 = [
  V2
], d9 = /* @__PURE__ */ i({
  __name: "IconEditorStrikethrough",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, A2, 14, H2));
  }
}), L2 = ["stroke-width"], N2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.565 2.626A.4.4 0 0 1 .895 2h.9a.4.4 0 0 1 .33.174l3.388 4.958 3.386-4.958A.4.4 0 0 1 9.23 2h.901a.4.4 0 0 1 .33.626L6.448 8.5l4.013 5.874a.4.4 0 0 1-.33.626h-.901a.4.4 0 0 1-.33-.174L5.513 9.869l-3.386 4.957a.4.4 0 0 1-.33.174H.894a.4.4 0 0 1-.33-.626L4.578 8.5.565 2.626Zm15.588 7.193a.5.5 0 0 0-.466-.319H12.79a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1.546l-1.901 2.49a.5.5 0 0 0-.069.485l.271.7a.5.5 0 0 0 .466.319H16a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-1.547l1.902-2.491a.5.5 0 0 0 .069-.484l-.27-.7Z",
  fill: "currentColor"
}, null, -1), F2 = [
  N2
], p9 = /* @__PURE__ */ i({
  __name: "IconEditorSubscript",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, F2, 14, L2));
  }
}), G2 = ["stroke-width"], D2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M.565 2.626A.4.4 0 0 1 .895 2h.9a.4.4 0 0 1 .33.174l3.388 4.958 3.386-4.958A.4.4 0 0 1 9.23 2h.901a.4.4 0 0 1 .33.626L6.448 8.5l4.013 5.874a.4.4 0 0 1-.33.626h-.901a.4.4 0 0 1-.33-.174L5.513 9.869l-3.386 4.957a.4.4 0 0 1-.33.174H.894a.4.4 0 0 1-.33-.626L4.578 8.5.565 2.626Zm15.588-.307A.5.5 0 0 0 15.687 2H12.79a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h1.546l-1.901 2.49a.5.5 0 0 0-.069.485l.271.7a.5.5 0 0 0 .466.319H16a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5h-1.547l1.902-2.491a.5.5 0 0 0 .069-.484l-.27-.7Z",
  fill: "currentColor"
}, null, -1), E2 = [
  D2
], h9 = /* @__PURE__ */ i({
  __name: "IconEditorSuperscript",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, E2, 14, G2));
  }
}), U2 = ["stroke-width"], O2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.523 3.65 8.075.874a.95.95 0 0 1 .85 0l5.553 2.776a.95.95 0 0 1 0 1.7L8.925 8.126a.95.95 0 0 1-.85 0L2.523 5.35a.95.95 0 0 1 0-1.7Zm10.3.85L8.5 2.338 4.176 4.5 8.5 6.661l4.323-2.16ZM1.829 8.165a.75.75 0 0 1 .912-.375l.095.04L8.5 10.66l5.665-2.832a.75.75 0 0 1 .954.248l.052.088a.75.75 0 0 1-.247.954l-.088.052-5.911 2.955a.95.95 0 0 1-.732.05l-.118-.05-5.91-2.955a.75.75 0 0 1-.336-1.006Zm.912 3.625a.75.75 0 0 0-.576 1.38l5.91 2.956.118.05a.95.95 0 0 0 .732-.05l5.91-2.955.088-.052a.75.75 0 0 0 .248-.954l-.052-.088a.75.75 0 0 0-.954-.248L8.5 14.661 2.836 11.83l-.095-.04Z",
  fill: "currentColor"
}, null, -1), R2 = [
  O2
], u9 = /* @__PURE__ */ i({
  __name: "IconEditorSwitchSheet",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, R2, 14, U2));
  }
}), j2 = ["stroke-width"], P2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.993 2.398A.75.75 0 0 0 .5 2.5v12l.007.102A.75.75 0 0 0 2 14.5V9.25h6.5v5.25l.007.102A.75.75 0 0 0 10 14.5v-12l-.007-.102A.75.75 0 0 0 8.5 2.5v5.25H2V2.5l-.007-.102Zm10.182 7.415c.362-.686 1.084-1.073 1.986-1.073 1.253 0 2.13.742 2.13 1.803 0 .515-.215.963-.607 1.277h-.002l-.015.014.017-.014.026.015c.397.25.657.636.738 1.11l.02.161.007.164c0 1.153-.991 1.994-2.307 1.994-.96 0-1.685-.361-2.092-1.054a1.216 1.216 0 0 1-.176-.624c0-.392.282-.678.675-.678.31 0 .523.171.648.496l.045.101c.155.304.438.45.9.45.546 0 .89-.27.893-.664.002-.477-.314-.734-.936-.734h-.449c-.379 0-.666-.275-.666-.647 0-.371.287-.647.666-.647h.418c.477 0 .79-.26.79-.626 0-.393-.226-.588-.723-.588-.452 0-.68.15-.834.538-.12.35-.318.513-.647.513-.393 0-.662-.274-.662-.67 0-.22.05-.418.157-.617Z",
  fill: "currentColor"
}, null, -1), T2 = [
  P2
], f9 = /* @__PURE__ */ i({
  __name: "IconEditorThirdHeader",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, T2, 14, j2));
  }
}), q2 = ["stroke-width"], K2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.5 1.5H5V3H3.5V1.5Zm4.264 2.024h1.5v1.5h-1.5v-1.5Zm0 2h1.5v1.5h-1.5v-1.5Zm1.502 2.25h-1.5v1.5h1.5v-1.5Zm-5.5 0h1.5v1.5h-1.5v-1.5Zm3.5 0h-1.5v1.5h1.5v-1.5Zm2.5 0h1.5v1.5h-1.5v-1.5Zm3.5 0h-1.5v1.5h1.5v-1.5Zm-5.502 2.25h1.5v1.5h-1.5v-1.5Zm1.5 2h-1.5v1.5h1.5v-1.5ZM7 1.5 5.5 1.5V3H7V1.5Zm.75-.001h1.5V3h-1.5V1.5Zm3.75 0H10V3h1.5V1.5Zm.5 0h1.5V3H12V1.5Zm3.5 0H14V3h1.5V1.5ZM5 14H3.5v1.5H5V14Zm2 .002L5.5 14v1.5H7v-1.5ZM7.75 14h1.5v1.5h-1.5V14Zm3.75 0H10v1.5h1.5v-1.5Zm.5 0h1.5v1.5H12v-1.5Zm3.5 0H14v1.5h1.5V14ZM3 3.5H1.5V5H3V3.5Zm0 2H1.5V7H3V5.5ZM1.503 7.75h1.5v1.5h-1.5v-1.5ZM3 10.001H1.5v1.5H3V10Zm-1.5 2H3v1.5H1.5V12ZM14 3.5h1.5V5H14V3.5Zm0 2h1.5V7H14V5.5Zm1.503 2.25h-1.5v1.5h1.5v-1.5ZM14 10.001h1.5v1.5H14V10Zm1.5 2H14v1.5h1.5V12ZM3 14H1.5v1.5H3V14Z",
  fill: "currentColor"
}, null, -1), Q2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M1.5 1.5h14V3h-14V1.5Z",
  fill: "currentColor"
}, null, -1), X2 = [
  K2,
  Q2
], _9 = /* @__PURE__ */ i({
  __name: "IconEditorTopBorder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, X2, 14, q2));
  }
}), Y2 = ["stroke-width"], J2 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5.5c.276 0 .5.256.5.571V15.93c0 .315-.224.571-.5.571H15c-.276 0-.5-.256-.5-.571V9.25H7a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h7.5V1.071c0-.315.224-.571.5-.571h.5ZM2 .506c.276 0 .5.256.5.571v14.857c0 .316-.224.572-.5.572h-.5c-.276 0-.5-.256-.5-.572V1.077c0-.315.224-.571.5-.571H2Z",
  fill: "currentColor"
}, null, -1), tc = [
  J2
], y9 = /* @__PURE__ */ i({
  __name: "IconEditorTruncation",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, tc, 14, Y2));
  }
}), ec = ["stroke-width"], oc = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.25 7.5V2h-1.5v5.5l.005.217A4.75 4.75 0 0 0 13.25 7.5V2h-1.5v5.5l-.005.184A3.25 3.25 0 0 1 5.25 7.5ZM14 14a.5.5 0 0 0-.5-.5h-10a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h10a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), rc = [
  oc
], w9 = /* @__PURE__ */ i({
  __name: "IconEditorUnderline",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, rc, 14, ec));
  }
}), sc = ["stroke-width"], nc = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7 4.5V1L1 6l6 5V7.5c4.103 0 7.359 3.577 9 8.5 0-6.5-2.436-10.68-9-11.5Z",
  fill: "currentColor"
}, null, -1), ic = [
  nc
], g9 = /* @__PURE__ */ i({
  __name: "IconEditorUndo",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ic, 14, sc));
  }
}), lc = ["stroke-width"], ac = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.5 10.005a.5.5 0 0 1 .5-.5h5.004a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5L11 11.004V15a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5v-4.995ZM7.503 7a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 6l4.003.001V2.005a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5V7Z",
  fill: "currentColor"
}, null, -1), cc = [
  ac
], v9 = /* @__PURE__ */ i({
  __name: "IconEditorUnexpand",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, cc, 14, lc));
  }
}), dc = ["stroke-width"], pc = /* @__PURE__ */ n("path", {
  d: "M14.8 12a.7.7 0 1 1 0 1.4h-1.4v1.4a.7.7 0 1 1-1.4 0v-2.1a.7.7 0 0 1 .7-.7h2.1ZM4.474 6.462l.066.058a.7.7 0 0 1 0 .991l-.495.495a3.5 3.5 0 1 0 4.95 4.95l.495-.495a.7.7 0 0 1 1.049.922l-.058.066-.496.496a4.9 4.9 0 0 1-6.93-6.93l.495-.495a.7.7 0 0 1 .924-.058Zm6.5-.437a.7.7 0 0 1 .06.925l-.06.066-3.958 3.958a.7.7 0 0 1-1.05-.923l.059-.066 3.96-3.96a.7.7 0 0 1 .99 0Zm2.972-2.97a4.9 4.9 0 0 1 0 6.93l-.496.495a.7.7 0 0 1-.99-.991l.495-.495a3.5 3.5 0 1 0-4.95-4.95l-.495.496a.7.7 0 0 1-1.048-.923l.058-.067.496-.495a4.9 4.9 0 0 1 6.93 0ZM4.3 1.5a.7.7 0 0 1 .7.7v2.1a.7.7 0 0 1-.7.7H2.2a.7.7 0 1 1 0-1.4h1.4V2.2a.7.7 0 0 1 .7-.7Z",
  fill: "currentColor"
}, null, -1), hc = [
  pc
], z9 = /* @__PURE__ */ i({
  __name: "IconEditorUnlink",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, hc, 14, dc));
  }
}), uc = ["stroke-width"], fc = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15 2a.5.5 0 0 1 .5.5V3a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 6 2h9ZM3.5 8.25a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.502a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V8.25Zm12 0a.5.5 0 0 0-.5-.5H6a.5.5 0 0 0-.5.5v.502a.5.5 0 0 0 .5.5h9a.5.5 0 0 0 .5-.5V8.25ZM3.5 2.5A.5.5 0 0 0 3 2H2a.5.5 0 0 0-.5.5V3a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5v-.5Zm11.5 11a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5H6a.5.5 0 0 1-.5-.5V14a.5.5 0 0 1 .5-.5h9ZM3.5 14a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h1a.5.5 0 0 0 .5-.5V14Z",
  fill: "currentColor"
}, null, -1), _c = [
  fc
], $9 = /* @__PURE__ */ i({
  __name: "IconEditorUnorderedList",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, _c, 14, uc));
  }
}), yc = ["stroke-width"], wc = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 15a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 14h13a.5.5 0 0 1 .5.5v.5Zm-7.72-2.72.01.013.355.353a.499.499 0 0 0 .707 0l.354-.353.01-.012 2.464-2.463a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0l-1.366 1.367V2a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v8.133L6.377 8.757a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707l2.463 2.463Z",
  fill: "currentColor"
}, null, -1), gc = [
  wc
], m9 = /* @__PURE__ */ i({
  __name: "IconEditorVerticalAlignBottom",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, gc, 14, yc));
  }
}), vc = ["stroke-width"], zc = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m7.78 6.03.01.013.355.353a.499.499 0 0 0 .707 0l.354-.353.01-.012 2.464-2.463a.5.5 0 0 0 0-.707l-.354-.354a.5.5 0 0 0-.707 0L9.253 3.874V1.75a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v2.133L6.377 2.507a.5.5 0 0 0-.707 0l-.354.354a.5.5 0 0 0 0 .707L7.78 6.03ZM15 9.253a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5a.5.5 0 0 0 .5.5h13ZM7.79 10.96l-.01.012-2.464 2.463a.5.5 0 0 0 0 .707l.354.353a.5.5 0 0 0 .707 0l1.376-1.375v2.133a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-2.124l1.366 1.366a.5.5 0 0 0 .707 0l.354-.353a.5.5 0 0 0 0-.707l-2.463-2.463-.011-.012-.354-.354a.498.498 0 0 0-.707 0l-.354.354Z",
  fill: "currentColor"
}, null, -1), $c = [
  zc
], k9 = /* @__PURE__ */ i({
  __name: "IconEditorVerticalAlignMiddle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, $c, 14, vc));
  }
}), mc = ["stroke-width"], kc = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v.5A.5.5 0 0 0 2 3h13a.5.5 0 0 0 .5-.5V2ZM7.776 4.72l.012-.013.354-.353a.499.499 0 0 1 .707 0l.354.353.011.012 2.463 2.463a.5.5 0 0 1 0 .707l-.353.354a.5.5 0 0 1-.707 0L9.25 6.876V15a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V6.867L6.374 8.243a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707l2.462-2.463Z",
  fill: "currentColor"
}, null, -1), Sc = [
  kc
], S9 = /* @__PURE__ */ i({
  __name: "IconEditorVerticalAlignTop",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Sc, 14, mc));
  }
}), xc = ["stroke-width"], Cc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm-.7-9.75a.75.75 0 0 1 1.5 0V7.3h1.95a.75.75 0 0 1 0 1.5H8.8v1.95a.75.75 0 0 1-1.5 0V8.8H5.25a.75.75 0 0 1 0-1.5H7.3V5.25Z",
  "clip-rule": "evenodd"
}, null, -1), Bc = [
  Cc
], x9 = /* @__PURE__ */ i({
  __name: "IconFillAdd",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Bc, 14, xc));
  }
}), Mc = ["stroke-width"], Zc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M15.5 1.5a.75.75 0 0 0-.75-.75H1.25l-.102.007A.75.75 0 0 0 1.25 2.25h13.5l.102-.007A.75.75 0 0 0 15.5 1.5Zm-1.952 5.835L8.753 2.85a.639.639 0 0 0-.066-.054c-.294-.21-.738-.186-.995.054L2.897 7.335a.522.522 0 0 0-.174.38c.001.32.317.578.705.577h1.973v6.207c0 .637.632 1.154 1.41 1.154h2.823c.779 0 1.41-.517 1.41-1.155V8.293h1.973a.8.8 0 0 0 .465-.143.55.55 0 0 0 .24-.396.515.515 0 0 0-.174-.418Z"
}, null, -1), Ic = [
  Zc
], C9 = /* @__PURE__ */ i({
  __name: "IconFillBackToTop",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ic, 14, Mc));
  }
}), bc = ["stroke-width"], Wc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14Zm2.51-9.44a.75.75 0 0 0-1.06 0L8 7.01 6.55 5.56a.75.75 0 0 0-1.06 1.061l1.45 1.45-1.38 1.378a.75.75 0 1 0 1.061 1.061L8 9.131l1.379 1.38a.75.75 0 1 0 1.06-1.061L9.06 8.07l1.45-1.45a.75.75 0 0 0 0-1.06Z",
  "clip-rule": "evenodd"
}, null, -1), Hc = [
  Wc
], B9 = /* @__PURE__ */ i({
  __name: "IconFillClear",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Hc, 14, bc));
  }
}), Vc = ["stroke-width"], Ac = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M4 1a2 2 0 0 0-2 2v11.33a1 1 0 0 0 1.472.881l3.584-1.92a2 2 0 0 1 1.888 0l3.584 1.92A1 1 0 0 0 14 14.33V3a2 2 0 0 0-2-2H4Zm5.352 8.485a.249.249 0 0 0 .362-.263l-.228-1.327a.344.344 0 0 1 .1-.305l.964-.94a.25.25 0 0 0-.139-.426L9.08 6.031a.344.344 0 0 1-.26-.188l-.595-1.207c-.084-.171-.364-.171-.448 0L7.18 5.843a.344.344 0 0 1-.259.188l-1.332.193a.25.25 0 0 0-.139.426l.965.94a.344.344 0 0 1 .099.305l-.228 1.327a.25.25 0 0 0 .362.263l1.192-.627c.1-.052.22-.052.32 0l1.192.627Z",
  "clip-rule": "evenodd"
}, null, -1), Lc = [
  Ac
], M9 = /* @__PURE__ */ i({
  __name: "IconFillCollectFlag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Lc, 14, Vc));
  }
}), Nc = ["stroke-width"], Fc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M11.915 14.703a.664.664 0 0 1-.31-.077L8 12.732l-3.605 1.894a.666.666 0 0 1-.966-.702l.689-4.014L1.2 7.068a.668.668 0 0 1 .37-1.136l4.03-.586 1.802-3.651c.223-.455.97-.455 1.194 0L10.4 5.346l4.03.586a.667.667 0 0 1 .37 1.136L11.881 9.91l.689 4.014a.666.666 0 0 1-.656.779Z"
}, null, -1), Gc = [
  Fc
], Z9 = /* @__PURE__ */ i({
  __name: "IconFillCollect",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Gc, 14, Nc));
  }
}), Dc = ["stroke-width"], Ec = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M11.638.643a.75.75 0 0 0-.713-.518h-5.85l-.108.008a.75.75 0 0 0-.631.615L3.993 2.75H1.25l-.102.007A.75.75 0 0 0 1.25 4.25h13.5l.102-.007a.75.75 0 0 0-.102-1.493h-2.743L11.664.748l-.026-.105ZM10.485 2.75l-.193-1.125H5.707L5.514 2.75h4.971Zm-7.36 2.59h9.75a.75.75 0 0 1 .748.8l-.75 9.033a.75.75 0 0 1-.748.702h-8.25a.75.75 0 0 1-.748-.702l-.75-9.034a.75.75 0 0 1 .748-.798Zm7.5 6.785a.75.75 0 0 0-.75-.75h-3.75l-.102.007a.75.75 0 0 0 .102 1.493h3.75l.102-.007a.75.75 0 0 0 .648-.743Z",
  "clip-rule": "evenodd"
}, null, -1), Uc = [
  Ec
], I9 = /* @__PURE__ */ i({
  __name: "IconFillDelete",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Uc, 14, Dc));
  }
}), Oc = ["stroke-width"], Rc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M3.158 1.055c-1.14 0-2.065.925-2.065 2.065v4.818c0 1.14.925 2.065 2.065 2.065H3.5V1.055h-.342Zm1.842 0h5.537a3.442 3.442 0 0 1 3.375 2.767l.604 3.023.02.12a2.064 2.064 0 0 1-2.044 2.35h-2.228l.625 2.186c.378 1.32.112 1.971-.89 2.384-1.002.413-1.824.048-2.33-.56L5 10.123V1.055Z"
}, null, -1), jc = [
  Rc
], b9 = /* @__PURE__ */ i({
  __name: "IconFillDislike",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, jc, 14, Oc));
  }
}), Pc = ["stroke-width"], Tc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM4.832 8.53a.75.75 0 0 1 1.06-1.06l1.385 1.384 2.83-2.83a.75.75 0 1 1 1.061 1.06L7.812 10.44l-.005.005a.75.75 0 0 1-1.06 0L4.831 8.53Z",
  "clip-rule": "evenodd"
}, null, -1), qc = [
  Tc
], W9 = /* @__PURE__ */ i({
  __name: "IconFillFinish",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, qc, 14, Pc));
  }
}), Kc = ["stroke-width"], Qc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M15 7.3v4.9c0 1.155-.945 2.1-2.1 2.1H3.1c-1.155 0-2.1-.945-2.1-2.1V7.3h14ZM5.06 1.7c.714 0 1.4.273 1.918.763L8.399 3.8H12.9c1.155 0 2.1.945 2.1 2.1H1V3.8c0-1.155.945-2.1 2.1-2.1h1.96Z"
}, null, -1), Xc = [
  Qc
], H9 = /* @__PURE__ */ i({
  __name: "IconFillFolder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Xc, 14, Kc));
  }
}), Yc = ["stroke-width"], Jc = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15 8A7 7 0 1 0 1 8a7 7 0 0 0 14 0ZM8.775 6.94a.233.233 0 0 0-.234-.234H7.515c-.012 0-.024 0-.036.003h-.332a.261.261 0 0 0-.261.262v.85c0 .144.117.261.261.261h.134v2.151l-.697.001a.261.261 0 0 0-.261.262v.836c0 .144.117.261.261.261h2.883a.261.261 0 0 0 .261-.261v-.836a.261.261 0 0 0-.261-.262h-.692V6.938Zm-.109-2.263a.261.261 0 0 0-.261-.261h-.971a.261.261 0 0 0-.261.261v.971c0 .144.117.261.261.261h.97a.261.261 0 0 0 .262-.261v-.97Z",
  "clip-rule": "evenodd"
}, null, -1), t3 = [
  Jc
], V9 = /* @__PURE__ */ i({
  __name: "IconFillInfo",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, t3, 14, Yc));
  }
}), e3 = ["stroke-width"], o3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M3.158 14.945a2.065 2.065 0 0 1-2.065-2.065V8.062c0-1.14.925-2.065 2.065-2.065H3.5v8.948h-.342Zm1.842 0h5.537a3.442 3.442 0 0 0 3.375-2.767l.604-3.023.02-.12a2.064 2.064 0 0 0-2.044-2.35h-2.228L10.89 4.5c.378-1.32.112-1.971-.89-2.384-1.002-.413-1.824-.048-2.33.56L5 5.877v9.068Z"
}, null, -1), r3 = [
  o3
], A9 = /* @__PURE__ */ i({
  __name: "IconFillLike",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, r3, 14, e3));
  }
}), s3 = ["stroke-width"], n3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15 8a7 7 0 1 0-14.002.002A7 7 0 0 0 15 8ZM6.6 5.2a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.618.695L6.6 10.8a.7.7 0 0 1-.7-.7V5.9a.7.7 0 0 1 .7-.7Zm2.8 0a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.618.695L9.4 10.8a.7.7 0 0 1-.7-.7V5.9a.7.7 0 0 1 .7-.7Z",
  "clip-rule": "evenodd"
}, null, -1), i3 = [
  n3
], L9 = /* @__PURE__ */ i({
  __name: "IconFillPause",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, i3, 14, s3));
  }
}), l3 = ["stroke-width"], a3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M13.791 5.303c.372.372.345 1.001-.058 1.405a1.079 1.079 0 0 1-.746.321l-.468.006-2.332 3.14.092.619c.043.284-.044.582-.235.814l-.075.085-.311.31c-.405.406-1.034.432-1.406.06L6.45 10.261l-2.458 2.223-.471-.471 2.222-2.459-1.802-1.801c-.345-.346-.346-.913-.022-1.316L4 6.347l.311-.31c.243-.243.58-.36.9-.312l.618.091 3.144-2.329.006-.465c.015-.517.388-.954.896-1.05l.11-.015a.918.918 0 0 1 .72.26l3.086 3.086Z"
}, null, -1), c3 = [
  a3
], N9 = /* @__PURE__ */ i({
  __name: "IconFillPin",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, c3, 14, l3));
  }
}), d3 = ["stroke-width"], p3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M15 8a7 7 0 1 0-14.002.002A7 7 0 0 0 15 8ZM7.007 5.454a.5.5 0 0 0-.757.43v4.233a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L7.007 5.454Z",
  "clip-rule": "evenodd"
}, null, -1), h3 = [
  p3
], F9 = /* @__PURE__ */ i({
  __name: "IconFillPlay",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, h3, 14, d3));
  }
}), u3 = ["stroke-width"], f3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M1.046.141a.2.2 0 0 1 .283 0l14.53 14.53a.2.2 0 0 1 0 .283l-.905.905a.2.2 0 0 1-.283 0L.141 1.329a.2.2 0 0 1 0-.283l.905-.905Z",
  "clip-rule": "evenodd"
}, null, -1), _3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M.564 3.752A.778.778 0 0 0 0 4.5v7a.778.778 0 0 0 .778.777h2.866l3.688 2.582a.778.778 0 0 0 1.224-.637v-2.479L.564 3.752Zm11.75 5.374L10.87 7.682a3.112 3.112 0 0 0-.755-1.709.21.21 0 0 1 .004-.287l.817-.817a.194.194 0 0 1 .28.003 4.664 4.664 0 0 1 1.098 4.254Zm2.363 2.364-1.168-1.169a6.226 6.226 0 0 0-1.192-6.683.205.205 0 0 1 .002-.285l.817-.817a.197.197 0 0 1 .281.002 7.782 7.782 0 0 1 1.26 8.951ZM8.556 5.368l-2.991-2.99L7.332 1.14a.778.778 0 0 1 1.224.637v3.59Z"
}, null, -1), y3 = [
  f3,
  _3
], G9 = /* @__PURE__ */ i({
  __name: "IconFillQuiet",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, y3, 14, u3));
  }
}), w3 = ["stroke-width"], g3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 15A7 7 0 1 0 8 1a7 7 0 0 0 0 14ZM8 3.8a.75.75 0 0 0-.75.75v.6a.75.75 0 0 0 1.5 0v-.6A.75.75 0 0 0 8 3.8Zm0 6.3a.75.75 0 0 0-.75.75v.6a.75.75 0 0 0 1.5 0v-.6A.75.75 0 0 0 8 10.1ZM4.637 6.925a.75.75 0 0 1 .75-1.299l.52.3a.75.75 0 0 1-.75 1.3l-.52-.3ZM9.819 9.05a.75.75 0 0 0 .275 1.025l.52.3a.75.75 0 1 0 .75-1.3l-.52-.3a.75.75 0 0 0-1.025.275Zm-4.432 1.325a.75.75 0 1 1-.75-1.3l.52-.3a.75.75 0 1 1 .75 1.3l-.52.3ZM9.819 6.95a.75.75 0 0 0 1.025.274l.52-.3a.75.75 0 0 0-.75-1.299l-.52.3a.75.75 0 0 0-.275 1.025Z",
  "clip-rule": "evenodd"
}, null, -1), v3 = [
  g3
], D9 = /* @__PURE__ */ i({
  __name: "IconFillRunning",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, v3, 14, w3));
  }
}), z3 = ["stroke-width"], $3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M7.332 1.14a.778.778 0 0 1 1.224.638v12.444a.778.778 0 0 1-1.224.637l-3.688-2.581H.778A.778.778 0 0 1 0 11.5v-7a.778.778 0 0 1 .778-.778h2.866l3.688-2.581Zm2.782 4.833a.21.21 0 0 1 .005-.287l.817-.817a.194.194 0 0 1 .28.003 4.666 4.666 0 0 1 0 6.31.194.194 0 0 1-.28.004l-.817-.817a.21.21 0 0 1-.005-.287 3.113 3.113 0 0 0 0-4.109Z"
}, null, -1), m3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M12.317 3.638a.205.205 0 0 1 .002-.285l.817-.817a.197.197 0 0 1 .281.002 7.778 7.778 0 0 1 0 10.712.197.197 0 0 1-.281.002l-.817-.817a.205.205 0 0 1-.002-.285 6.223 6.223 0 0 0 0-8.512Z"
}, null, -1), k3 = [
  $3,
  m3
], E9 = /* @__PURE__ */ i({
  __name: "IconFillVoice",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, k3, 14, z3));
  }
}), S3 = ["stroke-width"], x3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  d: "M8 1a7 7 0 1 1-.002 14.002A7 7 0 0 1 8 1Zm0 2.8a.7.7 0 0 0-.7.7V8a.7.7 0 0 0 .205.495l2.1 2.1a.698.698 0 0 0 .99 0 .7.7 0 0 0 0-.99L8.7 7.71V4.5a.7.7 0 0 0-.7-.7Z"
}, null, -1), C3 = [
  x3
], U9 = /* @__PURE__ */ i({
  __name: "IconFillWaiting",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, C3, 14, S3));
  }
}), B3 = ["stroke-width"], M3 = /* @__PURE__ */ n("path", {
  fill: "currentColor",
  "fill-rule": "evenodd",
  d: "M8 1a7 7 0 1 0 0 14A7 7 0 0 0 8 1Zm-.267 8.274a.418.418 0 0 1-.144-.246l-.274-3.702A.705.705 0 0 1 8 4.57a.687.687 0 0 1 .686.686l-.274 3.771a.418.418 0 0 1-.68.246Zm-.114.899A.685.685 0 0 1 8 10.057a.648.648 0 0 1 .686.686.686.686 0 1 1-1.067-.57Z",
  "clip-rule": "evenodd"
}, null, -1), Z3 = [
  M3
], O9 = /* @__PURE__ */ i({
  __name: "IconFillWarning",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "currentColor",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Z3, 14, B3));
  }
}), I3 = ["stroke-width"], b3 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.23 1.75c-1.39 0-2.483 1.092-2.483 2.397V7.46c0 1.305 1.093 2.397 2.483 2.397h3.795a.75.75 0 0 1 .594.291l.508.657V1.75H4.23Zm6.397 10.776v-1.197h1.144c.85 0 1.649-.14 2.107-.826.207-.31.293-.662.335-.99.041-.323.048-.69.048-1.071h.253c.683 0 1.236-.554 1.236-1.236V3.948c0-2.062-1.714-3.698-3.783-3.698H4.23C2.05.25.247 1.976.247 4.147V7.46c0 2.171 1.803 3.897 3.983 3.897h3.428l1.336 1.727c.532.688 1.633.312 1.633-.558Zm1.144-2.697h-1.144V8.511h2.134a6.92 6.92 0 0 1-.036.811c-.028.223-.071.314-.094.348-.006.01-.09.16-.86.16Zm-1.126-2.887V1.75h1.322c1.281 0 2.283 1.004 2.283 2.198v2.994h-3.605ZM5.808 4.3c0-.617-.512-1.116-1.144-1.116-.632 0-1.144.5-1.144 1.116 0 .616.512 1.116 1.144 1.116.632 0 1.144-.5 1.144-1.116Z"
}, null, -1), W3 = [
  b3
], R9 = /* @__PURE__ */ i({
  __name: "IconFunctionKim",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 14",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, W3, 14, I3));
  }
}), H3 = ["stroke-width"], V3 = /* @__PURE__ */ n("path", {
  d: "M18 2.25C9.302 2.25 2.25 9.302 2.25 18S9.302 33.75 18 33.75 33.75 26.698 33.75 18 26.698 2.25 18 2.25Zm0 28.828c-7.221 0-13.078-5.857-13.078-13.078 0-7.221 5.857-13.078 13.078-13.078 7.221 0 13.078 5.857 13.078 13.078 0 7.221-5.857 13.078-13.078 13.078Zm-3.094-18.703H13.22a.282.282 0 0 0-.281.281v10.688c0 .154.126.281.28.281h1.688a.282.282 0 0 0 .281-.281V12.656a.282.282 0 0 0-.28-.281Zm7.875 0h-1.687a.282.282 0 0 0-.282.281v10.688c0 .154.127.281.282.281h1.687a.282.282 0 0 0 .282-.281V12.656a.282.282 0 0 0-.282-.281Z",
  fill: "currentColor",
  "fill-opacity": ".85"
}, null, -1), A3 = [
  V3
], j9 = /* @__PURE__ */ i({
  __name: "IconFunctionPauseCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 36 36",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, A3, 14, H3));
  }
}), L3 = ["stroke-width"], N3 = ["strokeWidth"], P9 = /* @__PURE__ */ i({
  __name: "IconGeneralAddBold",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        "fill-rule": "evenodd",
        "clip-rule": "evenodd",
        d: "M8.5 1.5a.75.75 0 0 0-.75.75v5.5h-5.5a.75.75 0 0 0 0 1.5h5.5v5.5a.75.75 0 0 0 1.5 0v-5.5h5.5a.75.75 0 0 0 0-1.5h-5.5v-5.5a.75.75 0 0 0-.75-.75Z",
        fill: "currentColor"
      }, null, 8, N3)
    ], 14, L3));
  }
}), F3 = ["stroke-width"], G3 = ["strokeWidth"], D3 = ["strokeWidth"], T9 = /* @__PURE__ */ i({
  __name: "IconGeneralAddCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.502",
        cy: "8.504",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, G3),
      n("path", {
        d: "M8.5 4.964v7.071M12.035 8.5h-7.07",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, D3)
    ], 14, F3));
  }
}), E3 = ["stroke-width"], U3 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.5 1.5a.75.75 0 0 0-.75.75v5.5h-5.5a.75.75 0 0 0 0 1.5h5.5v5.5a.75.75 0 0 0 1.5 0v-5.5h5.5a.75.75 0 0 0 0-1.5h-5.5v-5.5a.75.75 0 0 0-.75-.75Z",
  fill: "currentColor"
}, null, -1), O3 = [
  U3
], q9 = /* @__PURE__ */ i({
  __name: "IconGeneralAddItem",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, O3, 14, E3));
  }
}), R3 = ["stroke-width"], j3 = /* @__PURE__ */ n("path", {
  d: "M13.4 1.5c1.16 0 2.1.94 2.1 2.1v9.8a2.1 2.1 0 0 1-2.1 2.1H3.6a2.1 2.1 0 0 1-2.1-2.1V3.6c0-1.16.94-2.1 2.1-2.1h9.8Zm0 1.4H3.6a.7.7 0 0 0-.695.618L2.9 3.6v9.8a.7.7 0 0 0 .618.695l.082.005h9.8a.7.7 0 0 0 .695-.618l.005-.082V3.6a.7.7 0 0 0-.618-.695L13.4 2.9ZM8.5 5a.7.7 0 0 1 .7.7v2.1h2.1a.7.7 0 0 1 .695.618L12 8.5a.7.7 0 0 1-.7.7H9.2v2.1a.7.7 0 1 1-1.4 0V9.2H5.7a.7.7 0 1 1 0-1.4h2.1V5.7a.7.7 0 0 1 .7-.7Z",
  fill: "currentColor"
}, null, -1), P3 = [
  j3
], K9 = /* @__PURE__ */ i({
  __name: "IconGeneralAddSqual",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, P3, 14, R3));
  }
}), T3 = ["stroke-width"], q3 = /* @__PURE__ */ n("path", {
  d: "M8.5 1.85c2.701 0 4.9 2.199 4.9 4.9v7h1.4a.7.7 0 1 1 0 1.4H2.2a.7.7 0 1 1 0-1.4h1.4v-7c0-2.701 2.199-4.9 4.9-4.9Zm0 1.4C6.57 3.25 5 4.82 5 6.75v7h7v-7c0-1.93-1.57-3.5-3.5-3.5Zm0 7.212a.98.98 0 1 1 0 1.96.98.98 0 0 1 0-1.96Zm0-5.604a.7.7 0 0 1 .7.7v3.216a.7.7 0 1 1-1.4 0V5.558a.7.7 0 0 1 .7-.7Z",
  fill: "currentColor"
}, null, -1), K3 = [
  q3
], Q9 = /* @__PURE__ */ i({
  __name: "IconGeneralAlarm",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, K3, 14, T3));
  }
}), Q3 = ["stroke-width"], X3 = ["strokeWidth"], X9 = /* @__PURE__ */ i({
  __name: "IconGeneralArrowOrder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "m7.5 5.5-3-2-3 2M4.5 3.5v11M15.5 12.5l-3 2-3-2M12.5 14.5v-11",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, X3)
    ], 14, Q3));
  }
}), Y3 = ["stroke-width"], J3 = ["strokeWidth"], td = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.5 15.167a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm.5-3.25v-1.25a.5.5 0 0 0-1 0v2.25h2a.5.5 0 1 0 0-1h-1Z",
  fill: "currentColor"
}, null, -1), Y9 = /* @__PURE__ */ i({
  __name: "IconGeneralCalendarClock",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "M2.833 7.833h11.333v-4a.333.333 0 0 0-.333-.333H3.166a.333.333 0 0 0-.333.333v10a.333.333 0 0 0 .333.334H8.5m3.333-12v2.666M5.166 2.167v2.666",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        "stroke-linecap": "round"
      }, null, 8, J3),
      td
    ], 14, Y3));
  }
}), ed = ["stroke-width"], od = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.5 1.5A.5.5 0 0 0 5 2v1.5H2.75c-.69 0-1.25.56-1.25 1.25V14.255c0 .69.56 1.25 1.25 1.25h11.504c.69 0 1.25-.56 1.25-1.25V4.75c0-.69-.56-1.25-1.25-1.25H12V2a.5.5 0 0 0-.5-.5H11a.5.5 0 0 0-.5.5v1.5h-4V2a.5.5 0 0 0-.5-.5h-.5ZM3 8.5V14h11V8.5H3ZM14 7V5H3v2h11Z",
  fill: "currentColor"
}, null, -1), rd = [
  od
], J9 = /* @__PURE__ */ i({
  __name: "IconGeneralCalender",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, rd, 14, ed));
  }
}), sd = ["stroke-width"], nd = /* @__PURE__ */ n("path", {
  d: "M8.264 4.949A.788.788 0 1 0 9.38 3.834.788.788 0 0 0 8.264 4.95Z",
  fill: "currentColor"
}, null, -1), id = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m14.238 9.007-5.416 5.415L7.15 12.75l5.415-5.415c.28-.28.445-.656.46-1.052l.186-4.644A1.576 1.576 0 0 0 11.573.001L6.93.187c-.396.016-.771.18-1.051.46L.462 6.063a1.576 1.576 0 0 0 0 2.23L4.92 12.75l.04.038 2.747 2.748a1.576 1.576 0 0 0 2.23 0l5.415-5.416c.28-.28.445-.656.46-1.051L16 4.425a1.576 1.576 0 0 0-1.638-1.638l-1.197.048-.063 1.58 1.323-.053-.186 4.645Zm-8.203 2.63L11.45 6.22l.186-4.644-4.644.186-5.416 5.416 4.459 4.458Z",
  fill: "currentColor"
}, null, -1), ld = [
  nd,
  id
], t_ = /* @__PURE__ */ i({
  __name: "IconGeneralChildtag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ld, 14, sd));
  }
}), ad = ["stroke-width"], cd = ["strokeWidth"], dd = /* @__PURE__ */ n("path", {
  d: "M6 1.5V14",
  "stroke-linecap": "round",
  "stroke-linejoin": "round"
}, null, -1), pd = /* @__PURE__ */ n("path", { d: "M1 5a1 1 0 0 1 1-1h8a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1z" }, null, -1), hd = [
  dd,
  pd
], e_ = /* @__PURE__ */ i({
  __name: "IconGeneralChinese",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      fill: "none",
      viewBox: "0 0 12 15",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("g", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, hd, 8, cd)
    ], 14, ad));
  }
}), ud = ["stroke-width"], fd = ["strokeWidth"], _d = ["strokeWidth"], o_ = /* @__PURE__ */ i({
  __name: "IconGeneralCloseCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.502",
        cy: "8.504",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, fd),
      n("path", {
        d: "m6 6 5 5M11 6l-5 5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, _d)
    ], 14, ud));
  }
}), yd = ["stroke-width"], wd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.28 3.244a.875.875 0 0 1 1.237 0l9.24 9.24a.875.875 0 0 1 0 1.237l-.036.035a.875.875 0 0 1-1.237 0l-9.24-9.24a.875.875 0 0 1 0-1.237l.036-.035Z",
  fill: "currentColor"
}, null, -1), gd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M13.721 3.244a.875.875 0 0 0-1.237 0l-9.24 9.24a.875.875 0 0 0 0 1.237l.036.035a.875.875 0 0 0 1.237 0l9.24-9.24a.875.875 0 0 0 0-1.237l-.036-.035Z",
  fill: "currentColor"
}, null, -1), vd = [
  wd,
  gd
], r_ = /* @__PURE__ */ i({
  __name: "IconGeneralClose",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, vd, 14, yd));
  }
}), zd = ["stroke-width"], $d = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.567 9.866a.173.173 0 0 0-.149-.002c-.205.093-.624.317-1.055.554a.72.72 0 0 1-1.051-.758c.09-.498.172-.98.192-1.204a.16.16 0 0 0-.04-.123 16.775 16.775 0 0 0-.865-.848.722.722 0 0 1 .393-1.238c.497-.069.978-.142 1.2-.193a.173.173 0 0 0 .114-.088c.115-.208.345-.648.571-1.084a.7.7 0 0 1 1.238-.012c.232.432.465.869.574 1.086.025.05.068.088.123.1.225.052.696.123 1.183.191.594.083.83.825.394 1.236a16.7 16.7 0 0 0-.86.85.158.158 0 0 0-.04.122c.02.223.112.704.214 1.2.12.59-.505 1.063-1.036.78a35.556 35.556 0 0 0-1.1-.569ZM7.215 7.674a10.01 10.01 0 0 0-.51-.52c.286-.043.546-.087.712-.125.348-.08.614-.306.765-.58.075-.135.19-.354.32-.603.126.236.232.438.293.56.141.28.412.538.795.626.165.037.417.08.695.123-.21.203-.398.393-.51.522-.208.238-.312.55-.282.871.017.174.06.438.115.725-.246-.128-.465-.24-.612-.31a1.173 1.173 0 0 0-.992-.01c-.146.067-.365.18-.607.309.049-.287.088-.55.103-.72a1.16 1.16 0 0 0-.285-.868Z",
  fill: "currentColor"
}, null, -1), md = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.485 3.5a2 2 0 0 1 2-2h8.025a2 2 0 0 1 2 2v11.43a.9.9 0 0 1-1.32.796l-3.758-1.984a2 2 0 0 0-1.868 0l-3.758 1.984a.9.9 0 0 1-1.32-.796V3.5Zm2-.5h8.025a.5.5 0 0 1 .5.5v10.435l-2.878-1.52a3.5 3.5 0 0 0-3.268 0l-2.879 1.52V3.5a.5.5 0 0 1 .5-.5Z",
  fill: "currentColor"
}, null, -1), kd = [
  $d,
  md
], s_ = /* @__PURE__ */ i({
  __name: "IconGeneralCollectFlag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, kd, 14, zd));
  }
}), Sd = ["stroke-width"], xd = ["strokeWidth"], n_ = /* @__PURE__ */ i({
  __name: "IconGeneralCollect",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "m4.697 14.383.571-3.327a1.75 1.75 0 0 0-.503-1.55l-.42.431.42-.43L2.346 7.15l3.342-.486a1.75 1.75 0 0 0 1.318-.957L8.5 2.68l1.494 3.027a1.75 1.75 0 0 0 1.318.957l3.342.486-2.419 2.356a1.75 1.75 0 0 0-.503 1.55l.57 3.327-2.988-1.57a1.75 1.75 0 0 0-1.628 0l-2.989 1.57Z",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, xd)
    ], 14, Sd));
  }
}), Cd = ["stroke-width"], Bd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.994 3.106A1.75 1.75 0 0 0 13.25 1.5h-7l-.144.006A1.75 1.75 0 0 0 4.5 3.25v.5H6v-.5l.007-.057A.25.25 0 0 1 6.25 3h7l.057.007a.25.25 0 0 1 .193.243v7l-.007.057a.25.25 0 0 1-.243.193h-.5V12h.5l.143-.006A1.75 1.75 0 0 0 15 10.25v-7l-.006-.144ZM9.75 4.5h-6A2.25 2.25 0 0 0 1.5 6.75v6A2.25 2.25 0 0 0 3.75 15h6A2.25 2.25 0 0 0 12 12.75v-6A2.25 2.25 0 0 0 9.75 4.5Zm-6 1.5h6a.75.75 0 0 1 .75.75v6a.75.75 0 0 1-.75.75h-6a.75.75 0 0 1-.75-.75v-6A.75.75 0 0 1 3.75 6Z",
  fill: "currentColor"
}, null, -1), Md = [
  Bd
], i_ = /* @__PURE__ */ i({
  __name: "IconGeneralCopy",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Md, 14, Cd));
  }
}), Zd = ["stroke-width"], Id = /* @__PURE__ */ u('<g clip-path="url(#a)" fill="currentColor"><path d="M8.5.5a8 8 0 1 1-.002 16.002A8 8 0 0 1 8.5.5Zm0 1.6a6.407 6.407 0 0 0-6.4 6.4c0 3.529 2.871 6.4 6.4 6.4 3.529 0 6.4-2.871 6.4-6.4 0-3.529-2.871-6.4-6.4-6.4Z"></path><path d="M12.054 6.705a.7.7 0 0 0-.99 0L8.59 9.18l-.407.413-1.488-1.488a.7.7 0 1 0-.99.99l1.98 1.98.008.007a.7.7 0 0 0 .99 0l.897-.912 2.474-2.475a.7.7 0 0 0 0-.99Z"></path></g><defs><clipPath id="a"><path fill="currentColor" transform="translate(.5 .5)" d="M0 0h16v16H0z"></path></clipPath></defs>', 2), bd = [
  Id
], l_ = /* @__PURE__ */ i({
  __name: "IconGeneralCorrect",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, bd, 14, Zd));
  }
}), Wd = ["stroke-width"], Hd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.138 1.143a.75.75 0 0 0-.713-.518h-5.85l-.108.008a.75.75 0 0 0-.631.615L4.493 3.25H1.75l-.102.007A.75.75 0 0 0 1.75 4.75h1.172l.705 10.923a.75.75 0 0 0 .748.702h8.25a.75.75 0 0 0 .748-.702l.705-10.923h1.172l.102-.007a.75.75 0 0 0-.102-1.493h-2.743l-.343-2.002-.026-.105ZM10.985 3.25h-4.97l.192-1.125h4.585l.193 1.125ZM5.078 14.875 4.425 4.75h8.149l-.653 10.125H5.078Zm6.047-2.25a.75.75 0 0 0-.75-.75h-3.75l-.102.007a.75.75 0 0 0 .102 1.493h3.75l.102-.007a.75.75 0 0 0 .648-.743Z",
  fill: "currentColor"
}, null, -1), Vd = [
  Hd
], a_ = /* @__PURE__ */ i({
  __name: "IconGeneralDelete",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Vd, 14, Wd));
  }
}), Ad = ["stroke-width"], Ld = /* @__PURE__ */ n("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ n("path", {
    d: "M14.1 1.3a2.4 2.4 0 0 1 2.4 2.4v11.432a.8.8 0 0 1-1.22.681L12.5 14.1H2.9a2.4 2.4 0 0 1-2.4-2.4v-8a2.4 2.4 0 0 1 2.4-2.4h11.2Zm0 1.6H2.9a.8.8 0 0 0-.795.707L2.1 3.7v8a.8.8 0 0 0 .707.795l.093.005h10.053l1.947 1.2v-10a.8.8 0 0 0-.707-.795L14.1 2.9ZM8.5 8.742a1.12 1.12 0 1 1 0 2.24 1.12 1.12 0 0 1 0-2.24Zm0-4.642c.408 0 .744.232.794.53l.006.077v2.787c0 .335-.358.606-.8.606-.408 0-.744-.231-.794-.53L7.7 7.494V4.707c0-.335.358-.607.8-.607Z",
    fill: "currentColor"
  })
], -1), Nd = /* @__PURE__ */ n("defs", null, [
  /* @__PURE__ */ n("clipPath", { id: "a" }, [
    /* @__PURE__ */ n("path", {
      fill: "currentColor",
      transform: "translate(.5 .5)",
      d: "M0 0h16v16H0z"
    })
  ])
], -1), Fd = [
  Ld,
  Nd
], c_ = /* @__PURE__ */ i({
  __name: "IconGeneralDialog",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Fd, 14, Ad));
  }
}), Gd = ["stroke-width"], Dd = /* @__PURE__ */ n("path", {
  d: "M5.822 4.884a.5.5 0 0 1 0-.707l.354-.354a.5.5 0 0 1 .707 0l3.823 3.823a.5.5 0 0 1 0 .708l-3.823 3.823a.5.5 0 0 1-.707 0l-.354-.354a.5.5 0 0 1 0-.707L8.938 8 5.822 4.884Z",
  fill: "currentColor"
}, null, -1), Ed = [
  Dd
], d_ = /* @__PURE__ */ i({
  __name: "IconGeneralDirectionRighSmall",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ed, 14, Gd));
  }
}), Ud = ["stroke-width"], Od = ["strokeWidth"], p_ = /* @__PURE__ */ i({
  __name: "IconGeneralDownload",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "M2.5 14.5h12M8.5 1.5v10M4.5 8.5l4 3 4-3",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        "stroke-linecap": "round"
      }, null, 8, Od)
    ], 14, Ud));
  }
}), Rd = ["stroke-width"], jd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.5 5.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm4 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0Zm3 1a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z",
  fill: "currentColor"
}, null, -1), Pd = [
  jd
], h_ = /* @__PURE__ */ i({
  __name: "IconGeneralDrag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Pd, 14, Rd));
  }
}), Td = ["stroke-width"], qd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M8.97.651c.174-.179.444-.199.638-.06l.07.06 3.182 3.291a.53.53 0 0 1 .058.66l-.058.071-7.468 7.723H2.003a.505.505 0 0 1-.492-.424l-.008-.093V8.374L8.971.65Zm.355 1.828L3.003 9.016v1.828h1.768l6.321-6.537-1.767-1.828ZM15.5 14.466a.509.509 0 0 0-.5-.517H2c-.276 0-.5.231-.5.517v.517c0 .285.224.517.5.517h13c.276 0 .5-.232.5-.517v-.517Z",
  fill: "currentColor"
}, null, -1), Kd = [
  qd
], u_ = /* @__PURE__ */ i({
  __name: "IconGeneralEdit",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Kd, 14, Td));
  }
}), Qd = ["stroke-width"], Xd = ["strokeWidth"], f_ = /* @__PURE__ */ i({
  __name: "IconGeneralEnglish",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        strokeWidth: e.strokeWidth,
        d: "M7.5 4H1.6a.1.1 0 0 0-.1.1v8.8a.1.1 0 0 0 .1.1h5.9M2 8.5h5.5M10 7v6m0-4v0a2 2 0 0 1 2-2h1a2 2 0 0 1 2 2v4"
      }, null, 8, Xd)
    ], 14, Qd));
  }
}), Yd = ["stroke-width"], Jd = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M11.072 2.404a.75.75 0 0 0-.977.058l-.074.083a.75.75 0 0 0 .058.977l2.647 2.728H2.5l-.102.007A.75.75 0 0 0 2.5 7.75h12l.102-.006a.75.75 0 0 0 .436-1.266l-3.883-4-.083-.074ZM5.93 14.596a.75.75 0 0 0 .977-.058l.074-.083a.75.75 0 0 0-.058-.977L4.276 10.75h10.226l.102-.007a.75.75 0 0 0-.102-1.493h-12l-.102.006a.75.75 0 0 0-.436 1.266l3.883 4 .083.074Z",
  fill: "currentColor"
}, null, -1), t4 = [
  Jd
], __ = /* @__PURE__ */ i({
  __name: "IconGeneralExchange",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, t4, 14, Yd));
  }
}), e4 = ["stroke-width"], o4 = ["strokeWidth"], y_ = /* @__PURE__ */ i({
  __name: "IconGeneralEyeInvisible",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "M2.5 5.833c.212.406.532.783.94 1.118C4.588 7.891 6.427 8.5 8.5 8.5c2.074 0 3.913-.61 5.06-1.549a3.65 3.65 0 0 0 .94-1.118M10.16 8.5l.69 2.576M12.951 7.618l1.886 1.886M2.167 9.504l1.886-1.886M6.143 11.076l.69-2.576",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        "stroke-linecap": "round",
        "stroke-linejoin": "round"
      }, null, 8, o4)
    ], 14, e4));
  }
}), r4 = ["stroke-width"], s4 = /* @__PURE__ */ n("path", {
  d: "m1.5 8.5-.742-.106-.016.106.016.106L1.5 8.5Zm13.858 0 .743.106.015-.106-.015-.106-.743.106Zm-13.116.106A6.252 6.252 0 0 1 8.43 3.25v-1.5A7.752 7.752 0 0 0 .758 8.394l1.484.212ZM8.43 3.25a6.252 6.252 0 0 1 6.187 5.356l1.485-.212A7.752 7.752 0 0 0 8.429 1.75v1.5Zm6.187 5.144a6.252 6.252 0 0 1-6.187 5.356v1.5a7.752 7.752 0 0 0 7.672-6.644l-1.485-.212ZM8.429 13.75a6.252 6.252 0 0 1-6.187-5.356l-1.484.212a7.752 7.752 0 0 0 7.671 6.644v-1.5Z",
  fill: "currentColor"
}, null, -1), n4 = ["strokeWidth"], w_ = /* @__PURE__ */ i({
  __name: "IconGeneralEye",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      s4,
      n("circle", {
        cx: "8.429",
        cy: "8.5",
        r: "2",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, n4)
    ], 14, r4));
  }
}), i4 = ["stroke-width"], l4 = ["strokeWidth"], a4 = /* @__PURE__ */ n("path", {
  d: "M10.5 6.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
  fill: "currentColor"
}, null, -1), g_ = /* @__PURE__ */ i({
  __name: "IconGeneralFathertag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "M8.276 2.012a.333.333 0 0 1 .3-.091l4.322.864a.333.333 0 0 1 .261.261l.865 4.321a.332.332 0 0 1-.092.302l-6.709 6.709a.334.334 0 0 1-.471 0L1.566 9.192a.333.333 0 0 1 0-.471l6.71-6.71Z",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, l4),
      a4
    ], 14, i4));
  }
}), c4 = ["stroke-width"], d4 = /* @__PURE__ */ n("path", {
  d: "M10.9 15.7a.8.8 0 0 1-.8-.8V7.7c0-.166.052-.33.15-.465L13.345 2.9H3.654L6.75 7.235c.098.135.15.299.15.465v4.8a.8.8 0 1 1-1.6 0V7.956L1.45 2.565A.8.8 0 0 1 2.1 1.3h12.8a.801.801 0 0 1 .65 1.265L11.7 7.956V14.9a.8.8 0 0 1-.8.8Z",
  fill: "currentColor"
}, null, -1), p4 = [
  d4
], v_ = /* @__PURE__ */ i({
  __name: "IconGeneralFilter",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, p4, 14, c4));
  }
}), h4 = ["stroke-width"], u4 = /* @__PURE__ */ n("path", {
  d: "M12.793 4.793a1 1 0 0 1 1.497 1.32l-.083.094-6.5 6.5a1 1 0 0 1-1.32.083l-.094-.083-3.5-3.5a1 1 0 0 1 1.32-1.497l.094.083L7 10.585l5.793-5.792Z",
  fill: "currentColor"
}, null, -1), f4 = [
  u4
], z_ = /* @__PURE__ */ i({
  __name: "IconGeneralFinish",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, f4, 14, h4));
  }
}), _4 = ["stroke-width"], y4 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m8.811 3.75-2-2H2.5A1.75 1.75 0 0 0 .75 3.5v10c0 .966.784 1.75 1.75 1.75h12a1.75 1.75 0 0 0 1.75-1.75v-8l-.006-.144A1.75 1.75 0 0 0 14.5 3.75H8.811Zm-2.622-.5 2 2H14.5a.25.25 0 0 1 .25.25v8a.25.25 0 0 1-.25.25h-12a.25.25 0 0 1-.25-.25v-10a.25.25 0 0 1 .25-.25h3.689Z",
  fill: "currentColor"
}, null, -1), w4 = [
  y4
], $_ = /* @__PURE__ */ i({
  __name: "IconGeneralFolder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, w4, 14, _4));
  }
}), g4 = ["stroke-width"], v4 = /* @__PURE__ */ n("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "17",
  height: "17"
}, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M1 1h15v15H1z"
  })
], -1), z4 = { mask: "url(#a)" }, $4 = ["strokeWidth"], m_ = /* @__PURE__ */ i({
  __name: "IconGeneralGift",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      v4,
      n("g", z4, [
        n("path", {
          d: "M4.776 4.983H2.853a.353.353 0 0 0-.353.352v2.82a.352.352 0 0 0 .353.353h11.294a.353.353 0 0 0 .353-.353v-2.82a.352.352 0 0 0-.353-.352H12.42m-7.644 0h7.644m-7.644 0c-.365-.999-.217-1.974.418-2.34.76-.438 1.928.164 2.61 1.344.19.329.323.668.398.996m-3.426 0h3.426m4.218 0c.365-.999.217-1.974-.417-2.34-.76-.438-1.928.164-2.61 1.344-.182.31-.316.646-.399.996m3.426 0H8.994m-.792 0h.792M3.56 9.213a.705.705 0 0 1 .706-.705h8.47a.706.706 0 0 1 .706.705v4.582a.704.704 0 0 1-.706.705h-8.47a.706.706 0 0 1-.706-.705V9.213Z",
          stroke: "currentColor",
          strokeWidth: e.strokeWidth
        }, null, 8, $4)
      ])
    ], 14, g4));
  }
}), m4 = ["stroke-width"], k4 = /* @__PURE__ */ n("path", {
  d: "M9.931 13.908c.735-.987 1.252-2.703 1.35-4.708h2.77a5.608 5.608 0 0 1-4.12 4.708ZM2.949 9.2h2.77c.099 2.005.616 3.721 1.35 4.708A5.609 5.609 0 0 1 2.949 9.2Zm4.12-6.107c-.734.985-1.251 2.702-1.35 4.707h-2.77a5.609 5.609 0 0 1 4.12-4.707Zm.06 4.707c.14-2.557.993-4.012 1.372-4.192.379.18 1.233 1.635 1.371 4.192H7.13ZM8.5 13.392c-.379-.181-1.233-1.635-1.371-4.192H9.87c-.138 2.557-.992 4.011-1.371 4.192ZM14.052 7.8h-2.77c-.099-2.005-.616-3.722-1.35-4.707a5.608 5.608 0 0 1 4.12 4.707ZM8.5 1.5a7 7 0 1 0 0 14 7 7 0 0 0 0-14Z",
  fill: "currentColor"
}, null, -1), S4 = [
  k4
], k_ = /* @__PURE__ */ i({
  __name: "IconGeneralGlobal",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, S4, 14, m4));
  }
}), x4 = ["stroke-width"], C4 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M14.444 1c1.135 0 2.056.941 2.056 2.102v10.796c0 1.161-.92 2.102-2.056 2.102H2.576C1.441 16 .521 15.06.52 13.899v-.54a.646.646 0 0 1 0-.32V3.102C.52 1.942 1.44 1 2.576 1h11.868Zm-.002 1.281H2.575a.817.817 0 0 0-.81.822v6.818c.3-.613.595-1.133.886-1.554.5-.73.992-1.17 1.497-1.338.465-.156.92-.087 1.328.205 1.372.987 2.99 3.13 3.813 4.29.187-.276.384-.546.59-.808.934-1.193 1.752-1.828 2.498-1.938.474-.068.908.07 1.256.403.586.557 1.15 1.26 1.614 1.905V3.104a.816.816 0 0 0-.804-.822Zm-.446 3.08c0-.795-.63-1.44-1.408-1.44-.778 0-1.408.645-1.408 1.44 0 .795.63 1.44 1.408 1.44.777 0 1.408-.645 1.408-1.44Z",
  fill: "currentColor"
}, null, -1), B4 = [
  C4
], S_ = /* @__PURE__ */ i({
  __name: "IconGeneralImage",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, B4, 14, x4));
  }
}), M4 = ["stroke-width"], Z4 = { stroke: "currentColor" }, I4 = ["strokeWidth"], b4 = ["strokeWidth"], W4 = /* @__PURE__ */ n("path", {
  "clip-rule": "evenodd",
  d: "M4.667 3.185c.631 0 1.143.5 1.143 1.116s-.512 1.116-1.143 1.116c-.632 0-1.144-.5-1.144-1.116 0-.617.512-1.116 1.144-1.116z",
  fill: "currentColor",
  "fill-rule": "evenodd",
  "stroke-width": ".5"
}, null, -1), x_ = /* @__PURE__ */ i({
  __name: "IconGeneralKim",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      fill: "none",
      viewBox: "0 0 16 14",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("g", Z4, [
        n("path", {
          d: "M9.879 7.76h3.633v.659c0 1.565-.104 2.16-1.74 2.16H9.879V7.761zM9.896 1h2.072C13.643 1 15 2.32 15 3.948v3.329a.415.415 0 0 1-.415.415H9.896z",
          strokeWidth: e.strokeWidth
        }, null, 8, I4),
        n("path", {
          d: "M9.878 12.595a.138.138 0 0 1-.247.085l-1.604-2.073H4.233C2.447 10.607 1 9.198 1 7.46V4.147C1 2.409 2.447 1 4.233 1h5.645z",
          "stroke-linejoin": "round",
          strokeWidth: e.strokeWidth
        }, null, 8, b4),
        W4
      ])
    ], 14, M4));
  }
}), H4 = ["stroke-width"], V4 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m14.335 1.506-.133-.006H5.906l-.133.006a1.297 1.297 0 0 0-1.164 1.29v1.815H2.796l-.132.007A1.297 1.297 0 0 0 1.5 5.908v8.296l.006.133a1.296 1.296 0 0 0 1.29 1.163h8.297l.132-.006a1.296 1.296 0 0 0 1.164-1.29v-1.815h1.813l.133-.006a1.296 1.296 0 0 0 1.163-1.29V2.796l-.006-.132a1.296 1.296 0 0 0-1.157-1.158Zm-1.946 9.327h1.554V3.056H6.165V4.61h4.928l.132.007a1.296 1.296 0 0 1 1.164 1.29v4.925Zm-9.334 3.11h7.777V6.167H3.055v7.778Z",
  fill: "currentColor"
}, null, -1), A4 = /* @__PURE__ */ n("path", {
  d: "M6.308 7.775c.26-.286.745-.36 1.114-.17.368.19.495.58.291.895l-.066.086-.661.73h1.68c.296 0 .57.128.719.336.15.209.154.467.01.678l-.066.08-1.688 1.818c-.263.286-.752.357-1.119.162-.367-.195-.487-.59-.275-.902l.067-.085.673-.724H5.333c-.293 0-.565-.126-.716-.332a.576.576 0 0 1-.017-.673l.957-1.088.751-.81Z",
  fill: "currentColor"
}, null, -1), L4 = [
  V4,
  A4
], C_ = /* @__PURE__ */ i({
  __name: "IconGeneralLightningCopy",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, L4, 14, H4));
  }
}), N4 = ["stroke-width"], F4 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.658 15.445a2.065 2.065 0 0 1-2.065-2.065V8.562c0-1.14.925-2.065 2.065-2.065H5.4L8.17 3.174c.506-.608 1.328-.973 2.33-.56 1.002.413 1.268 1.065.89 2.384l-.624 2.186h2.227c1.262 0 2.22 1.12 2.044 2.35l-.02.12-.604 3.023a3.442 3.442 0 0 1-3.375 2.767h-7.38ZM9.753 3.852c-.26-.096-.543.102-.852.594L6.41 7.434v6.634h4.626c.943 0 1.761-.638 1.998-1.54l.027-.12.604-3.023a.688.688 0 0 0-.674-.823h-3.14a.688.688 0 0 1-.661-.878l.839-2.937c.012-.042.338-.704-.277-.895ZM5.034 7.873H3.658a.689.689 0 0 0-.684.608l-.005.08v4.819c0 .38.309.688.689.688h1.376V7.873Z",
  fill: "currentColor"
}, null, -1), G4 = [
  F4
], B_ = /* @__PURE__ */ i({
  __name: "IconGeneralLikeLine",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, G4, 14, N4));
  }
}), D4 = ["stroke-width"], E4 = { opacity: ".3" }, U4 = /* @__PURE__ */ n("path", {
  opacity: ".01",
  fill: "currentColor",
  d: "M1 0h11.883v12H1z"
}, null, -1), O4 = ["strokeWidth"], M_ = /* @__PURE__ */ i({
  __name: "IconGeneralLike",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 13 12",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("g", E4, [
        U4,
        n("path", {
          "clip-rule": "evenodd",
          d: "m6.94 2.154.336-.318a3.098 3.098 0 0 1 1.948-.711c1.632 0 2.916 1.324 2.916 3.005 0 .612-.159 1.202-.475 1.806-.585 1.118-1.381 1.854-3.904 4.213l-.5.42a.5.5 0 0 1-.642.001l-.498-.415C3.587 7.779 2.796 7.048 2.213 5.928c-.314-.601-.47-1.189-.47-1.798 0-1.681 1.283-3.005 2.914-3.005.706 0 1.4.26 1.95.71l.334.319Z",
          stroke: "currentColor",
          strokeWidth: e.strokeWidth
        }, null, 8, O4)
      ])
    ], 14, D4));
  }
}), R4 = ["stroke-width"], j4 = ["strokeWidth"], Z_ = /* @__PURE__ */ i({
  __name: "IconGeneralLike1",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        "clip-rule": "evenodd",
        d: "m8.199 4.029.334-.318A3.098 3.098 0 0 1 10.483 3c1.63 0 2.914 1.324 2.914 3.005 0 .612-.158 1.202-.474 1.806-.585 1.118-1.381 1.854-3.904 4.213l-.5.42a.5.5 0 0 1-.642.001l-.498-.415C4.844 9.654 4.054 8.923 3.47 7.803 3.157 7.202 3 6.614 3 6.005 3 4.324 4.283 3 5.915 3c.706 0 1.4.26 1.949.71l.335.319Z",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, j4)
    ], 14, R4));
  }
}), P4 = ["stroke-width"], T4 = /* @__PURE__ */ n("path", {
  d: "M11.3 9.9h2.799V7.1l-2.8.001v2.8Zm2.1-7H3.598a.7.7 0 0 0-.695.618l-.005.083v2.1h11.2V3.6a.7.7 0 0 0-.618-.696l-.082-.004ZM7.1 7.102v2.8h2.799V7.1H7.1Zm-1.401 0h-2.8v2.8h2.8V7.1Zm8.4 4.2h-2.8v2.8h2.1a.7.7 0 0 0 .696-.618l.005-.083-.001-2.1Zm-4.2 0h-2.8v2.8h2.8v-2.8Zm-4.2 0h-2.8v2.1a.7.7 0 0 0 .619.695l.081.005h2.1v-2.8Zm7.7-9.8c1.16 0 2.1.94 2.1 2.1v9.8a2.1 2.1 0 0 1-2.1 2.1H3.6a2.1 2.1 0 0 1-2.1-2.1V3.6c0-1.16.94-2.1 2.1-2.1h9.8Z",
  fill: "currentColor"
}, null, -1), q4 = [
  T4
], I_ = /* @__PURE__ */ i({
  __name: "IconGeneralList",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, q4, 14, P4));
  }
}), K4 = ["stroke-width"], Q4 = ["strokeWidth"], X4 = ["strokeWidth"], Y4 = /* @__PURE__ */ n("circle", {
  cx: "7",
  cy: "10.5",
  r: "1.5",
  fill: "currentColor"
}, null, -1), b_ = /* @__PURE__ */ i({
  __name: "IconGeneralLock",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 14 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M2 6.75h10c.69 0 1.25.56 1.25 1.25v6c0 .69-.56 1.25-1.25 1.25H2c-.69 0-1.25-.56-1.25-1.25V8c0-.69.56-1.25 1.25-1.25Z"
      }, null, 8, Q4),
      n("path", {
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        d: "M10 7V4a3 3 0 0 0-6 0v3.5"
      }, null, 8, X4),
      Y4
    ], 14, K4));
  }
}), J4 = ["stroke-width"], tp = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.003 3.004a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5v11a.5.5 0 0 0 .5.5h.5a.5.5 0 0 0 .5-.5v-11Zm8.26 1.382a.5.5 0 0 1 0-.707l.353-.353a.5.5 0 0 1 .707 0l4.824 4.823a.5.5 0 0 1 0 .707l-4.824 4.823a.5.5 0 0 1-.707 0l-.353-.354a.5.5 0 0 1 0-.707L13.63 9.25H6a.5.5 0 0 1-.5-.5v-.5a.5.5 0 0 1 .5-.5h7.626l-3.363-3.364Z",
  fill: "currentColor"
}, null, -1), ep = [
  tp
], W_ = /* @__PURE__ */ i({
  __name: "IconGeneralLogout",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ep, 14, J4));
  }
}), op = ["stroke-width"], rp = /* @__PURE__ */ n("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "17",
  height: "17"
}, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M.5.5h16v16H.5z"
  })
], -1), sp = /* @__PURE__ */ n("g", { mask: "url(#a)" }, [
  /* @__PURE__ */ n("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M11.005 1.5a.5.5 0 0 0-.5.5v.726a.5.5 0 0 0 .5.5h1.892L10.933 5.19a5.85 5.85 0 1 0 1.011 1.11l2.013-2.013v1.891a.5.5 0 0 0 .5.5h.726a.5.5 0 0 0 .5-.5V2a.5.5 0 0 0-.5-.5h-4.178Zm-7.98 8.15a4.123 4.123 0 1 1 8.247 0 4.123 4.123 0 0 1-8.246 0Z",
    fill: "currentColor"
  })
], -1), np = [
  rp,
  sp
], H_ = /* @__PURE__ */ i({
  __name: "IconGeneralMan",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, np, 14, op));
  }
}), ip = ["stroke-width"], lp = /* @__PURE__ */ n("path", {
  d: "m10.989 12.967.45.6-.45-.6Zm-2.65 1.746-.45.6.45-.6Zm-2.328-1.746.45-.6-.45.6ZM2.5 12.083h3.11v1.5H2.5v-1.5Zm3.96.284 2.33 1.746-.9 1.2-2.33-1.746.9-1.2Zm1.75 1.746 2.329-1.746.9 1.2-2.33 1.746-.9-1.2Zm3.179-2.03h3.11v1.5h-3.11v-1.5Zm3.027.084V2.833h1.5v9.334h-1.5Zm.084-9.25h-12v-1.5h12v1.5ZM2.583 2.833v9.334h-1.5V2.833h1.5Zm-.083.084a.083.083 0 0 0 .083-.084h-1.5c0-.782.634-1.416 1.417-1.416v1.5Zm11.916-.084c0 .046.038.084.084.084v-1.5c.782 0 1.416.634 1.416 1.416h-1.5Zm.084 9.25a.083.083 0 0 0-.084.084h1.5c0 .782-.634 1.416-1.416 1.416v-1.5Zm-3.961.284c.245-.184.543-.284.85-.284v1.5a.084.084 0 0 0 .05-.016l-.9-1.2Zm-1.75 1.746a.483.483 0 0 0-.58 0l.9 1.2a1.017 1.017 0 0 1-1.22 0l.9-1.2Zm-3.178-2.03c.306 0 .605.1.85.284l-.9 1.2c.014.01.032.016.05.016v-1.5Zm-3.111 1.5a1.417 1.417 0 0 1-1.417-1.416h1.5a.083.083 0 0 0-.083-.084v1.5Z",
  fill: "currentColor"
}, null, -1), ap = [
  lp
], V_ = /* @__PURE__ */ i({
  __name: "IconGeneralMessage",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, ap, 14, ip));
  }
}), cp = ["stroke-width"], dp = /* @__PURE__ */ n("path", {
  d: "M8.5 15.5a7 7 0 1 1 0-14 7 7 0 0 1 0 14Zm0-1.4a5.6 5.6 0 1 0 0-11.2 5.6 5.6 0 0 0 0 11.2Zm.7-4.2a2.45 2.45 0 1 1-3.484-2.222.7.7 0 0 1 .592 1.27A1.05 1.05 0 1 0 7.8 9.9V7.1a2.45 2.45 0 1 1 3.484 2.222.7.7 0 0 1-.592-1.27A1.05 1.05 0 1 0 9.2 7.1v2.8Z",
  fill: "currentColor"
}, null, -1), pp = [
  dp
], A_ = /* @__PURE__ */ i({
  __name: "IconGeneralMiniProgram",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, pp, 14, cp));
  }
}), hp = ["stroke-width"], up = /* @__PURE__ */ n("path", {
  d: "M14.75 7.75a.75.75 0 0 1 0 1.5H2.25a.75.75 0 0 1 0-1.5h12.5Z",
  fill: "currentColor"
}, null, -1), fp = [
  up
], L_ = /* @__PURE__ */ i({
  __name: "IconGeneralMinusItem",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, fp, 14, hp));
  }
}), _p = ["stroke-width"], yp = /* @__PURE__ */ n("circle", {
  cx: "4",
  cy: "8",
  r: "1",
  fill: "currentColor",
  "fill-opacity": ".56"
}, null, -1), wp = /* @__PURE__ */ n("circle", {
  cx: "8",
  cy: "8",
  r: "1",
  fill: "currentColor",
  "fill-opacity": ".56"
}, null, -1), gp = /* @__PURE__ */ n("circle", {
  cx: "12",
  cy: "8",
  r: "1",
  fill: "currentColor",
  "fill-opacity": ".56"
}, null, -1), vp = [
  yp,
  wp,
  gp
], N_ = /* @__PURE__ */ i({
  __name: "IconGeneralMore",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, vp, 14, _p));
  }
}), zp = ["stroke-width"], $p = ["strokeWidth"], mp = /* @__PURE__ */ n("path", {
  d: "M10.62 7.146a.5.5 0 0 1 .706 0l.354.354a.5.5 0 0 1 0 .707L8.857 11.03a.5.5 0 0 1-.708 0L5.326 8.207a.5.5 0 0 1 0-.707l.354-.354a.5.5 0 0 1 .707 0l2.116 2.116 2.116-2.116Z",
  fill: "currentColor"
}, null, -1), F_ = /* @__PURE__ */ i({
  __name: "IconGeneralNext",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.502",
        cy: "8.504",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, $p),
      mp
    ], 14, zp));
  }
}), kp = ["stroke-width"], Sp = /* @__PURE__ */ n("path", {
  d: "M9.973 16.253a4.253 4.253 0 0 1-4.245-4.047L5.723 12V7.262a2.753 2.753 0 0 1 5.501-.168l.005.168V11a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V7.26a1.253 1.253 0 0 0-2.5-.127l-.006.128V12a2.753 2.753 0 0 0 2.583 2.748l.168.005a2.749 2.749 0 0 0 2.745-2.58l.005-.168V6.47a4.22 4.22 0 0 0-8.434-.21l-.005.21V11a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5V6.47a5.72 5.72 0 0 1 11.434-.22l.005.22v5.535a4.248 4.248 0 0 1-4.043 4.243l-.208.005Z",
  fill: "currentColor"
}, null, -1), xp = [
  Sp
], G_ = /* @__PURE__ */ i({
  __name: "IconGeneralPaperclip",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, xp, 14, kp));
  }
}), Cp = ["stroke-width"], Bp = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.225 7.034a1.121 1.121 0 0 0-.236-1.237l-3.78-3.78a1.121 1.121 0 0 0-.828-.329l-.122.01c-.567.08-.982.574-.964 1.146l.016.525-2.678 1.72-.704-.133a1.119 1.119 0 0 0-1 .308L3.823 6.368l-.077.085a1.121 1.121 0 0 0 .077 1.5l2.187 2.187-2.373 2.69.634.634 2.69-2.373 2.085 2.085a1.122 1.122 0 0 0 1.585 0l1.104-1.103.082-.092c.204-.253.288-.586.227-.91l-.134-.704 1.722-2.673.53.016c.458.014.88-.254 1.062-.676Zm-4.568-3.666 2.98 2.979-.343-.008a.673.673 0 0 0-.586.308l-2.073 3.219-.049.09a.673.673 0 0 0-.046.399l.161.85-.86.861-4.906-4.905.861-.862.85.163a.673.673 0 0 0 .489-.096l3.224-2.07.08-.06a.672.672 0 0 0 .229-.526l-.01-.342Z",
  fill: "currentColor"
}, null, -1), Mp = [
  Bp
], D_ = /* @__PURE__ */ i({
  __name: "IconGeneralPin",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Mp, 14, Cp));
  }
}), Zp = ["stroke-width"], Ip = /* @__PURE__ */ n("rect", {
  x: "2.5",
  y: "7.5",
  width: "12",
  height: "2",
  rx: "1",
  fill: "currentColor"
}, null, -1), bp = [
  Ip
], E_ = /* @__PURE__ */ i({
  __name: "IconGeneralPlaceholder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, bp, 14, Zp));
  }
}), Wp = ["stroke-width"], Hp = ["strokeWidth"], Vp = ["strokeWidth"], U_ = /* @__PURE__ */ i({
  __name: "IconGeneralPlay",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.5",
        cy: "8.51",
        r: "6.667",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, Hp),
      n("path", {
        "clip-rule": "evenodd",
        d: "M7.167 5.933c0-.043.047-.068.083-.044l3.85 2.567a.053.053 0 0 1 0 .088l-3.85 2.567a.053.053 0 0 1-.083-.044V5.933Z",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, Vp)
    ], 14, Wp));
  }
}), Ap = ["stroke-width"], Lp = /* @__PURE__ */ n("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "17",
  height: "17"
}, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M.5.5h16v16H.5z"
  })
], -1), Np = /* @__PURE__ */ n("g", { mask: "url(#a)" }, [
  /* @__PURE__ */ n("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M4.25 7.302c0-2.441 1.922-4.385 4.25-4.385 2.328 0 4.25 1.944 4.25 4.385 0 .515-.237 1.203-.686 2.007-.44.786-1.034 1.601-1.645 2.347A30.83 30.83 0 0 1 8.5 13.782a30.842 30.842 0 0 1-1.92-2.125c-.61-.747-1.205-1.562-1.644-2.348-.45-.804-.686-1.492-.686-2.007Zm3.736 8.078.514-.547-.513.547.513.482.513-.482-.513-.547.514.547.001-.001.003-.003.012-.012.045-.042.165-.16a32.283 32.283 0 0 0 2.34-2.556c.64-.782 1.295-1.673 1.793-2.565.489-.874.877-1.836.877-2.74 0-3.23-2.556-5.884-5.75-5.884S2.75 4.07 2.75 7.302c0 .903.388 1.865.877 2.739.498.892 1.153 1.783 1.792 2.565a32.277 32.277 0 0 0 2.506 2.716l.045.042.012.011.003.004h.001Zm-.403-8.547a.917.917 0 1 1 1.833 0 .917.917 0 0 1-1.833 0ZM8.5 4.417a2.417 2.417 0 1 0 0 4.833 2.417 2.417 0 0 0 0-4.833Z",
    fill: "currentColor"
  })
], -1), Fp = [
  Lp,
  Np
], O_ = /* @__PURE__ */ i({
  __name: "IconGeneralPosition",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Fp, 14, Ap));
  }
}), Gp = ["stroke-width"], Dp = ["strokeWidth"], Ep = /* @__PURE__ */ n("path", {
  d: "M6.38 9.854a.5.5 0 0 1-.706 0L5.32 9.5a.5.5 0 0 1 0-.707L8.143 5.97a.5.5 0 0 1 .708 0l2.823 2.823a.5.5 0 0 1 0 .707l-.354.354a.5.5 0 0 1-.707 0L8.497 7.738 6.381 9.854Z",
  fill: "currentColor"
}, null, -1), R_ = /* @__PURE__ */ i({
  __name: "IconGeneralPrevious",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.498",
        cy: "8.496",
        r: "6.5",
        transform: "rotate(180 8.498 8.496)",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, Dp),
      Ep
    ], 14, Gp));
  }
}), Up = ["stroke-width"], Op = /* @__PURE__ */ n("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "17",
  height: "17"
}, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M.5.5h16v16H.5z"
  })
], -1), Rp = /* @__PURE__ */ n("g", { mask: "url(#a)" }, [
  /* @__PURE__ */ n("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.25 2.5a1.083 1.083 0 0 0-1.083 1.083v1.584H2.583A1.083 1.083 0 0 0 1.5 6.25v5.667A1.083 1.083 0 0 0 2.583 13h1.25v1.25a1.083 1.083 0 0 0 1.083 1.083h6.667a1.083 1.083 0 0 0 1.083-1.083V13h1.25A1.083 1.083 0 0 0 15 11.917V6.25a1.083 1.083 0 0 0-1.083-1.083h-1.584V3.583A1.083 1.083 0 0 0 11.25 2.5h-6Zm7.416 9h.834V6.667H3V11.5h.833v-.917A1.083 1.083 0 0 1 4.916 9.5h6.667a1.083 1.083 0 0 1 1.083 1.083v.917Zm-7.333 0V11h5.833v.5H5.333Zm0 1.5h5.833v.833H5.333V13Zm5.5-7.833H5.667V4h5.166v1.167Z",
    fill: "currentColor"
  })
], -1), jp = [
  Op,
  Rp
], j_ = /* @__PURE__ */ i({
  __name: "IconGeneralPrinter",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, jp, 14, Up));
  }
}), Pp = ["stroke-width"], Tp = /* @__PURE__ */ n("path", {
  d: "M14.487 11.024a.7.7 0 1 1 .626 1.252l-6.3 3.15a.7.7 0 0 1-.626 0l-6.3-3.15a.7.7 0 1 1 .626-1.252l5.36 2.68a1.4 1.4 0 0 0 1.253 0l5.36-2.68Zm0-3.208a.7.7 0 1 1 .626 1.252l-6.3 3.15a.7.7 0 0 1-.626 0l-6.3-3.15a.7.7 0 1 1 .626-1.252l5.36 2.68a1.4 1.4 0 0 0 1.253 0l5.36-2.68ZM9.124 1.743l5.97 2.93a.7.7 0 0 1 0 1.258l-5.96 2.91a1.4 1.4 0 0 1-1.232-.002L1.916 5.896a.7.7 0 0 1 .004-1.258L7.896 1.74a1.4 1.4 0 0 1 1.228.003Zm-.937 1.338L4.016 5.167a.14.14 0 0 0 0 .25l4.171 2.086a.7.7 0 0 0 .626 0l4.171-2.086a.14.14 0 0 0 0-.25L8.813 3.081a.7.7 0 0 0-.626 0Z",
  fill: "currentColor"
}, null, -1), qp = [
  Tp
], P_ = /* @__PURE__ */ i({
  __name: "IconGeneralProduct",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, qp, 14, Pp));
  }
}), Kp = ["stroke-width"], Qp = ["strokeWidth"], Xp = ["strokeWidth"], T_ = /* @__PURE__ */ i({
  __name: "IconGeneralQuestion",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M8.002 9.474c0-1.263 1.112-1.685 1.772-2.696C10.434 5.766 9.592 4 7.997 4 6.51 4 6.002 5.073 6 5.9v.196M8 12h.004"
      }, null, 8, Qp),
      n("circle", {
        cx: "8",
        cy: "8",
        r: "7",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, Xp)
    ], 14, Kp));
  }
}), Yp = ["stroke-width"], Jp = ["strokeWidth"], t7 = ["strokeWidth"], q_ = /* @__PURE__ */ i({
  __name: "IconGeneralReduceCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.502",
        cy: "8.504",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, Jp),
      n("path", {
        d: "M12.035 8.5h-7.07",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, t7)
    ], 14, Yp));
  }
}), e7 = ["stroke-width"], o7 = ["strokeWidth"], K_ = /* @__PURE__ */ i({
  __name: "IconGeneralRefresh",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        d: "m6.5 6.5-.005-3.657A6.002 6.002 0 0 0 6.5 14.158M10.5 10.5l.005 3.656a6.002 6.002 0 0 0 .01-11.31",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, o7)
    ], 14, e7));
  }
}), r7 = ["stroke-width"], s7 = /* @__PURE__ */ n("path", {
  d: "M8.5 1.5a7 7 0 1 1 0 14 7 7 0 0 1 0-14Zm0 1.4a5.6 5.6 0 1 0 0 11.2 5.6 5.6 0 0 0 0-11.2Zm0 7.7a.7.7 0 0 1 .7.7v.7a.7.7 0 1 1-1.4 0v-.7a.7.7 0 0 1 .7-.7Zm2.775-1.306.606.35a.7.7 0 0 1-.7 1.212l-.606-.35a.7.7 0 1 1 .7-1.212ZM6.68 9.55a.7.7 0 0 1-.256.956l-.606.35a.7.7 0 1 1-.7-1.212l.606-.35a.7.7 0 0 1 .956.256Zm5.456-3.15a.7.7 0 0 1-.256.956l-.606.35a.7.7 0 0 1-.7-1.212l.606-.35a.7.7 0 0 1 .956.256ZM5.82 6.144l.606.35a.7.7 0 0 1-.7 1.212l-.606-.35a.7.7 0 0 1 .7-1.212ZM8.5 4.3a.7.7 0 0 1 .7.7v.7a.7.7 0 1 1-1.4 0V5a.7.7 0 0 1 .7-.7Z",
  fill: "currentColor"
}, null, -1), n7 = [
  s7
], Q_ = /* @__PURE__ */ i({
  __name: "IconGeneralRunning",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, n7, 14, r7));
  }
}), i7 = ["stroke-width"], l7 = ["strokeWidth"], a7 = ["strokeWidth"], X_ = /* @__PURE__ */ i({
  __name: "IconGeneralSearch",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "7.5",
        cy: "7.5",
        r: "5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, l7),
      n("path", {
        d: "m10.5 10.5 4 4",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, a7)
    ], 14, i7));
  }
}), c7 = ["stroke-width"], d7 = /* @__PURE__ */ n("path", {
  d: "M2.367 2.647a.695.695 0 0 1 .924-.333l11.81 5.558a.694.694 0 0 1 0 1.257l-11.81 5.557a.694.694 0 0 1-.97-.797L3.669 8.5 2.322 3.111a.695.695 0 0 1 .045-.464Zm1.658 1.547.902 3.611H7.86c.356 0 .65.269.69.614l.004.081a.695.695 0 0 1-.694.695H4.927l-.902 3.61 9.15-4.305-9.15-4.306Z",
  fill: "currentColor"
}, null, -1), p7 = [
  d7
], Y_ = /* @__PURE__ */ i({
  __name: "IconGeneralSend",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, p7, 14, c7));
  }
}), h7 = ["stroke-width"], u7 = /* @__PURE__ */ n("path", {
  d: "M10.118 2.132a.702.702 0 0 1 .793-.208c.402.155.758.323 1.089.514.331.191.655.416.99.686a.7.7 0 0 1 .216.79 2.1 2.1 0 0 0 .143 1.788l.006.009c.317.536.85.903 1.469 1.007a.7.7 0 0 1 .577.582c.066.426.1.818.1 1.2 0 .381-.034.774-.1 1.2a.696.696 0 0 1-.291.456l-.005.004a.69.69 0 0 1-.281.122 2.098 2.098 0 0 0-1.039.505c-.168.148-.32.314-.435.513-.203.35-.285.747-.266 1.143.01.215.042.429.118.636.007.02.007.04.012.059a.617.617 0 0 1 .026.127c.003.028 0 .056 0 .084a.823.823 0 0 1-.012.11.733.733 0 0 1-.07.192l-.014.029-.016.027-.011.021c-.035.05-.08.1-.126.138-.273.23-.564.432-.866.614-.041.026-.081.055-.124.08-.057.032-.116.06-.174.09a6.9 6.9 0 0 1-.925.423c-.018.006-.038.005-.057.01a.696.696 0 0 1-.176.03l-.005.002c-.007 0-.012-.004-.018-.004a.686.686 0 0 1-.258-.057c-.016-.007-.028-.011-.043-.02a.688.688 0 0 1-.23-.172 2.105 2.105 0 0 0-.473-.41 2.085 2.085 0 0 0-1.141-.352c-.203 0-.4.039-.59.095a2.092 2.092 0 0 0-1.029.672c-.015.02-.039.028-.056.045a.666.666 0 0 1-.275.164c-.027.008-.054.013-.082.018-.042.009-.083.028-.127.028a.716.716 0 0 1-.252-.046A7.703 7.703 0 0 1 5 14.562a7.624 7.624 0 0 1-.99-.686.7.7 0 0 1-.216-.79 2.1 2.1 0 0 0-.144-1.788l-.006-.009a2.102 2.102 0 0 0-1.469-1.007A.7.7 0 0 1 1.6 9.7 7.816 7.816 0 0 1 1.5 8.5c0-.382.033-.774.099-1.2a.696.696 0 0 1 .29-.456l.006-.004a.68.68 0 0 1 .28-.122 2.097 2.097 0 0 0 1.04-.505c.167-.148.32-.314.435-.513.203-.35.284-.747.266-1.144a2.134 2.134 0 0 0-.119-.636c-.007-.019-.007-.04-.012-.058a.668.668 0 0 1-.026-.127c-.002-.028 0-.056.001-.084a.723.723 0 0 1 .032-.187.668.668 0 0 1 .05-.115c.01-.019.018-.039.03-.056.004-.007.006-.015.01-.021.036-.05.08-.1.127-.139.273-.229.563-.43.865-.614.042-.025.082-.054.125-.079.057-.032.116-.06.174-.09.297-.162.603-.306.924-.423a.67.67 0 0 1 .213-.04.694.694 0 0 1 .574.251c.133.161.293.29.461.403.341.226.737.36 1.155.36.207 0 .406-.042.6-.1a2.094 2.094 0 0 0 1.017-.669Zm.713 1.278a3.491 3.491 0 0 1-1.212.696 3.49 3.49 0 0 1-1.118.196 3.466 3.466 0 0 1-1.895-.569 3.413 3.413 0 0 1-.435-.323 5.405 5.405 0 0 0-.565.303 5.369 5.369 0 0 0-.348.225c.043.209.068.42.072.632a3.47 3.47 0 0 1-.466 1.83c-.187.324-.43.603-.702.846a3.488 3.488 0 0 1-1.235.728 5.42 5.42 0 0 0 .001 1.054 3.472 3.472 0 0 1 1.849 1.447c.027.043.062.08.087.124.434.75.57 1.623.393 2.463.286.205.591.381.913.528a3.483 3.483 0 0 1 1.211-.696 3.476 3.476 0 0 1 1.119-.196 3.47 3.47 0 0 1 1.895.569c.152.098.3.201.435.322.195-.088.381-.19.564-.302a5.37 5.37 0 0 0 .349-.225 3.475 3.475 0 0 1 .393-2.463 3.49 3.49 0 0 1 .702-.845 3.48 3.48 0 0 1 1.236-.728 5.532 5.532 0 0 0-.001-1.055 3.468 3.468 0 0 1-1.847-1.444c-.028-.044-.064-.08-.09-.126a3.483 3.483 0 0 1-.393-2.463 5.399 5.399 0 0 0-.912-.528ZM8.501 5.7c1.543 0 2.8 1.256 2.8 2.8 0 1.544-1.257 2.8-2.8 2.8a2.803 2.803 0 0 1-2.8-2.8c0-1.544 1.255-2.8 2.8-2.8Zm0 1.4c-.773 0-1.4.628-1.4 1.4 0 .772.627 1.4 1.4 1.4.771 0 1.4-.628 1.4-1.4 0-.772-.629-1.4-1.4-1.4Z",
  fill: "currentColor"
}, null, -1), f7 = [
  u7
], J_ = /* @__PURE__ */ i({
  __name: "IconGeneralSetting",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, f7, 14, h7));
  }
}), _7 = ["stroke-width"], y7 = ["strokeWidth"], w7 = ["strokeWidth"], g7 = ["strokeWidth"], v7 = ["strokeWidth"], ty = /* @__PURE__ */ i({
  __name: "IconGeneralShare",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "4.5",
        cy: "8.5",
        r: "2.667",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, y7),
      n("circle", {
        cx: "13.167",
        cy: "3.833",
        r: "2",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, w7),
      n("circle", {
        cx: "13.167",
        cy: "13.167",
        r: "2",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, g7),
      n("path", {
        d: "M6.5 7.833 11.833 4.5M6.5 9.833l5.333 3.334",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, v7)
    ], 14, _7));
  }
}), z7 = ["stroke-width"], $7 = /* @__PURE__ */ n("path", {
  d: "M4.485 3.37a.685.685 0 0 1 .014.968A5.829 5.829 0 0 0 2.87 8.41c0 3.165 2.458 5.72 5.477 5.72s5.477-2.555 5.477-5.72a5.834 5.834 0 0 0-1.537-3.973.685.685 0 1 1 1.005-.93 7.203 7.203 0 0 1 1.901 4.903c0 3.91-3.059 7.09-6.846 7.09S1.5 12.32 1.5 8.41c0-1.91.734-3.703 2.017-5.025a.685.685 0 0 1 .968-.015ZM8.346 1.5c.378 0 .685.34.685.76v5.326c0 .42-.307.76-.685.76-.378 0-.684-.34-.684-.76V2.26c0-.42.306-.761.684-.761Z",
  fill: "currentColor"
}, null, -1), m7 = [
  $7
], ey = /* @__PURE__ */ i({
  __name: "IconGeneralSwitch",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, m7, 14, z7));
  }
}), k7 = ["stroke-width"], S7 = /* @__PURE__ */ n("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "17",
  height: "17"
}, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M.5.5h16v16H.5z"
  })
], -1), x7 = { mask: "url(#a)" }, C7 = ["strokeWidth"], B7 = /* @__PURE__ */ n("path", {
  d: "M11 7a1 1 0 1 1 0-2 1 1 0 0 1 0 2Z",
  fill: "currentColor"
}, null, -1), oy = /* @__PURE__ */ i({
  __name: "IconGeneralTag",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      S7,
      n("g", x7, [
        n("path", {
          d: "M8.779 2.512a.333.333 0 0 1 .3-.091l4.322.864a.333.333 0 0 1 .261.261l.865 4.321a.334.334 0 0 1-.092.302l-6.71 6.709a.334.334 0 0 1-.47 0L2.069 9.692a.333.333 0 0 1 0-.471l6.71-6.71Z",
          stroke: "currentColor",
          strokeWidth: e.strokeWidth
        }, null, 8, C7),
        B7
      ])
    ], 14, k7));
  }
}), M7 = ["stroke-width"], Z7 = /* @__PURE__ */ n("path", {
  d: "M8.491 1.5c.382 0 .692.31.692.691v.753c1.96.336 3.457 2.139 3.457 4.236v1.757c0 .37.143.717.405.978l1.044 1.044c.385.385.5.96.29 1.465a1.34 1.34 0 0 1-1.241.83h-2.573v.172c0 1.143-.93 2.074-2.074 2.074a2.077 2.077 0 0 1-2.074-2.074v-.173H3.845a1.34 1.34 0 0 1-1.242-.83 1.339 1.339 0 0 1 .291-1.464l1.044-1.044c.261-.261.405-.608.405-.978V7.03c0-1.166.495-2.285 1.359-3.07A4.158 4.158 0 0 1 7.8 2.948v-.757c0-.381.31-.691.691-.691Zm.692 11.753H7.8v.173a.692.692 0 0 0 1.383 0v-.173ZM8.765 4.28a2.768 2.768 0 0 0-3.04 2.752v1.906c0 .739-.287 1.434-.81 1.956l-.977.977h9.107l-.978-.977a2.746 2.746 0 0 1-.81-1.956V7.18c0-1.494-1.095-2.768-2.492-2.901Z",
  fill: "currentColor"
}, null, -1), I7 = [
  Z7
], ry = /* @__PURE__ */ i({
  __name: "IconGeneralTips1",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, I7, 14, M7));
  }
}), b7 = ["stroke-width"], W7 = ["strokeWidth"], H7 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M7.992 7.25a.63.63 0 1 0 .124 1.253l.15-.021s-.362 1.92-.728 3.035c-.196.595.381 1.106 1.007 1.067l.596-.038A.615.615 0 1 0 9 11.326l-.154.026s.358-1.924.744-3.035c.212-.61-.4-1.132-1.045-1.097l-.553.03Z",
  fill: "currentColor"
}, null, -1), V7 = /* @__PURE__ */ n("path", {
  d: "M9.366 4.5a1 1 0 1 1-1.732 1 1 1 0 0 1 1.732-1Z",
  fill: "currentColor"
}, null, -1), sy = /* @__PURE__ */ i({
  __name: "IconGeneralTips",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        "clip-rule": "evenodd",
        d: "M8.5 15.166c1.84 0 3.507-.746 4.714-1.952A6.646 6.646 0 0 0 15.166 8.5c0-1.841-.746-3.508-1.952-4.714A6.646 6.646 0 0 0 8.5 1.833c-1.841 0-3.508.746-4.714 1.953A6.646 6.646 0 0 0 1.833 8.5c0 1.84.746 3.507 1.953 4.714A6.646 6.646 0 0 0 8.5 15.166Z",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth,
        "stroke-linejoin": "round"
      }, null, 8, W7),
      H7,
      V7
    ], 14, b7));
  }
}), A7 = ["stroke-width"], L7 = /* @__PURE__ */ n("path", {
  d: "M3.07 8.883a5.335 5.335 0 0 0 8.647 3.238l.104-.088.252-.218a.333.333 0 0 1 .47.034l.437.504a.334.334 0 0 1-.034.47l-.252.218A6.672 6.672 0 0 1 2.4 11.047l-.032-.063-.189.422a.333.333 0 0 1-.423.176l-.635-.242a.333.333 0 0 1-.193-.43l.002-.005.86-2.15c.242-.636 1.169-.543 1.28.128Zm4.601-7.224a6.672 6.672 0 0 1 5.932 3.62l.032.062.213-.7a.334.334 0 0 1 .438-.216l.608.232a.333.333 0 0 1 .196.422l-.877 2.491c-.242.636-1.17.544-1.281-.127a5.335 5.335 0 0 0-8.647-3.239l-.104.088-.252.218a.333.333 0 0 1-.47-.033l-.436-.504a.333.333 0 0 1 .033-.47l.252-.219A6.642 6.642 0 0 1 7.671 1.66ZM7.145 5.31l-1.863 5.05a.476.476 0 0 0 .446.64h.427a.476.476 0 0 0 .46-.356l.276-1.057h2.214l.277 1.057A.475.475 0 0 0 9.84 11h.428a.476.476 0 0 0 .445-.64L8.851 5.31A.475.475 0 0 0 8.405 5H7.59a.475.475 0 0 0-.445.31Zm1.591 3.218H7.26l.738-2.47.738 2.47Z",
  fill: "currentColor"
}, null, -1), N7 = [
  L7
], ny = /* @__PURE__ */ i({
  __name: "IconGeneralTranslation",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 16 16",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, N7, 14, A7));
  }
}), F7 = ["stroke-width"], G7 = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M3.658 1.555c-1.14 0-2.065.925-2.065 2.065v4.818c0 1.14.925 2.065 2.065 2.065H5.4l2.769 3.322c.506.608 1.328.973 2.33.56 1.002-.413 1.268-1.065.89-2.384l-.624-2.186h2.227c1.262 0 2.22-1.12 2.044-2.35l-.02-.12-.604-3.023a3.442 3.442 0 0 0-3.375-2.767h-7.38Zm6.095 11.593c-.26.096-.543-.102-.852-.594L6.41 9.566V2.932h4.626c.943 0 1.761.638 1.998 1.54l.027.12.604 3.023a.688.688 0 0 1-.674.823h-3.14a.688.688 0 0 0-.661.878l.839 2.937c.012.042.338.704-.277.895ZM5.034 9.127H3.658a.689.689 0 0 1-.684-.608l-.005-.08V3.62c0-.38.309-.688.689-.688h1.376v6.195Z",
  fill: "currentColor"
}, null, -1), D7 = [
  G7
], iy = /* @__PURE__ */ i({
  __name: "IconGeneralUnlikeLine",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, D7, 14, F7));
  }
}), E7 = ["stroke-width"], U7 = ["strokeWidth"], O7 = /* @__PURE__ */ n("path", {
  d: "M8.557 5.257a.5.5 0 0 0-.5-.5h-.5a.5.5 0 0 0-.5.5V9.25a.5.5 0 0 0 .5.5h3.993a.5.5 0 0 0 .5-.5v-.5a.5.5 0 0 0-.5-.5H8.557V5.257Z",
  fill: "currentColor"
}, null, -1), ly = /* @__PURE__ */ i({
  __name: "IconGeneralWaiting",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("circle", {
        cx: "8.502",
        cy: "8.504",
        r: "6.5",
        stroke: "currentColor",
        strokeWidth: e.strokeWidth
      }, null, 8, U7),
      O7
    ], 14, E7));
  }
}), R7 = ["stroke-width"], j7 = /* @__PURE__ */ n("path", {
  d: "M512 0a512 512 0 1 1 0 1024A512 512 0 0 1 512 0zm0 96a416 416 0 1 0 0 832 416 416 0 0 0 0-832z",
  fill: "currentColor"
}, null, -1), P7 = /* @__PURE__ */ n("path", {
  d: "M512 179.2a72.448 72.448 0 0 1 72.277 76.63l-18.09 307.455a54.272 54.272 0 0 1-108.374 0l-18.09-307.456A72.448 72.448 0 0 1 512 179.2zm0 665.6a76.8 76.8 0 1 0 0-153.6 76.8 76.8 0 0 0 0 153.6z",
  fill: "currentColor"
}, null, -1), T7 = [
  j7,
  P7
], ay = /* @__PURE__ */ i({
  __name: "IconGeneralWarningCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 1024 1024",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, T7, 14, R7));
  }
}), q7 = ["stroke-width"], K7 = /* @__PURE__ */ n("g", { "clip-path": "url(#a)" }, [
  /* @__PURE__ */ n("path", {
    d: "M9.558.75c.457.23.829.6 1.057 1.058l5.635 11.269a2.366 2.366 0 0 1-2.116 3.423H2.865A2.365 2.365 0 0 1 .75 13.077L6.384 1.808A2.365 2.365 0 0 1 9.558.75ZM7.84 2.433l-.045.08L2.16 13.782a.789.789 0 0 0 .613 1.136l.092.005h11.27a.788.788 0 0 0 .74-1.056l-.036-.085L9.205 2.513a.789.789 0 0 0-.265-.301l-.088-.051a.789.789 0 0 0-1.012.272Zm.66 8.942a1.183 1.183 0 1 1 0 2.365 1.183 1.183 0 0 1 0-2.365Zm0-5.125c.435 0 .788.353.788.788v2.366a.788.788 0 0 1-1.577 0V7.038c0-.435.353-.788.789-.788Z",
    fill: "currentColor"
  })
], -1), Q7 = /* @__PURE__ */ n("defs", null, [
  /* @__PURE__ */ n("clipPath", { id: "a" }, [
    /* @__PURE__ */ n("path", {
      fill: "currentColor",
      transform: "translate(.5 .5)",
      d: "M0 0h16v16H0z"
    })
  ])
], -1), X7 = [
  K7,
  Q7
], cy = /* @__PURE__ */ i({
  __name: "IconGeneralWarning",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, X7, 14, q7));
  }
}), Y7 = ["stroke-width"], J7 = /* @__PURE__ */ n("path", {
  d: "M13.4 1.5c1.16 0 2.1.94 2.1 2.1v9.8a2.1 2.1 0 0 1-2.1 2.1H3.6a2.1 2.1 0 0 1-2.1-2.1V3.6c0-1.16.94-2.1 2.1-2.1h9.8Zm.7 5.6H2.9v6.3a.7.7 0 0 0 .618.695l.082.005h9.8a.7.7 0 0 0 .695-.618l.005-.082V7.1Zm-.7-4.2H3.6a.7.7 0 0 0-.695.618L2.9 3.6v2.1h11.2V3.6a.7.7 0 0 0-.618-.695L13.4 2.9ZM5 3.6A.7.7 0 1 1 5 5a.7.7 0 0 1 0-1.4Zm2.1 0a.7.7 0 1 1 0 1.4.7.7 0 0 1 0-1.4Z",
  fill: "currentColor"
}, null, -1), th = [
  J7
], dy = /* @__PURE__ */ i({
  __name: "IconGeneralWeb",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, th, 14, Y7));
  }
}), eh = ["stroke-width"], oh = /* @__PURE__ */ n("mask", {
  id: "a",
  maskUnits: "userSpaceOnUse",
  x: "0",
  y: "0",
  width: "17",
  height: "17"
}, [
  /* @__PURE__ */ n("path", {
    fill: "currentColor",
    d: "M.5.5h16v16H.5z"
  })
], -1), rh = /* @__PURE__ */ n("g", { mask: "url(#a)" }, [
  /* @__PURE__ */ n("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M5.67 2.557a5.738 5.738 0 1 1 .644 8.672L5.273 12.27l1.873 1.874a.5.5 0 0 1 0 .707l-.495.495a.5.5 0 0 1-.707 0l-1.873-1.873-1.56 1.559a.5.5 0 0 1-.706 0l-.495-.495a.5.5 0 0 1 0-.708l1.559-1.559-1.874-1.873a.5.5 0 0 1 0-.707l.495-.495a.5.5 0 0 1 .708 0l1.873 1.873 1.041-1.041a5.74 5.74 0 0 1 .557-7.47Zm6.912 1.202a4.038 4.038 0 1 0-5.71 5.711 4.038 4.038 0 0 0 5.71-5.71Z",
    fill: "currentColor"
  })
], -1), sh = [
  oh,
  rh
], py = /* @__PURE__ */ i({
  __name: "IconGeneralWoman",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, sh, 14, eh));
  }
}), nh = ["stroke-width"], ih = /* @__PURE__ */ n("path", {
  d: "M14.48 12.353a.327.327 0 0 0 .518-.263V4.91a.324.324 0 0 0-.351-.324.327.327 0 0 0-.167.06l-4.988 3.59a.325.325 0 0 0 0 .528l4.988 3.59ZM7.124 12.353a.326.326 0 0 0 .517-.263V4.91a.324.324 0 0 0-.351-.324.327.327 0 0 0-.166.06l-4.989 3.59a.325.325 0 0 0 0 .528l4.989 3.59Z",
  fill: "currentColor"
}, null, -1), lh = [
  ih
], hy = /* @__PURE__ */ i({
  __name: "IconMediaBackFast",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, lh, 14, nh));
  }
}), ah = ["stroke-width"], ch = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M5.524 2.96a.833.833 0 0 1 .746-.46h4.46c.316 0 .605.178.746.46l.436.873h2.255a1 1 0 0 1 1 1V13.5a1 1 0 0 1-1 1H2.833a1 1 0 0 1-1-1V4.833a1 1 0 0 1 1-1h2.255l.436-.872ZM3.167 5.168v8h10.666v-8H3.168ZM8.5 7.5a1.667 1.667 0 1 0 0 3.333 1.667 1.667 0 0 0 0-3.333Zm-3 1.667a3 3 0 1 1 6 0 3 3 0 0 1-6 0Z",
  fill: "currentColor"
}, null, -1), dh = [
  ch
], uy = /* @__PURE__ */ i({
  __name: "IconMediaCamera",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, dh, 14, ah));
  }
}), ph = ["stroke-width"], hh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.462 9.809c.038.092.038.208.038.441v4.5c0 .233 0 .35-.038.441a.5.5 0 0 1-.27.27c-.092.039-.209.039-.442.039h-4.5c-.233 0-.35 0-.441-.038a.5.5 0 0 1-.27-.27C9.5 15.1 9.5 14.982 9.5 14.75s0-.35.038-.441a.5.5 0 0 1 .27-.27c.093-.039.209-.039.442-.039H14v-3.75c0-.233 0-.35.038-.441a.5.5 0 0 1 .27-.27c.092-.039.209-.039.442-.039s.35 0 .441.038a.5.5 0 0 1 .27.27ZM1.5 6.75c0 .233 0 .35.038.441a.5.5 0 0 0 .27.27c.093.039.209.039.442.039s.35 0 .441-.038a.5.5 0 0 0 .27-.27C3 7.098 3 6.982 3 6.75V3h3.75c.233 0 .35 0 .441-.038a.5.5 0 0 0 .27-.27c.039-.093.039-.209.039-.442s0-.35-.038-.441a.5.5 0 0 0-.27-.27C7.098 1.5 6.982 1.5 6.75 1.5h-4.5c-.233 0-.35 0-.441.038a.5.5 0 0 0-.27.27c-.039.093-.039.209-.039.442v4.5Z",
  fill: "currentColor"
}, null, -1), uh = [
  hh
], fy = /* @__PURE__ */ i({
  __name: "IconMediaExpand",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, uh, 14, ph));
  }
}), fh = ["stroke-width"], _h = /* @__PURE__ */ n("path", {
  d: "M2.52 4.647a.327.327 0 0 0-.517.263v7.18a.324.324 0 0 0 .351.324.326.326 0 0 0 .166-.06l4.988-3.59a.325.325 0 0 0 0-.528L2.52 4.646ZM9.877 4.647a.327.327 0 0 0-.517.263v7.18a.324.324 0 0 0 .351.324.326.326 0 0 0 .166-.06l4.989-3.59a.326.326 0 0 0 .1-.412.326.326 0 0 0-.1-.116l-4.989-3.59Z",
  fill: "currentColor"
}, null, -1), yh = [
  _h
], _y = /* @__PURE__ */ i({
  __name: "IconMediaFastForward",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, yh, 14, fh));
  }
}), wh = ["stroke-width"], gh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "m14.335 1.506-.133-.006H5.906l-.133.006a1.297 1.297 0 0 0-1.164 1.29v1.815H2.796l-.132.007A1.297 1.297 0 0 0 1.5 5.908v8.296l.006.133a1.296 1.296 0 0 0 1.29 1.163h8.297l.132-.006a1.296 1.296 0 0 0 1.164-1.29v-1.815h1.813l.133-.006a1.296 1.296 0 0 0 1.163-1.29V2.796l-.006-.132a1.296 1.296 0 0 0-1.157-1.158Zm-1.946 9.327h1.554V3.056H6.165V4.61h4.928l.132.007a1.296 1.296 0 0 1 1.164 1.29v4.925Zm-9.334 3.11h7.777V6.167H3.055v7.778Z",
  fill: "currentColor"
}, null, -1), vh = /* @__PURE__ */ n("path", {
  d: "M6.308 7.775c.26-.286.745-.36 1.114-.17.368.19.495.58.291.895l-.066.086-.661.73h1.68c.296 0 .57.128.719.336.15.209.154.467.01.678l-.066.08-1.688 1.818c-.263.286-.752.357-1.119.162-.367-.195-.487-.59-.275-.902l.067-.085.673-.724H5.333c-.293 0-.565-.126-.716-.332a.576.576 0 0 1-.017-.673l.957-1.088.751-.81Z",
  fill: "currentColor"
}, null, -1), zh = [
  gh,
  vh
], yy = /* @__PURE__ */ i({
  __name: "IconMediaLightningCopy",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, zh, 14, wh));
  }
}), $h = ["stroke-width"], mh = /* @__PURE__ */ n("path", {
  d: "M4.16 3.578a.417.417 0 0 0-.66.337v9.17a.414.414 0 0 0 .448.414.417.417 0 0 0 .212-.078l6.372-4.585a.416.416 0 0 0 .127-.526.416.416 0 0 0-.127-.147L4.16 3.578Z",
  fill: "currentColor"
}, null, -1), kh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.25 13.482a.418.418 0 0 1-.417-.416V3.933a.415.415 0 0 1 .417-.415h.833a.417.417 0 0 1 .417.415v9.133a.415.415 0 0 1-.417.416h-.833Z",
  fill: "currentColor"
}, null, -1), Sh = [
  mh,
  kh
], wy = /* @__PURE__ */ i({
  __name: "IconMediaNext",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Sh, 14, $h));
  }
}), xh = ["stroke-width"], Ch = /* @__PURE__ */ n("path", {
  d: "M8.5 1.5a7 7 0 1 1-.002 14.002A7 7 0 0 1 8.5 1.5Zm0 1.4a5.607 5.607 0 0 0-5.6 5.6c0 3.088 2.512 5.6 5.6 5.6 3.088 0 5.6-2.512 5.6-5.6 0-3.088-2.512-5.6-5.6-5.6ZM7.1 5.7a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.618.695L7.1 11.3a.7.7 0 0 1-.7-.7V6.4a.7.7 0 0 1 .7-.7Zm2.8 0a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.618.695L9.9 11.3a.7.7 0 0 1-.7-.7V6.4a.7.7 0 0 1 .7-.7Z",
  fill: "currentColor"
}, null, -1), Bh = [
  Ch
], gy = /* @__PURE__ */ i({
  __name: "IconMediaPauseCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Bh, 14, xh));
  }
}), Mh = ["stroke-width"], Zh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 8.5a7 7 0 1 0-14.002.002A7 7 0 0 0 15.5 8.5ZM7.1 5.7a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.618.695L7.1 11.3a.7.7 0 0 1-.7-.7V6.4a.7.7 0 0 1 .7-.7Zm2.8 0a.7.7 0 0 1 .7.7v4.2a.7.7 0 0 1-.618.695L9.9 11.3a.7.7 0 0 1-.7-.7V6.4a.7.7 0 0 1 .7-.7Z",
  fill: "currentColor"
}, null, -1), Ih = [
  Zh
], vy = /* @__PURE__ */ i({
  __name: "IconMediaPauseFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Ih, 14, Mh));
  }
}), bh = ["stroke-width"], Wh = /* @__PURE__ */ n("path", {
  d: "M8.5 1.5a7 7 0 1 1-.002 14.002A7 7 0 0 1 8.5 1.5Zm0 1.4a5.607 5.607 0 0 0-5.6 5.6c0 3.088 2.512 5.6 5.6 5.6 3.088 0 5.6-2.512 5.6-5.6 0-3.088-2.512-5.6-5.6-5.6Z",
  fill: "currentColor"
}, null, -1), Hh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M6.75 6.383a.5.5 0 0 1 .757-.429l3.528 2.117a.5.5 0 0 1 0 .858l-3.528 2.117a.5.5 0 0 1-.757-.43V6.384Z",
  fill: "currentColor"
}, null, -1), Vh = [
  Wh,
  Hh
], zy = /* @__PURE__ */ i({
  __name: "IconMediaPlayCircle",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Vh, 14, bh));
  }
}), Ah = ["stroke-width"], Lh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M15.5 8.5a7 7 0 1 0-14.002.002A7 7 0 0 0 15.5 8.5ZM7.507 5.954a.5.5 0 0 0-.757.43v4.233a.5.5 0 0 0 .757.429l3.528-2.117a.5.5 0 0 0 0-.858L7.507 5.954Z",
  fill: "currentColor"
}, null, -1), Nh = [
  Lh
], $y = /* @__PURE__ */ i({
  __name: "IconMediaPlayFill",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Nh, 14, Ah));
  }
}), Fh = ["stroke-width"], Gh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4 3.322a1 1 0 0 1 1.537-.844l8.137 5.178a1 1 0 0 1 0 1.688l-8.137 5.178A1 1 0 0 1 4 13.678V3.322Z",
  fill: "currentColor"
}, null, -1), Dh = [
  Gh
], my = /* @__PURE__ */ i({
  __name: "IconMediaPlay",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Dh, 14, Fh));
  }
}), Eh = ["stroke-width"], Uh = /* @__PURE__ */ n("path", {
  d: "M12.84 3.578a.418.418 0 0 1 .66.337v9.17a.414.414 0 0 1-.448.414.418.418 0 0 1-.212-.078L6.468 8.837a.416.416 0 0 1 0-.673l6.372-4.585Z",
  fill: "currentColor"
}, null, -1), Oh = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M4.75 13.482a.418.418 0 0 0 .417-.416V3.933a.414.414 0 0 0-.417-.415h-.833a.417.417 0 0 0-.417.415v9.133a.415.415 0 0 0 .417.416h.833Z",
  fill: "currentColor"
}, null, -1), Rh = [
  Uh,
  Oh
], ky = /* @__PURE__ */ i({
  __name: "IconMediaPrevious",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Rh, 14, Eh));
  }
}), jh = ["stroke-width"], Ph = /* @__PURE__ */ n("path", {
  d: "M8.5 1.5a7 7 0 1 1-.002 14.002A7 7 0 0 1 8.5 1.5Zm0 1.4a5.607 5.607 0 0 0-5.6 5.6c0 3.088 2.512 5.6 5.6 5.6 3.088 0 5.6-2.512 5.6-5.6 0-3.088-2.512-5.6-5.6-5.6Z",
  fill: "currentColor"
}, null, -1), Th = /* @__PURE__ */ n("rect", {
  x: "6.5",
  y: "6.5",
  width: "4",
  height: "4",
  rx: ".5",
  fill: "currentColor"
}, null, -1), qh = [
  Ph,
  Th
], Sy = /* @__PURE__ */ i({
  __name: "IconMediaRecorderPause",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, qh, 14, jh));
  }
}), Kh = ["stroke-width"], Qh = /* @__PURE__ */ n("path", {
  d: "M8.5 1.5a7 7 0 1 1-.002 14.002A7 7 0 0 1 8.5 1.5Zm0 1.4a5.607 5.607 0 0 0-5.6 5.6c0 3.088 2.512 5.6 5.6 5.6 3.088 0 5.6-2.512 5.6-5.6 0-3.088-2.512-5.6-5.6-5.6Z",
  fill: "currentColor"
}, null, -1), Xh = /* @__PURE__ */ n("circle", {
  cx: "8.5",
  cy: "8.5",
  r: "2",
  fill: "currentColor"
}, null, -1), Yh = [
  Qh,
  Xh
], xy = /* @__PURE__ */ i({
  __name: "IconMediaRecorder",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, Yh, 14, Kh));
  }
}), Jh = ["stroke-width"], tu = /* @__PURE__ */ n("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M9.5 10.005a.5.5 0 0 1 .5-.5h5.004a.5.5 0 0 1 .5.5v.5a.5.5 0 0 1-.5.5L11 11.004V15a.5.5 0 0 1-.5.5H10a.5.5 0 0 1-.5-.5v-4.995ZM7.503 7a.5.5 0 0 1-.5.5H2a.5.5 0 0 1-.5-.5v-.5A.5.5 0 0 1 2 6l4.003.001V2.005a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5V7Z",
  fill: "currentColor"
}, null, -1), eu = [
  tu
], Cy = /* @__PURE__ */ i({
  __name: "IconMediaUnexpand",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      viewBox: "0 0 17 17",
      fill: "currentColor",
      xmlns: "http://www.w3.org/2000/svg",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, eu, 14, Jh));
  }
}), ou = ["stroke-width"], ru = ["strokeWidth"], By = /* @__PURE__ */ i({
  __name: "IconYuuuDownArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M11.5 10.5 7.75 14 4 10.5M7.75 2v12"
      }, null, 8, ru)
    ], 14, ou));
  }
}), su = ["stroke-width"], nu = ["strokeWidth"], My = /* @__PURE__ */ i({
  __name: "IconYuuuLeftArrow",
  props: {
    size: {
      type: String,
      default: ""
    },
    spin: {
      type: Boolean,
      default: !1
    },
    color: { type: String, default: "" },
    rotate: {
      type: Number
    },
    "stroke-width": {
      type: String,
      default: "1.5"
    }
  },
  setup(o) {
    const t = o, r = l(() => {
      let e = "";
      return t.size && (e += `font-size:${typeof t.size == "number" ? `${t.size}px` : t.size};`), t.color && (e += `color:${t.color};`), t.rotate && (e += `transform:rotate(${t.rotate}deg);`), e;
    });
    return (e, s) => (a(), c("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 16 16",
      class: d(["icon-wrapper", o.spin ? "noah-icon-spin" : ""]),
      style: p(h(r)),
      "stroke-width": e.strokeWidth
    }, [
      n("path", {
        stroke: "currentColor",
        "stroke-linecap": "round",
        "stroke-linejoin": "round",
        strokeWidth: e.strokeWidth,
        d: "M5.5 11.5 2 7.75 5.5 4M14 7.75H2"
      }, null, 8, nu)
    ], 14, su));
  }
}), _ = [], Zy = (o) => {
  const { src: t } = o;
  if ((t == null ? void 0 : t.length) && !_.includes(t)) {
    const r = document.createElement("script");
    r.setAttribute("src", t), r.setAttribute("data-namespace", t), _.push(t), document.body.appendChild(r);
  }
  return i({
    name: "IconFont",
    props: {
      type: {
        type: String
      },
      size: {
        type: String,
        default: "16px"
      },
      width: {
        type: [String, Number]
      },
      height: {
        type: [String, Number]
      },
      spin: {
        type: Boolean,
        default: !1
      },
      color: { type: String, default: "" },
      rotate: {
        type: Number
      },
      "stroke-width": {
        type: String
      }
    },
    setup(r) {
      const e = l(() => {
        let s = "";
        return r.size && (s += `width:${r.size};`), r.color && (s += `fill:${r.color};`), r.rotate && (s += `transform:rotate(${r.rotate}deg);`), s;
      });
      return () => f(
        "svg",
        {
          "aria-hidden": !0,
          class: `noah-font-wrapper ${r.spin ? "noah-icon-spin" : ""}`,
          style: e.value
        },
        f("use", {
          "xlink:href": `#${r.type}`
        })
      );
    }
  });
};
export {
  lu as IconColourActiveNormal,
  au as IconColourAscendActive,
  cu as IconColourCardActive,
  du as IconColourCardNormal,
  pu as IconColourConfigActive,
  hu as IconColourConfigNormal,
  uu as IconColourCopy,
  fu as IconColourDescendActive,
  _u as IconColourDrag,
  yu as IconColourEnterActive,
  wu as IconColourEnterNormal,
  gu as IconColourError,
  vu as IconColourFolder,
  $u as IconColourFootballActive,
  mu as IconColourFootballNormal,
  zu as IconColourFootball_normal,
  ku as IconColourGiftActive,
  Su as IconColourGiftNormal,
  xu as IconColourGoodsActive,
  Cu as IconColourGoodsNormal,
  Bu as IconColourIconDown,
  Mu as IconColourIconMinus,
  Zu as IconColourIconUp,
  Iu as IconColourKim,
  bu as IconColourManageActive,
  Wu as IconColourManageNormal,
  Hu as IconColourMonitorActive,
  Vu as IconColourMonitorNormal,
  Au as IconColourMoredetails,
  Lu as IconColourMusicActive,
  Nu as IconColourMusicNormal,
  Fu as IconColourOrderNormal,
  Gu as IconColourPageActive,
  Du as IconColourPageNormal,
  Eu as IconColourPieActive,
  Uu as IconColourPieNormal,
  Ou as IconColourPlay,
  Ru as IconColourQuitActive,
  ju as IconColourQuitNormal,
  Pu as IconColourReviewActive,
  Tu as IconColourSuccess,
  qu as IconColourTargetActive,
  Ku as IconColourTargetNormal,
  Qu as IconColourTishi,
  Xu as IconColourToolsActive,
  Yu as IconColourToolsNormal,
  Ju as IconColourUserActive,
  t6 as IconColourUserNormal,
  e6 as IconColourUserVerify,
  o6 as IconColourVideoActive,
  r6 as IconColourVideoNormal,
  n6 as IconColourXing,
  s6 as IconColourXingGray,
  i6 as IconCursorArrowMenu,
  l6 as IconCursorBeamHorizontal,
  a6 as IconCursorBeamVertical,
  c6 as IconCursorCell,
  d6 as IconCursorClose,
  p6 as IconCursorCopy,
  h6 as IconCursorCross,
  u6 as IconCursorDefault,
  f6 as IconCursorDisabled,
  _6 as IconCursorGrip,
  y6 as IconCursorGripping,
  w6 as IconCursorHelp,
  g6 as IconCursorLoading,
  b6 as IconCursorMove,
  v6 as IconCursorMoveDown,
  k6 as IconCursorMoveLeft,
  z6 as IconCursorMoveLeftDown,
  $6 as IconCursorMoveLeftRight,
  m6 as IconCursorMoveLeftUp,
  C6 as IconCursorMoveRight,
  S6 as IconCursorMoveRightDown,
  x6 as IconCursorMoveRightUp,
  I6 as IconCursorMoveUp,
  B6 as IconCursorMoveUpDown,
  M6 as IconCursorMoveUpLeftDownRight,
  Z6 as IconCursorMoveUpRightDownLeft,
  W6 as IconCursorPointing,
  H6 as IconCursorResizeDown,
  A6 as IconCursorResizeLeft,
  V6 as IconCursorResizeLeftRight,
  L6 as IconCursorResizeRight,
  F6 as IconCursorResizeUp,
  N6 as IconCursorResizeUpDown,
  G6 as IconCursorScreenshotSelect,
  D6 as IconCursorScreenshotShot,
  E6 as IconCursorShortcuts,
  U6 as IconCursorZoomIn,
  O6 as IconCursorZoomOut,
  R6 as IconDataAssetsList,
  j6 as IconDataBackup,
  P6 as IconDataBarChart,
  T6 as IconDataBarData,
  q6 as IconDataCloudDownload,
  K6 as IconDataCloudUpload,
  Q6 as IconDataColumnChart,
  X6 as IconDataDataInsert,
  Y6 as IconDataDesign,
  J6 as IconDataFlowline,
  t8 as IconDataFoldingLineChart,
  e8 as IconDataLineData,
  o8 as IconDataMachineReview,
  r8 as IconDataMultiServer,
  s8 as IconDataPeopleReview,
  n8 as IconDataPieChart,
  i8 as IconDataPopData,
  l8 as IconDataServer,
  a8 as IconDataWeb,
  c8 as IconDataWorkbench,
  d8 as IconDirectionAscendingOrder,
  p8 as IconDirectionBackToBottom,
  h8 as IconDirectionBackToRight,
  u8 as IconDirectionBackToUp,
  f8 as IconDirectionDescendingOrder,
  v8 as IconDirectionDown,
  _8 as IconDirectionDownArrow,
  y8 as IconDirectionDownCircle,
  w8 as IconDirectionDownFill,
  g8 as IconDirectionDownLineCircle,
  z8 as IconDirectionExchange,
  $8 as IconDirectionExpand,
  C8 as IconDirectionLeft,
  m8 as IconDirectionLeftArrow,
  k8 as IconDirectionLeftCircle,
  S8 as IconDirectionLeftDoubleArrow,
  x8 as IconDirectionLeftFill,
  B8 as IconDirectionLogout,
  M8 as IconDirectionMenuFold,
  Z8 as IconDirectionMenuUnfold,
  I8 as IconDirectionNext,
  W8 as IconDirectionOrder,
  b8 as IconDirectionOrderArrow,
  H8 as IconDirectionPrevious,
  F8 as IconDirectionRight,
  V8 as IconDirectionRightArrow,
  A8 as IconDirectionRightCircle,
  L8 as IconDirectionRightDoubleArrow,
  N8 as IconDirectionRightFill,
  G8 as IconDirectionShrink,
  D8 as IconDirectionSkipNextFill,
  E8 as IconDirectionSkipPreviousFill,
  U8 as IconDirectionUnexpand,
  q8 as IconDirectionUp,
  O8 as IconDirectionUpArrow,
  R8 as IconDirectionUpCircle,
  j8 as IconDirectionUpDownFill,
  P8 as IconDirectionUpFill,
  T8 as IconDirectionUpLineCircle,
  K8 as IconEditorAlignCenter,
  X8 as IconEditorAlignLeft,
  Q8 as IconEditorAlignLeft1,
  Y8 as IconEditorAlignRight,
  J8 as IconEditorArchive,
  tf as IconEditorAscendingOrder,
  ef as IconEditorAsendSort,
  of as IconEditorBackgroundColor,
  rf as IconEditorBatchAdjust,
  sf as IconEditorBold,
  nf as IconEditorBorders,
  lf as IconEditorBottomBorder,
  af as IconEditorBulb,
  cf as IconEditorCalender,
  df as IconEditorCatalogue,
  pf as IconEditorCheckbox,
  hf as IconEditorClearBorders,
  uf as IconEditorCodeSquare,
  ff as IconEditorCondition,
  _f as IconEditorCopy,
  yf as IconEditorCut,
  gf as IconEditorData,
  wf as IconEditorDataCheck,
  vf as IconEditorDedent,
  zf as IconEditorDescendingOrder,
  $f as IconEditorDivider,
  mf as IconEditorEdit,
  kf as IconEditorEnter,
  Sf as IconEditorEraser,
  xf as IconEditorExpand,
  Bf as IconEditorEye,
  Cf as IconEditorEyeInvisible,
  Mf as IconEditorFlowchart,
  Zf as IconEditorFolder,
  If as IconEditorFontColor,
  bf as IconEditorFormatPainter,
  Wf as IconEditorFormula,
  Hf as IconEditorFreezeColumn,
  Vf as IconEditorFreezeColumns,
  Af as IconEditorFreezeRow,
  Lf as IconEditorHeader,
  Nf as IconEditorImage,
  Ff as IconEditorIndent,
  Gf as IconEditorInnerBorders,
  Df as IconEditorInputDrag,
  Uf as IconEditorItalic,
  Ef as IconEditorItalicHeader,
  Of as IconEditorKeyboard,
  Rf as IconEditorLab,
  jf as IconEditorLeftBorder,
  Pf as IconEditorLineHeight,
  Tf as IconEditorLink,
  qf as IconEditorListSearch,
  Kf as IconEditorMergeCells,
  Qf as IconEditorMindMap,
  Xf as IconEditorMoney,
  Yf as IconEditorNotificaiton,
  Jf as IconEditorOrderedList,
  t9 as IconEditorOuterBorders,
  e9 as IconEditorOveflow,
  o9 as IconEditorPageBreak,
  r9 as IconEditorPageHeadFoot,
  s9 as IconEditorPageNumber,
  n9 as IconEditorPrimaryHeader,
  i9 as IconEditorRedo,
  l9 as IconEditorRightBorder,
  a9 as IconEditorSecondHeader,
  c9 as IconEditorSplitCells,
  d9 as IconEditorStrikethrough,
  p9 as IconEditorSubscript,
  h9 as IconEditorSuperscript,
  u9 as IconEditorSwitchSheet,
  f9 as IconEditorThirdHeader,
  _9 as IconEditorTopBorder,
  y9 as IconEditorTruncation,
  w9 as IconEditorUnderline,
  g9 as IconEditorUndo,
  v9 as IconEditorUnexpand,
  z9 as IconEditorUnlink,
  $9 as IconEditorUnorderedList,
  m9 as IconEditorVerticalAlignBottom,
  k9 as IconEditorVerticalAlignMiddle,
  S9 as IconEditorVerticalAlignTop,
  x9 as IconFillAdd,
  C9 as IconFillBackToTop,
  B9 as IconFillClear,
  Z9 as IconFillCollect,
  M9 as IconFillCollectFlag,
  I9 as IconFillDelete,
  b9 as IconFillDislike,
  W9 as IconFillFinish,
  H9 as IconFillFolder,
  V9 as IconFillInfo,
  A9 as IconFillLike,
  L9 as IconFillPause,
  N9 as IconFillPin,
  F9 as IconFillPlay,
  G9 as IconFillQuiet,
  D9 as IconFillRunning,
  E9 as IconFillVoice,
  U9 as IconFillWaiting,
  O9 as IconFillWarning,
  R9 as IconFunctionKim,
  j9 as IconFunctionPauseCircle,
  P9 as IconGeneralAddBold,
  T9 as IconGeneralAddCircle,
  q9 as IconGeneralAddItem,
  K9 as IconGeneralAddSqual,
  Q9 as IconGeneralAlarm,
  X9 as IconGeneralArrowOrder,
  Y9 as IconGeneralCalendarClock,
  J9 as IconGeneralCalender,
  t_ as IconGeneralChildtag,
  e_ as IconGeneralChinese,
  r_ as IconGeneralClose,
  o_ as IconGeneralCloseCircle,
  n_ as IconGeneralCollect,
  s_ as IconGeneralCollectFlag,
  i_ as IconGeneralCopy,
  l_ as IconGeneralCorrect,
  a_ as IconGeneralDelete,
  c_ as IconGeneralDialog,
  d_ as IconGeneralDirectionRighSmall,
  p_ as IconGeneralDownload,
  h_ as IconGeneralDrag,
  u_ as IconGeneralEdit,
  f_ as IconGeneralEnglish,
  __ as IconGeneralExchange,
  w_ as IconGeneralEye,
  y_ as IconGeneralEyeInvisible,
  g_ as IconGeneralFathertag,
  v_ as IconGeneralFilter,
  z_ as IconGeneralFinish,
  $_ as IconGeneralFolder,
  m_ as IconGeneralGift,
  k_ as IconGeneralGlobal,
  S_ as IconGeneralImage,
  x_ as IconGeneralKim,
  C_ as IconGeneralLightningCopy,
  M_ as IconGeneralLike,
  Z_ as IconGeneralLike1,
  B_ as IconGeneralLikeLine,
  I_ as IconGeneralList,
  b_ as IconGeneralLock,
  W_ as IconGeneralLogout,
  H_ as IconGeneralMan,
  V_ as IconGeneralMessage,
  A_ as IconGeneralMiniProgram,
  L_ as IconGeneralMinusItem,
  N_ as IconGeneralMore,
  F_ as IconGeneralNext,
  G_ as IconGeneralPaperclip,
  D_ as IconGeneralPin,
  E_ as IconGeneralPlaceholder,
  U_ as IconGeneralPlay,
  O_ as IconGeneralPosition,
  R_ as IconGeneralPrevious,
  j_ as IconGeneralPrinter,
  P_ as IconGeneralProduct,
  T_ as IconGeneralQuestion,
  q_ as IconGeneralReduceCircle,
  K_ as IconGeneralRefresh,
  Q_ as IconGeneralRunning,
  X_ as IconGeneralSearch,
  Y_ as IconGeneralSend,
  J_ as IconGeneralSetting,
  ty as IconGeneralShare,
  ey as IconGeneralSwitch,
  oy as IconGeneralTag,
  sy as IconGeneralTips,
  ry as IconGeneralTips1,
  ny as IconGeneralTranslation,
  iy as IconGeneralUnlikeLine,
  ly as IconGeneralWaiting,
  cy as IconGeneralWarning,
  ay as IconGeneralWarningCircle,
  dy as IconGeneralWeb,
  py as IconGeneralWoman,
  hy as IconMediaBackFast,
  uy as IconMediaCamera,
  fy as IconMediaExpand,
  _y as IconMediaFastForward,
  yy as IconMediaLightningCopy,
  wy as IconMediaNext,
  gy as IconMediaPauseCircle,
  vy as IconMediaPauseFill,
  my as IconMediaPlay,
  zy as IconMediaPlayCircle,
  $y as IconMediaPlayFill,
  ky as IconMediaPrevious,
  xy as IconMediaRecorder,
  Sy as IconMediaRecorderPause,
  Cy as IconMediaUnexpand,
  By as IconYuuuDownArrow,
  My as IconYuuuLeftArrow,
  Zy as createFromIconfont
};
